// $fmt — one source for the browser (static.ts prepends it to island-runtime.js) and the server
// (engine/fmt.ts evaluates it in a vm), so it stays a plain ES5 function declaration with no globals.
function rtCreateFmt(locale, timeZone) {
  var L = locale || 'es-PE'
  var TZ = timeZone || 'UTC'
  var MONEY = new Intl.NumberFormat('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  var DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/
  var cache = {}
  function dtf(key, opts, utc) {
    var k = key + (utc ? '|utc' : '')
    if (!cache[k]) {
      var o = { timeZone: utc ? 'UTC' : TZ }
      for (var p in opts) o[p] = opts[p]
      cache[k] = new Intl.DateTimeFormat(L, o)
    }
    return cache[k]
  }
  // A bare YYYY-MM-DD is a calendar day, never shifted by the zone.
  function read(d) {
    if (d == null || d === '') return null
    var utc = typeof d === 'string' && DATE_ONLY.test(d)
    var x = typeof d === 'object' && typeof d.getTime === 'function' ? new Date(d.getTime()) : new Date(d)
    return isNaN(x.getTime()) ? null : { at: x, utc: utc }
  }
  function money(n) { var v = Number(n) || 0; return (v < 0 ? '-' : '') + 'S/ ' + MONEY.format(Math.abs(v)) }
  function number(n, digits) {
    var v = Number(n) || 0
    var k = 'n' + (digits == null ? '' : digits)
    if (!cache[k]) cache[k] = new Intl.NumberFormat(L, digits == null ? {} : { minimumFractionDigits: digits, maximumFractionDigits: digits })
    return cache[k].format(v)
  }
  function date(d, style) {
    var r = read(d); if (!r) return ''
    return style === 'long'
      ? dtf('dl', { day: 'numeric', month: 'long', year: 'numeric' }, r.utc).format(r.at)
      : dtf('ds', { day: '2-digit', month: '2-digit', year: 'numeric' }, r.utc).format(r.at)
  }
  function time(d) {
    var r = read(d); if (!r) return ''
    return dtf('t', { hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }, false).format(r.at)
  }
  function datetime(d) { var r = read(d); return r ? date(r.at) + ' ' + time(r.at) : '' }
  function day(d) {
    var r = read(d); if (!r) return ''
    var parts = dtf('dd', { weekday: 'short', day: 'numeric', month: 'short' }, r.utc).formatToParts(r.at)
    var out = { weekday: '', day: '', month: '' }
    for (var i = 0; i < parts.length; i++) if (out[parts[i].type] === '') out[parts[i].type] = parts[i].value.replace(/\./g, '')
    return out.weekday + ' ' + out.day + ' ' + out.month
  }
  var UNITS = [['year', 31536000], ['month', 2592000], ['week', 604800], ['day', 86400], ['hour', 3600], ['minute', 60], ['second', 1]]
  function relative(d, now) {
    var r = read(d); if (!r) return ''
    var base = now == null ? Date.now() : new Date(now).getTime()
    var s = Math.round((r.at.getTime() - base) / 1000)
    if (!cache.rel) cache.rel = new Intl.RelativeTimeFormat(L, { style: 'short', numeric: 'auto' })
    for (var i = 0; i < UNITS.length - 1; i++) {
      if (Math.abs(s) >= UNITS[i][1]) return cache.rel.format(Math.round(s / UNITS[i][1]), UNITS[i][0])
    }
    return cache.rel.format(s, 'second')
  }
  return { locale: L, tz: TZ, money: money, number: number, date: date, time: time, datetime: datetime, day: day, relative: relative }
}

// $t — `catalog` is a flat key → message map (fallbacks merged by the caller). `{p}` interpolates a param;
// `{n, plural, =0 {…} one {…} other {…}}` picks a branch by Intl.PluralRules, `#` in it is n. A missing key is the key.
function rtCreateT(catalog, locale) {
  var cat = catalog || {}
  var rules = null
  try { rules = new Intl.PluralRules(locale || 'es-PE') } catch (_) { rules = null }
  function close(s, i) {
    var depth = 0
    for (var j = i; j < s.length; j++) {
      var c = s.charAt(j)
      if (c === '{') depth++
      else if (c === '}' && --depth === 0) return j
    }
    return -1
  }
  function plural(n, spec, params) {
    var branches = {}, i = 0
    while (i < spec.length) {
      var open = spec.indexOf('{', i)
      if (open < 0) break
      var sel = spec.slice(i, open).trim()
      var end = close(spec, open)
      if (end < 0) break
      branches[sel] = spec.slice(open + 1, end)
      i = end + 1
    }
    var pick = branches['=' + n]
    if (pick == null && rules && isFinite(n)) pick = branches[rules.select(n)]
    if (pick == null) pick = branches.other
    return pick == null ? '' : format(pick.replace(/#/g, String(n)), params)
  }
  function arg(body, params) {
    var m = /^\s*([\w.]+)\s*(?:,\s*plural\s*,([\s\S]*))?$/.exec(body)
    if (!m) return '{' + body + '}'
    var v = params ? params[m[1]] : undefined
    if (m[2] != null) return plural(Number(v), m[2], params)
    return v == null ? '{' + m[1] + '}' : String(v)
  }
  function format(msg, params) {
    var out = '', i = 0
    while (i < msg.length) {
      var c = msg.charAt(i)
      if (c !== '{') { out += c; i++; continue }
      var end = close(msg, i)
      if (end < 0) { out += msg.slice(i); break }
      out += arg(msg.slice(i + 1, end), params)
      i = end + 1
    }
    return out
  }
  return function t(key, params) {
    var msg = Object.prototype.hasOwnProperty.call(cat, key) ? cat[key] : null
    return typeof msg === 'string' ? format(msg, params) : String(key)
  }
}
;
// v-html sanitiser — one source for the browser (static.ts prepends it to island-runtime.js) and the server
// (engine/sanitize.ts evaluates it in a vm): a string allowlist re-serialiser, no DOM, so both sides emit the same bytes.
function rtSanitizeHtml(input) {
  var html = input == null ? '' : String(input)
  var VOID = { br: 1, hr: 1, img: 1, col: 1, wbr: 1 }
  var TAGS = {
    p: 1, br: 1, hr: 1, b: 1, strong: 1, i: 1, em: 1, u: 1, s: 1, strike: 1, del: 1, ins: 1, mark: 1, small: 1,
    sub: 1, sup: 1, code: 1, pre: 1, kbd: 1, samp: 1, blockquote: 1, q: 1, cite: 1, abbr: 1, span: 1, div: 1,
    h1: 1, h2: 1, h3: 1, h4: 1, h5: 1, h6: 1, ul: 1, ol: 1, li: 1, dl: 1, dt: 1, dd: 1, a: 1, img: 1, wbr: 1,
    table: 1, caption: 1, colgroup: 1, col: 1, thead: 1, tbody: 1, tfoot: 1, tr: 1, td: 1, th: 1, figure: 1, figcaption: 1,
  }
  // Elements dropped WITH their content: script/style bodies are code, the rest embed active or foreign content.
  var DROP = { script: 1, style: 1, iframe: 1, frameset: 1, object: 1, applet: 1, svg: 1, math: 1,
    template: 1, noscript: 1, noembed: 1, noframes: 1, xmp: 1, plaintext: 1, textarea: 1, select: 1, title: 1, head: 1 }
  var GLOBAL_ATTRS = { 'class': 1, title: 1, lang: 1, dir: 1 }
  var TAG_ATTRS = {
    a: { href: 1, target: 1 }, img: { src: 1, alt: 1, width: 1, height: 1, loading: 1 },
    td: { colspan: 1, rowspan: 1, align: 1 }, th: { colspan: 1, rowspan: 1, scope: 1, align: 1 },
    ol: { start: 1, type: 1, reversed: 1 }, li: { value: 1 }, col: { span: 1 }, colgroup: { span: 1 },
    blockquote: { cite: 1 }, q: { cite: 1 }, abbr: { title: 1 },
  }
  var NAMED = { amp: '&', lt: '<', gt: '>', quot: '"', apos: "'", nbsp: ' ', colon: ':', tab: '\t', newline: '\n' }

  function decode(s) {
    return s.replace(/&(#x[0-9a-f]+|#\d+|[a-z]+);?/gi, function (m, e) {
      var c = e.charAt(0) === '#' ? (e.charAt(1).toLowerCase() === 'x' ? parseInt(e.slice(2), 16) : parseInt(e.slice(1), 10)) : null
      if (c !== null) return c > 0 && c < 0x110000 ? String.fromCodePoint(c) : ''
      var n = NAMED[e.toLowerCase()]
      return n !== undefined ? n : m
    })
  }
  function escAttr(s) { return s.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;') }
  function escText(s) { return s.replace(/</g, '&lt;').replace(/>/g, '&gt;') }
  // The scheme a browser would see: entities decoded, controls and whitespace removed, lower-cased.
  function scheme(url) {
    var u = decode(url).replace(/[\u0000- \u007f-\u009f]/g, '').toLowerCase()
    var m = /^([a-z][a-z0-9+.-]*):/.exec(u)
    return { url: u, scheme: m ? m[1] : '' }
  }
  function safeUrl(tag, name, value) {
    var s = scheme(value)
    if (!s.scheme) return true
    if (tag === 'img' && name === 'src') return s.scheme === 'http' || s.scheme === 'https' || /^data:image\/(png|jpe?g|gif|webp|avif);/.test(s.url)
    return s.scheme === 'http' || s.scheme === 'https' || s.scheme === 'mailto' || s.scheme === 'tel'
  }
  function attrsOf(tag, src) {
    var out = ''
    var re = /([^\s"'>\/=]+)(?:\s*=\s*(?:"([^"]*)"|'([^']*)'|([^\s"'=<>`]+)))?/g
    var m
    var seen = {}
    while ((m = re.exec(src))) {
      var name = m[1].toLowerCase()
      if (seen[name] || !(GLOBAL_ATTRS[name] || (TAG_ATTRS[tag] && TAG_ATTRS[tag][name]))) continue
      seen[name] = 1
      var raw = m[2] !== undefined ? m[2] : m[3] !== undefined ? m[3] : m[4] !== undefined ? m[4] : ''
      if ((name === 'href' || name === 'src' || name === 'cite') && !safeUrl(tag, name, raw)) continue
      if (name === 'target' && !/^_(blank|self|parent|top)$/.test(raw)) continue
      out += ' ' + name + '="' + escAttr(decode(raw)) + '"'
    }
    if (tag === 'a') out += ' rel="noopener noreferrer"'
    return out
  }

  var out = ''
  var stack = []
  var i = 0
  var n = html.length
  while (i < n) {
    var lt = html.indexOf('<', i)
    if (lt < 0) { out += escText(html.slice(i)); break }
    out += escText(html.slice(i, lt))
    i = lt
    if (html.substr(i, 4) === '<!--') { var ce = html.indexOf('-->', i + 4); i = ce < 0 ? n : ce + 3; continue }
    var m = /^<(\/?)([a-zA-Z][a-zA-Z0-9-]*)((?:"[^"]*"|'[^']*'|[^'">])*)>/.exec(html.slice(i))
    if (!m) {
      if (/^<[!?\/]/.test(html.slice(i, i + 2))) { var ge = html.indexOf('>', i); i = ge < 0 ? n : ge + 1; continue }
      out += '&lt;'; i++; continue
    }
    i += m[0].length
    var tag = m[2].toLowerCase()
    if (m[1]) {
      if (!TAGS[tag] || VOID[tag]) continue
      var at = stack.lastIndexOf(tag)
      if (at < 0) continue
      while (stack.length > at) out += '</' + stack.pop() + '>'
      continue
    }
    if (DROP[tag]) {
      var close = new RegExp('</' + tag + '\\s*>', 'i').exec(html.slice(i))
      i = close ? i + close.index + close[0].length : n
      continue
    }
    if (!TAGS[tag]) continue
    out += '<' + tag + attrsOf(tag, m[3]) + '>'
    if (!VOID[tag] && !/\/\s*$/.test(m[3])) stack.push(tag)
    else if (!VOID[tag]) out += '</' + tag + '>'
  }
  while (stack.length) out += '</' + stack.pop() + '>'
  return out
}
;
// Field validation — one source for the browser (static.ts prepends it to island-runtime.js as Runtime.validate)
// and the server (engine/validate-shared.ts evaluates it in a vm): the 422 the executor returns is this code's verdict.
function rtCreateValidate() {
  var KIND_OF = {
    string: 'string', text: 'string', varchar: 'string', enum: 'string',
    number: 'number', decimal: 'number', numeric: 'number', float: 'number',
    integer: 'integer', int: 'integer', bigint: 'integer',
    boolean: 'boolean', bool: 'boolean',
    date: 'date', timestamptz: 'date', datetime: 'date', timestamp: 'date',
    uuid: 'uuid', file: 'uuid', image: 'uuid',
    email: 'email', array: 'array', object: 'object', jsonb: 'any', json: 'any', any: 'any'
  }
  var UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  var MSG = {
    string: 'Debe ser un texto', number: 'Debe ser un número', integer: 'Debe ser un número entero',
    boolean: 'Debe ser verdadero o falso', date: 'Debe ser una fecha válida', uuid: 'Debe ser un identificador válido',
    email: 'Debe ser un correo válido', array: 'Debe ser una lista', object: 'Debe ser un objeto', any: ''
  }
  function isBlank(v) { return v === undefined || v === null || (typeof v === 'string' && v.trim() === '') }
  function kindOf(spec) { return KIND_OF[String((spec && spec.type) || 'any').toLowerCase()] || 'any' }
  function isNum(v) { return typeof v === 'number' ? isFinite(v) : typeof v === 'string' && v.trim() !== '' && isFinite(Number(v)) }
  function typeOk(kind, v) {
    switch (kind) {
      case 'string': return typeof v === 'string'
      case 'number': return isNum(v)
      case 'integer': return isNum(v) && Math.floor(Number(v)) === Number(v)
      case 'boolean': return typeof v === 'boolean'
      case 'date': return (typeof v === 'string' || typeof v === 'number') && !isNaN(new Date(v).getTime())
      case 'uuid': return typeof v === 'string' && UUID_RE.test(v)
      case 'email': return typeof v === 'string' && EMAIL_RE.test(v.trim())
      case 'array': return Array.isArray(v)
      case 'object': return typeof v === 'object' && v !== null && !Array.isArray(v)
      default: return true
    }
  }
  function rangeError(kind, spec, v) {
    var numeric = kind === 'number' || kind === 'integer'
    var size = numeric ? Number(v) : typeof v === 'string' ? v.length : Array.isArray(v) ? v.length : null
    if (size === null) return null
    if (typeof spec.min === 'number' && size < spec.min) {
      return numeric ? 'Debe ser mayor o igual a ' + spec.min : kind === 'array' ? 'Debe tener al menos ' + spec.min + ' elementos' : 'Debe tener al menos ' + spec.min + ' caracteres'
    }
    if (typeof spec.max === 'number' && size > spec.max) {
      return numeric ? 'Debe ser menor o igual a ' + spec.max : kind === 'array' ? 'Debe tener como máximo ' + spec.max + ' elementos' : 'Debe tener como máximo ' + spec.max + ' caracteres'
    }
    return null
  }
  // One `definition.input` field: the message, or null when valid.
  function inputField(spec, v) {
    spec = spec || {}
    if (isBlank(v)) return spec.required && spec.default === undefined ? 'Obligatorio' : null
    var kind = kindOf(spec)
    if (!typeOk(kind, v)) return spec.message || MSG[kind]
    var r = rangeError(kind, spec, v)
    if (r) return spec.message || r
    if (Array.isArray(spec.enum) && !spec.enum.some(function (e) { return e === v || String(e) === String(v) })) {
      return spec.message || 'Debe ser uno de: ' + spec.enum.map(String).join(', ')
    }
    if (typeof spec.pattern === 'string' && typeof v === 'string' && !new RegExp(spec.pattern).test(v)) return spec.message || 'Formato no válido'
    return null
  }
  // `{ field: message }` for every failing field of a `definition.input` spec, or null.
  function input(spec, values) {
    var errors = {}, n = 0
    values = values || {}
    for (var name in spec) {
      if (!Object.prototype.hasOwnProperty.call(spec, name) || !spec[name] || typeof spec[name] !== 'object') continue
      var msg = inputField(spec[name], values[name])
      if (msg) { errors[name] = msg; n++ }
    }
    return n ? errors : null
  }

  function humanize(s) { return String(s).replace(/[_-]+/g, ' ').replace(/^\s+|\s+$/g, '').replace(/\b\w/g, function (c) { return c.toUpperCase() }) }
  function fail(rule, message, expected, got) { return { rule: rule, message: message, expected: expected, got: got } }
  // One entity field (the normalized form schema shape): `{ rule, message, expected?, got? }` or null.
  function field(f, value) {
    var r = f.rules || {}, H = humanize(f.name), msg = r.message
    var empty = value === undefined || value === null || (typeof value === 'string' && value.length === 0) || (Array.isArray(value) && value.length === 0)
    if (empty) return r.required ? fail('required', msg || H + ' is required') : null
    var n
    switch (f.type) {
      case 'int': case 'bigint':
        n = typeof value === 'number' ? value : Number(value)
        if (!isFinite(n) || Math.floor(n) !== n) return fail('type', msg || H + ' must be an integer', 'integer', typeof value)
        if (r.min != null && n < r.min) return fail('min', msg || H + ' must be at least ' + r.min, r.min, n)
        if (r.max != null && n > r.max) return fail('max', msg || H + ' must be at most ' + r.max, r.max, n)
        break
      case 'decimal':
        n = typeof value === 'number' ? value : Number(value)
        if (!isFinite(n)) return fail('type', msg || H + ' must be a number', 'decimal', typeof value)
        if (r.min != null && n < r.min) return fail('min', msg || H + ' must be at least ' + r.min, r.min, n)
        if (r.max != null && n > r.max) return fail('max', msg || H + ' must be at most ' + r.max, r.max, n)
        break
      case 'boolean':
        if (typeof value !== 'boolean') return fail('type', msg || H + ' must be true or false', 'boolean', typeof value)
        break
      case 'date': case 'timestamptz':
        if (typeof value !== 'string' && !(value && typeof value.getTime === 'function')) return fail('type', msg || H + ' must be a date', 'date', typeof value)
        if (isNaN(new Date(value).getTime())) return fail('type', msg || H + ' is not a valid date', 'date', String(value))
        break
      case 'enum':
        if (typeof value !== 'string') return fail('type', msg || H + ' must be a string', 'string', typeof value)
        var vals = f.values || f.options
        if (vals && vals.length && vals.indexOf(value) < 0) return fail('oneOf', msg || H + ' must be one of: ' + vals.join(', '), vals, value)
        break
      case 'jsonb':
        if (r.min != null || r.max != null) {
          var s = JSON.stringify(value)
          if (r.min != null && s.length < r.min) return fail('min', msg || H + ' too short', r.min, s.length)
          if (r.max != null && s.length > r.max) return fail('max', msg || H + ' too long', r.max, s.length)
        }
        break
      case 'uuid':
        if (typeof value !== 'string' || !UUID_RE.test(value)) return fail('type', msg || H + ' must be a UUID', 'uuid', typeof value === 'string' ? value : typeof value)
        break
      case 'file': case 'image':
        if (typeof value !== 'string') return fail('type', msg || H + ' must be an uploaded file uid', 'file-uid', typeof value)
        break
      default:
        if (typeof value !== 'string') return fail('type', msg || H + ' must be a string', 'string', typeof value)
        if (f.length != null && value.length > f.length) return fail('max', msg || H + ' must be at most ' + f.length + ' characters', f.length, value.length)
        if (r.min != null && value.length < r.min) return fail('min', msg || H + ' must be at least ' + r.min + ' characters', r.min, value.length)
        if (r.max != null && value.length > r.max) return fail('max', msg || H + ' must be at most ' + r.max + ' characters', r.max, value.length)
    }
    if (r.oneOf && r.oneOf.length && typeof value === 'string' && r.oneOf.indexOf(value) < 0) return fail('oneOf', msg || H + ' must be one of: ' + r.oneOf.join(', '), r.oneOf, value)
    if (r.regex) {
      // ReDoS guard: an operator pattern runs on end-user input, so pattern and subject are capped.
      var subject = String(value)
      if (r.regex.length > 1000) return fail('regex', msg || H + ' validation rule is invalid', r.regex, subject)
      if (subject.length > 4096) return fail('max', msg || H + ' is too long to validate', 4096, subject.length)
      var re = null
      try { re = new RegExp(r.regex) } catch (e) { re = null }
      if (re && !re.test(subject)) return fail('regex', msg || H + ' is invalid', r.regex, subject)
    }
    return null
  }
  return { kinds: KIND_OF, input: input, inputField: inputField, field: field }
}
;
// Island runtime: Vue-3-shaped reactivity, SSR DOM adoption (hydration) and islands; installs `window.Island`.
// `globalThis.__ISLAND_TEST__ = true` set before eval attaches `Island.__test` for the smokes.
;(function () {
  'use strict'

  // ════════════════════════════════════════════════════════════════════
  //  Scheduler — microtask-batched, deduped jobs
  // ════════════════════════════════════════════════════════════════════
  const queue = new Set()
  let flushing = false
  const MAX_CYCLES = 100

  function queueJob(job) {
    queue.add(job)
    if (!flushing) { flushing = true; queueMicrotask(flush) }
  }
  /** Order a flush batch by effect creation id (parents before children). */
  function byJobId(a, b) { return (a.__id || 0) - (b.__id || 0) }

  /** Surface a binding error without killing the rest of the batch. */
  function reportFlushError(err) {
    try {
      if (typeof Island !== 'undefined' && typeof Island.onError === 'function') Island.onError('flush', err)
      else console.error('[island] flush', err)
    } catch (_) { /* error reporting must never break the batch */ }
  }

  function flush() {
    let cycles = 0
    try {
      while (queue.size) {
        if (++cycles > MAX_CYCLES) {
          console.error('[island] infinite update loop aborted after ' + MAX_CYCLES + ' cycles')
          queue.clear()
          break
        }
        const jobs = Array.from(queue)
        queue.clear()
        // Parent-before-child: a v-if effect must unmount its branch before that branch's bindings
        // re-evaluate, so jobs run sorted by id (stable sort keeps FIFO on ties).
        jobs.sort(byJobId)
        for (const j of jobs) {
          // A throwing binding must not drop the rest of the already-cleared queue.
          try { j() } catch (err) { reportFlushError(err) }
        }
      }
    } finally {
      flushing = false
    }
  }
  /** Resolve after the next reactive flush. */
  function nextTick(fn) {
    return Promise.resolve().then(() => { flush(); if (typeof fn === 'function') return fn() })
  }

  // ════════════════════════════════════════════════════════════════════
  //  Effect + dependency tracking
  // ════════════════════════════════════════════════════════════════════
  let activeEffect = null
  const effectStack = []

  function cleanupEffect(effect) {
    for (const dep of effect.deps) dep.delete(effect)
    effect.deps.length = 0
  }

  let effectUid = 0

  class ReactiveEffect {
    constructor(fn, scheduler) {
      this.fn = fn
      this.scheduler = scheduler || null
      this.deps = []
      this.active = true
      // Monotonic CREATION id. An ancestor effect is always created before the
      // effects inside the subtree it owns, so ordering a flush batch by id
      // runs parents first — see flush().
      this.id = ++effectUid
      // A disposed effect's scheduled job is a no-op: an outer effect may stop it mid-flush after it
      // was queued. Guard the job, not run(), so computed's explicit runner.run() is untouched.
      this.job = () => { if (this.active) this.run() }
      this.job.__id = this.id
    }
    run() {
      if (!this.active) return this.fn()
      cleanupEffect(this)
      try {
        effectStack.push(this)
        activeEffect = this
        return this.fn()
      } finally {
        effectStack.pop()
        activeEffect = effectStack.length ? effectStack[effectStack.length - 1] : null
      }
    }
    stop() {
      if (this.active) { cleanupEffect(this); this.active = false }
    }
  }

  const targetMap = new WeakMap() // raw target -> Map<key, Set<effect>>
  const ITERATE_KEY = Symbol('iterate')

  function track(target, key) {
    if (!activeEffect) return
    let depsMap = targetMap.get(target)
    if (!depsMap) targetMap.set(target, (depsMap = new Map()))
    let dep = depsMap.get(key)
    if (!dep) depsMap.set(key, (dep = new Set()))
    if (!dep.has(activeEffect)) {
      dep.add(activeEffect)
      activeEffect.deps.push(dep)
    }
  }

  function trigger(target, key) {
    const depsMap = targetMap.get(target)
    if (!depsMap) return
    const toRun = new Set()
    const collect = (dep) => { if (dep) for (const e of dep) if (e !== activeEffect) toRun.add(e) }
    collect(depsMap.get(key))
    collect(depsMap.get(ITERATE_KEY)) // adds/deletes affect iteration + length reads
    for (const e of toRun) {
      if (e.scheduler) e.scheduler()
      else e.run()
    }
  }

  // ════════════════════════════════════════════════════════════════════
  //  reactive / ref / computed
  // ════════════════════════════════════════════════════════════════════
  const reactiveMap = new WeakMap() // raw -> proxy
  const rawMap = new WeakMap()      // proxy -> raw
  const rawMarked = new WeakSet()   // values forced non-reactive (markRaw, refs, computeds)

  function isRef(v) { return !!(v && v.__v_isRef === true) }
  function unref(v) { return isRef(v) ? v.value : v }
  function isReactive(v) { return !!(v && rawMap.has(v)) }
  function toRaw(v) { return (v && rawMap.get(v)) || v }
  function markRaw(v) { if (v && typeof v === 'object') rawMarked.add(v); return v }

  function isPlainTrackable(v) {
    if (v === null || typeof v !== 'object') return false
    if (rawMarked.has(v)) return false
    if (v.__v_isRef === true) return false
    if (rawMap.has(v)) return false // already a proxy
    const proto = Object.getPrototypeOf(v)
    return proto === Object.prototype || proto === Array.prototype || proto === null
  }

  function reactive(target) {
    if (!isPlainTrackable(target)) return target
    const existing = reactiveMap.get(target)
    if (existing) return existing
    const proxy = new Proxy(target, {
      get(t, key, recv) {
        if (key === '__v_raw') return t
        const res = Reflect.get(t, key, recv)
        if (typeof key === 'symbol') return res
        track(t, key)
        // Nested refs stored in a reactive object auto-unwrap (Vue behaviour).
        if (isRef(res)) return res.value
        return isPlainTrackable(res) ? reactive(res) : res
      },
      set(t, key, val, recv) {
        const had = Object.prototype.hasOwnProperty.call(t, key)
        const old = t[key]
        const raw = toRaw(val)
        // existing ref + plain new value → write through the ref
        if (isRef(old) && !isRef(raw)) { old.value = raw; return true }
        const result = Reflect.set(t, key, raw, recv)
        if (!had) { trigger(t, key); trigger(t, ITERATE_KEY) }
        else if (!Object.is(old, raw)) trigger(t, key)
        if (Array.isArray(t)) trigger(t, 'length')
        return result
      },
      deleteProperty(t, key) {
        const had = Object.prototype.hasOwnProperty.call(t, key)
        const result = Reflect.deleteProperty(t, key)
        if (had && result) { trigger(t, key); trigger(t, ITERATE_KEY) }
        return result
      },
      has(t, key) { track(t, key); return Reflect.has(t, key) },
      ownKeys(t) { track(t, ITERATE_KEY); return Reflect.ownKeys(t) },
    })
    reactiveMap.set(target, proxy)
    rawMap.set(proxy, target)
    return proxy
  }

  function ref(value) {
    if (isRef(value)) return value
    let _value = isPlainTrackable(value) ? reactive(value) : value
    const r = {
      __v_isRef: true,
      get value() { track(r, 'value'); return _value },
      set value(v) {
        const nv = isPlainTrackable(v) ? reactive(v) : v
        if (Object.is(nv, _value)) return
        _value = nv
        trigger(r, 'value')
      },
    }
    rawMarked.add(r)
    return r
  }

  function computed(getter) {
    let _value
    let _dirty = true
    const runner = new ReactiveEffect(getter, () => {
      if (!_dirty) { _dirty = true; trigger(c, 'value') }
    })
    const c = {
      __v_isRef: true,
      __v_isComputed: true,
      get value() {
        if (_dirty) { _value = runner.run(); _dirty = false }
        track(c, 'value')
        return _value
      },
    }
    rawMarked.add(c)
    return c
  }

  // ════════════════════════════════════════════════════════════════════
  //  watch / watchEffect
  // ════════════════════════════════════════════════════════════════════
  function traverse(value, seen) {
    if (value === null || typeof value !== 'object') return value
    seen = seen || new Set()
    if (seen.has(value)) return value
    seen.add(value)
    if (Array.isArray(value)) { for (let i = 0; i < value.length; i++) traverse(value[i], seen) }
    else { for (const k in value) traverse(value[k], seen) }
    return value
  }

  function watchEffect(fn) {
    const e = new ReactiveEffect(fn)
    e.scheduler = () => queueJob(e.job)
    e.run()
    return () => e.stop()
  }

  function watch(source, cb, opts) {
    opts = opts || {}
    let deep = !!opts.deep

    // A getter source may return a raw ref (compiled `() => __scope.x`); read `.value` inside the
    // effect so the dependency is tracked.
    const toGetter = (s) => {
      if (isRef(s)) return () => s.value
      if (isReactive(s)) { deep = true; return () => s }
      if (typeof s === 'function') return () => { const v = s(); return isRef(v) ? v.value : v }
      return () => s
    }

    const isMulti = Array.isArray(source)
    let getter
    if (isMulti) {
      const gs = source.map(toGetter)   // may flip `deep` if any element is reactive
      getter = () => gs.map((g) => g())
    } else {
      getter = toGetter(source)
    }
    if (deep) { const g = getter; getter = () => traverse(g()) }

    const changed = (a, b) => {
      if (isMulti) {
        if (!Array.isArray(a) || !Array.isArray(b) || a.length !== b.length) return true
        for (let i = 0; i < a.length; i++) {
          if (!Object.is(a[i], b[i]) || (a[i] && typeof a[i] === 'object')) return true
        }
        return false
      }
      return !Object.is(a, b) || (a && typeof a === 'object')
    }

    let oldValue
    let cleanup
    const onCleanup = (fn) => { cleanup = fn }
    const e = new ReactiveEffect(getter)
    const job = () => {
      if (!e.active) return
      const newValue = e.run()
      if (deep || changed(newValue, oldValue)) {
        if (cleanup) { const c = cleanup; cleanup = undefined; c() }
        cb(newValue, oldValue, onCleanup)
        oldValue = newValue
      }
    }
    job.__id = e.id
    // Scheduling: flush:'sync' runs the callback immediately on trigger; the
    // documented `debounce` (ms) coalesces rapid triggers into one trailing
    // call; otherwise the callback is batched onto the microtask queue.
    let debTimer = null
    e.scheduler = () => {
      if (opts.flush === 'sync') { job(); return }
      if (opts.debounce) {
        if (debTimer) clearTimeout(debTimer)
        debTimer = setTimeout(() => { debTimer = null; job() }, opts.debounce)
        return
      }
      queueJob(job)
    }
    if (opts.immediate) { oldValue = undefined; job() }
    else oldValue = e.run()
    return () => { if (debTimer) { clearTimeout(debTimer); debTimer = null } e.stop(); if (cleanup) cleanup() }
  }

  // ════════════════════════════════════════════════════════════════════
  //  $fmt — rtCreateFmt comes from static/fmt.js, prepended at serve time
  // ════════════════════════════════════════════════════════════════════
  let rtFmtCache = null
  function rtFmt() {
    if (typeof rtCreateFmt !== 'function') return null
    const loc = rtReadMeta('rt-locale') || 'es-PE'
    const tz = rtReadMeta('rt-tz') || 'UTC'
    if (!rtFmtCache || rtFmtCache.locale !== loc || rtFmtCache.tz !== tz) rtFmtCache = rtCreateFmt(loc, tz)
    return rtFmtCache
  }

  // ════════════════════════════════════════════════════════════════════
  //  Runtime.store / useStore, Runtime.use.* composables, $t
  // ════════════════════════════════════════════════════════════════════
  function rtStorage(kind) {
    try { return (kind === 'session' ? globalThisRef.sessionStorage : globalThisRef.localStorage) || null } catch (_) { return null }
  }
  function rtWin() { return typeof window !== 'undefined' ? window : null }
  function rtJson(v) { try { return JSON.stringify(v) } catch (_) { return undefined } }
  function rtParse(s, d) { if (s == null) return d; try { return JSON.parse(s) } catch (_) { return d } }

  // One reactive object per name for the whole document; a persisted store restores on first use.
  const rtStores = new Map()
  function rtStore(name, init, opts) {
    var hit = rtStores.get(name)
    if (hit) return hit
    var seed = rtJson(typeof init === 'function' ? init() : (init || {})) || '{}'
    var persist = opts && opts.persist
    var store = persist === 'local' || persist === 'session' ? rtStorage(persist) : null
    var key = 'rt-store:' + (rtReadMeta('rt-app-uid') || '') + ':' + name
    var raw = Object.assign(rtParse(seed, {}), store ? rtParse(store.getItem(key), {}) : {})
    var subs = new Set()
    var quiet = false
    function notify(type) {
      subs.forEach(function (fn) { try { fn(state, { type: type, name: name }) } catch (e) { console.error('[store] subscriber error:', e) } })
    }
    function assign(next) {
      quiet = true
      for (var k in state) if (!Object.prototype.hasOwnProperty.call(next, k)) delete state[k]
      for (var j in next) state[j] = next[j]
      quiet = false
    }
    Object.defineProperty(raw, '$reset', { value: function () { assign(rtParse(seed, {})); notify('reset') } })
    Object.defineProperty(raw, '$subscribe', { value: function (fn) { subs.add(fn); return function () { subs.delete(fn) } } })
    var state = reactive(raw)
    var timer = null
    watch(function () { return rtJson(state) }, function (json) {
      if (!quiet) notify('set')
      if (!store) return
      clearTimeout(timer)
      timer = setTimeout(function () { try { store.setItem(key, json) } catch (_) { /* quota */ } }, 100)
    })
    var w = rtWin()
    if (persist === 'local' && w) w.addEventListener('storage', function (e) {
      if (e.key !== key || e.newValue == null) return
      assign(rtParse(e.newValue, {}))
      notify('storage')
    })
    rtStores.set(name, state)
    return state
  }

  // With a scope, every listener and timer is released on its dispose; Runtime.use.* lives with the document.
  function makeUseHelpers(scope) {
    function hold(off) { if (scope) addDisposer(scope, off); return off }
    function listen(target, ev, fn) {
      if (!target) return
      target.addEventListener(ev, fn)
      hold(function () { target.removeEventListener(ev, fn) })
    }
    var w = rtWin()
    var d = typeof document !== 'undefined' ? document : null
    return {
      useStore: rtStore,
      useMediaQuery: function (q) {
        var mq = w && w.matchMedia ? w.matchMedia(q) : null
        var r = ref(!!(mq && mq.matches))
        if (mq) listen(mq, 'change', function (e) { r.value = !!e.matches })
        return r
      },
      useLocalStorage: function (key, def) {
        var ls = rtStorage('local')
        var r = ref(ls ? rtParse(ls.getItem(key), def) : def)
        hold(watch(r, function (v) {
          try { if (v === undefined) ls.removeItem(key); else ls.setItem(key, rtJson(v)) } catch (_) { /* */ }
        }, { deep: true }))
        listen(w, 'storage', function (e) { if (e.key === key) r.value = rtParse(e.newValue, def) })
        return r
      },
      useOnline: function () {
        var r = ref(typeof navigator === 'undefined' || navigator.onLine !== false)
        listen(w, 'online', function () { r.value = true })
        listen(w, 'offline', function () { r.value = false })
        return r
      },
      useIdle: function (ms) {
        var r = ref(false)
        var t = null
        function poke() { r.value = false; clearTimeout(t); t = setTimeout(function () { r.value = true }, ms || 60000) }
        var evs = ['pointerdown', 'pointermove', 'keydown', 'scroll', 'wheel', 'touchstart']
        for (var i = 0; i < evs.length; i++) listen(w, evs[i], poke)
        poke()
        hold(function () { clearTimeout(t) })
        return r
      },
      useClipboard: function () {
        var copied = ref(false)
        var t = null
        hold(function () { clearTimeout(t) })
        return { copied: copied, copy: async function (text) {
          try { await navigator.clipboard.writeText(String(text)) } catch (_) { return false }
          copied.value = true
          clearTimeout(t)
          t = setTimeout(function () { copied.value = false }, 1500)
          return true
        } }
      },
      useGeolocation: function (o) {
        var coords = ref(null), error = ref(null)
        var geo = typeof navigator !== 'undefined' ? navigator.geolocation : null
        function ok(p) {
          error.value = null
          coords.value = { latitude: p.coords.latitude, longitude: p.coords.longitude, accuracy: p.coords.accuracy, at: p.timestamp }
        }
        function bad(e) { error.value = { code: e ? e.code : 0, message: (e && e.message) || 'geolocation_unavailable' } }
        function refresh() { if (geo) geo.getCurrentPosition(ok, bad, o); else bad(null) }
        if (geo && o && o.watch) {
          var id = geo.watchPosition(ok, bad, o)
          hold(function () { geo.clearWatch(id) })
        } else refresh()
        return { coords: coords, error: error, refresh: refresh }
      },
      useDebounceFn: function (fn, ms) {
        var t = null
        function run() {
          var a = arguments, self = this
          clearTimeout(t)
          t = setTimeout(function () { fn.apply(self, a) }, ms || 0)
        }
        run.cancel = function () { clearTimeout(t) }
        hold(run.cancel)
        return run
      },
      useIntervalFn: function (fn, ms) {
        var id = null
        var isActive = ref(false)
        function pause() { if (id) clearInterval(id); id = null; isActive.value = false }
        function resume() { pause(); id = setInterval(function () { safeCall(scope, fn) }, ms); isActive.value = true }
        resume()
        hold(pause)
        return { pause: pause, resume: resume, isActive: isActive }
      },
      useDocumentVisibility: function () {
        var r = ref(d ? d.visibilityState || 'visible' : 'visible')
        listen(d, 'visibilitychange', function () { r.value = d.visibilityState })
        return r
      },
      // One member per tab: a beat every 20 s while visible, a leave on hide/unload/dispose, the list over Runtime.live.
      usePresence: function (channel, o) {
        var members = ref([])
        var others = computed(function () {
          var seen = {}, out = []
          members.value.forEach(function (m) {
            if (m.id === RT_ORIGIN || (m.user && seen[m.user])) return
            if (m.user) seen[m.user] = 1
            out.push(m)
          })
          return out
        })
        var uid = rtReadMeta('rt-app-uid')
        if (!uid || !channel || typeof fetch === 'undefined') return { members: members, others: others }
        var url = '/runtime/presence/' + uid
        var here = false, timer = null
        function send(action) {
          var body = JSON.stringify({ channel: channel, id: RT_ORIGIN, action: action, meta: (o && o.meta) || null })
          if (action === 'leave' && typeof navigator !== 'undefined' && navigator.sendBeacon) {
            try { if (navigator.sendBeacon(url, new Blob([body], { type: 'application/json' }))) return Promise.resolve(null) } catch (_) { /* fetch below */ }
          }
          return fetch(url, { method: 'POST', credentials: 'include', keepalive: action === 'leave', headers: { 'Content-Type': 'application/json' }, body: body })
            .then(function (r) { return r.ok ? r.json() : null }).catch(function () { return null })
        }
        function beat() {
          here = true
          send('beat').then(function (j) { if (here && j && Array.isArray(j.members)) members.value = j.members })
        }
        function join() { if (!here) { beat(); timer = setInterval(beat, 20000) } }
        function leave() {
          if (!here) return
          here = false
          clearInterval(timer)
          timer = null
          send('leave')
          members.value = []
        }
        hold(busSubscribe('event:live:presence:' + channel, function (p) { if (here && p && Array.isArray(p.members)) members.value = p.members }))
        hold(busSubscribe('event:live-resync', function () { if (here) beat() }))
        if (Runtime.live && Runtime.live.ensureTopic) Runtime.live.ensureTopic('live:presence:' + channel)
        listen(d, 'visibilitychange', function () { if (d.visibilityState === 'hidden') leave(); else join() })
        listen(w, 'pagehide', leave)
        hold(leave)
        if (!d || d.visibilityState !== 'hidden') join()
        return { members: members, others: others }
      },
      // Pages a cursor DataSource ({ rows, next }); a getter or ref `input` resets the list when it changes.
      useInfiniteList: function (dsUid, input, o) {
        var items = ref([]), pending = ref(false), loaded = ref(false), hasMore = ref(true), error = ref(null)
        var size = Number(o && o.pageSize) || 0
        var next = null, gen = 0, inflight = null
        function current() {
          var v = typeof input === 'function' ? input() : (isRef(input) ? input.value : input)
          return v && typeof v === 'object' ? v : {}
        }
        function loadMore() {
          if (inflight) return inflight
          if (!hasMore.value) return Promise.resolve(items.value)
          var mine = gen
          var call = Object.assign({}, current(), size ? { limit: size } : {}, next ? { after: next } : {})
          pending.value = true
          error.value = null
          inflight = Promise.resolve(Runtime.ds(dsUid, call)).then(function (page) {
            if (mine !== gen) return items.value
            var rows = page && Array.isArray(page.rows) ? page.rows : (Array.isArray(page) ? page : [])
            next = page && typeof page.next === 'string' ? page.next : null
            items.value = items.value.concat(rows)
            hasMore.value = !!next
            return items.value
          }, function (e) {
            if (mine === gen) error.value = (e && e.message) || 'load_failed'
            return items.value
          }).then(function (v) {
            if (mine === gen) { pending.value = false; loaded.value = true; inflight = null }
            return v
          })
          return inflight
        }
        function reset() {
          gen++
          inflight = null
          next = null
          items.value = []
          hasMore.value = true
          loaded.value = false
          pending.value = false
          return loadMore()
        }
        if (typeof input === 'function' || isRef(input)) hold(watch(current, reset, { deep: true }))
        loadMore()
        return { items: items, loadMore: loadMore, reset: reset, hasMore: hasMore, pending: pending, loaded: loaded, error: error }
      },
    }
  }
  const RT_USE_NAMES = ['useStore', 'useMediaQuery', 'useLocalStorage', 'useOnline', 'useIdle', 'useClipboard',
    'useGeolocation', 'useDebounceFn', 'useIntervalFn', 'useDocumentVisibility', 'usePresence', 'useInfiniteList']

  // `$flag(key)` in the browser: the keys the server evaluated ON for this caller (`<meta name="rt-flags">`).
  var rtFlagSet = null
  function rtFlag(key) {
    if (!rtFlagSet) rtFlagSet = (rtReadMeta('rt-flags') || '').split(',').filter(Boolean)
    return rtFlagSet.indexOf(String(key)) >= 0
  }

  // The page carries the active locale's catalog, fallbacks already merged server-side, as data-rt-i18n.
  let rtTCache = null
  function rtT() {
    if (rtTCache) return rtTCache
    var el = typeof document !== 'undefined' && document.querySelector ? document.querySelector('script[data-rt-i18n]') : null
    var cat = rtParse(el ? el.textContent : null, {})
    rtTCache = typeof rtCreateT === 'function' ? rtCreateT(cat, rtReadMeta('rt-locale') || 'es-PE') : function (k) { return k }
    return rtTCache
  }

  // ════════════════════════════════════════════════════════════════════
  //  Observability — browser errors → /runtime/client-log, Web Vitals → /runtime/vitals
  // ════════════════════════════════════════════════════════════════════
  const rtObs = (function () {
    const CAP = 20
    const DEDUPE_MS = 5 * 60 * 1000
    const seen = new Map()
    let sent = 0
    const hasWin = typeof window !== 'undefined' && typeof window.addEventListener === 'function'
    // Breadcrumbs: the last RING events of this page view travel with every error beacon.
    const RING = 20
    const T0 = Date.now()
    const crumbs = []
    const dsReq = Object.create(null) // ds uid → x-request-id of its last response
    function cut(v, n) { return v == null ? null : String(v).slice(0, n) }
    function crumb(c) { c.t = Date.now() - T0; crumbs.push(c); if (crumbs.length > RING) crumbs.shift() }
    function selOf(el) {
      if (el && el.nodeType !== 1) el = el.parentElement
      if (!el || !el.tagName) return '?'
      const hit = el.closest && el.closest('a,button,input,select,textarea,label,summary,[role=button]')
      if (hit) el = hit
      let s = el.tagName.toLowerCase()
      const cls = typeof el.className === 'string' ? el.className.trim().split(/\s+/)[0] : ''
      if (el.id) s += '#' + el.id
      else if (cls) s += '.' + cls
      return s.slice(0, 60)
    }

    function hash(s) { let h = 5381; for (let i = 0; i < s.length; i++) h = ((h << 5) + h + s.charCodeAt(i)) | 0; return (h >>> 0).toString(36) }
    function runtimeHash() {
      const el = typeof document !== 'undefined' && document.querySelector && document.querySelector('script[src*="island-runtime"]')
      const m = el && /island-runtime\.([0-9a-f]+)\.js/.exec(el.getAttribute('src') || '')
      return m ? m[1] : ''
    }
    function beacon(url, body) {
      // A speculatively prerendered page reports once, when (and only if) the person activates it.
      if (typeof document !== 'undefined' && document.prerendering) { document.addEventListener('prerenderingchange', function () { beacon(url, body) }, { once: true }); return }
      const json = JSON.stringify(body)
      try {
        if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function' &&
          navigator.sendBeacon(url, new Blob([json], { type: 'application/json' }))) return
      } catch (_) { /* fall through to fetch */ }
      try {
        fetch(url, { method: 'POST', body: json, keepalive: true, credentials: 'same-origin', headers: { 'content-type': 'application/json' } }).catch(function () {})
      } catch (_) { /* reporting never throws */ }
    }

    function report(kind, err, where) {
      try {
        if (sent >= CAP) return
        const e = err && typeof err === 'object' ? err : { message: String(err) }
        const message = String(e.message || kind).slice(0, 1000)
        const stack = String(e.stack || '').slice(0, 2048)
        const key = hash(message + '\n' + stack)
        const now = Date.now()
        if (seen.has(key) && now - seen.get(key) < DEDUPE_MS) return
        seen.set(key, now)
        sent++
        where = where || {}
        const body = {
          app: rtReadMeta('rt-app-uid') || null, kind: kind, message: message, stack: stack,
          source: where.source || null, line: where.line || null, col: where.col || null,
          route: typeof location !== 'undefined' ? location.pathname : null, runtime: runtimeHash(),
          ua: typeof navigator !== 'undefined' ? String(navigator.userAgent || '').slice(0, 300) : null,
          reqId: typeof e.reqId === 'string' ? e.reqId.slice(0, 64) : null,
          online: typeof navigator === 'undefined' || navigator.onLine !== false,
          viewport: hasWin ? { w: window.innerWidth || 0, h: window.innerHeight || 0 } : null,
          sinceLoadMs: Date.now() - T0, breadcrumbs: crumbs.slice(),
        }
        while (body.breadcrumbs.length && JSON.stringify(body).length > 7800) body.breadcrumbs.shift()
        beacon('/runtime/client-log', body)
        crumb({ type: 'error', msg: message.slice(0, 120) })
      } catch (_) { /* reporting never throws */ }
    }

    // Web Vitals: thresholds are web.dev's good / poor boundaries.
    const LIMITS = { LCP: [2500, 4000], CLS: [0.1, 0.25], INP: [200, 500], FCP: [1800, 3000], TTFB: [800, 1800] }
    let route = typeof location !== 'undefined' ? location.pathname : '/'
    let v = {}
    let inp = []
    let cls = { sess: 0, first: 0, last: 0 }
    function rate(name, val) { const l = LIMITS[name]; return val <= l[0] ? 'good' : val <= l[1] ? 'needs-improvement' : 'poor' }
    // p98 of interaction durations: skip one of the slowest per 50 interactions.
    function inpValue() { if (!inp.length) return null; const s = inp.slice().sort(function (a, b) { return b - a }); return s[Math.min(s.length - 1, Math.floor(s.length / 50))] }
    function flushVitals() {
      const val = Object.assign({}, v)
      const i = inpValue()
      if (i != null) val.INP = i
      v = {}; inp = []; cls = { sess: 0, first: 0, last: 0 }
      const samples = []
      for (const name in val) if (LIMITS[name] && isFinite(val[name])) samples.push({ name: name, value: Math.round(val[name] * 1000) / 1000, rating: rate(name, val[name]) })
      if (samples.length) beacon('/runtime/vitals', { app: rtReadMeta('rt-app-uid') || null, route: route, samples: samples })
    }
    // A soft navigation changes the pathname: the old route's samples go out before new entries count.
    function onEntries(cb) {
      return function (list) {
        if (typeof location !== 'undefined' && location.pathname !== route) { flushVitals(); route = location.pathname }
        cb(list.getEntries())
      }
    }
    function observe(type, cb, extra) {
      try { new PerformanceObserver(onEntries(cb)).observe(Object.assign({ type: type, buffered: true }, extra || {})) } catch (_) { /* unsupported entry type */ }
    }
    function startVitals() {
      if (typeof PerformanceObserver !== 'function') return
      observe('largest-contentful-paint', function (es) { if (es.length) v.LCP = es[es.length - 1].startTime })
      observe('paint', function (es) { es.forEach(function (e) { if (e.name === 'first-contentful-paint') v.FCP = e.startTime }) })
      observe('layout-shift', function (es) {
        es.forEach(function (e) {
          if (e.hadRecentInput) return
          if (cls.sess && e.startTime - cls.last < 1000 && e.startTime - cls.first < 5000) cls.sess += e.value
          else { cls.sess = e.value; cls.first = e.startTime }
          cls.last = e.startTime
          if (cls.sess > (v.CLS || 0)) v.CLS = cls.sess
        })
      })
      observe('event', function (es) { es.forEach(function (e) { if (e.interactionId) inp.push(e.duration) }) }, { durationThreshold: 40 })
      try {
        const nav = performance.getEntriesByType('navigation')[0]
        if (nav && nav.responseStart > 0) v.TTFB = nav.responseStart
      } catch (_) { /* no navigation timing */ }
    }

    if (hasWin) {
      window.addEventListener('error', function (ev) {
        if (!ev || (!ev.error && !ev.message)) return
        report('error', ev.error || { message: ev.message }, { source: ev.filename, line: ev.lineno, col: ev.colno })
      })
      window.addEventListener('unhandledrejection', function (ev) { report('unhandledrejection', ev && ev.reason) })
      window.addEventListener('online', function () { crumb({ type: 'online' }) })
      window.addEventListener('offline', function () { crumb({ type: 'offline' }) })
      if (typeof document !== 'undefined') document.addEventListener('click', function (ev) { crumb({ type: 'click', sel: selOf(ev.target) }) }, { capture: true, passive: true })
      if (typeof window.fetch === 'function') {
        const fetch0 = window.fetch
        window.fetch = function (url) {
          const p = fetch0.apply(this, arguments)
          try { watchDsResponse(String((url && url.url) || url || ''), arguments[1], p) } catch (_) { /* observer only */ }
          return p
        }
      }
      startVitals()
      if (typeof document !== 'undefined') document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') flushVitals() })
      window.addEventListener('pagehide', flushVitals)
    }
    // The x-request-id of a DS response, kept per uid so a ds() rejection carries the id the server logged.
    function watchDsResponse(url, init, p) {
      const m = /\/runtime\/ds\/([^/?#]+)/.exec(url)
      if (!m || !p || typeof p.then !== 'function') return
      let uids = [m[1]]
      if (m[1] === 'batch') { try { uids = JSON.parse(init.body).calls.map(function (c) { return c.uid }) } catch (_) { return } }
      p.then(function (res) {
        const id = res && res.headers && typeof res.headers.get === 'function' ? res.headers.get('x-request-id') : null
        if (id) uids.forEach(function (u) { dsReq[u] = id })
      }, function () {})
    }
    // Called once the bus and Runtime exist: navigation and ds() calls become breadcrumbs.
    function wire(rt) {
      busSubscribe('event:navigated', function (p) {
        p = p || {}
        crumb({ type: 'nav', from: cut(p.from, 80), to: cut((p.path || '') + (p.search || ''), 80) })
      })
      const orig = rt && rt.ds
      if (typeof orig !== 'function' || orig.__crumbs) return
      const wrapped = async function ds(uid) {
        const t = Date.now()
        try {
          const r = await orig.apply(this, arguments)
          crumb({ type: 'ds', uid: cut(uid, 40), status: 200, ms: Date.now() - t })
          return r
        } catch (err) {
          if (err && typeof err === 'object' && !err.reqId && dsReq[uid]) err.reqId = dsReq[uid]
          crumb({ type: 'ds', uid: cut(uid, 40), status: (err && err.status) || 0, ms: Date.now() - t })
          throw err
        }
      }
      Object.keys(orig).forEach(function (k) { wrapped[k] = orig[k] })
      wrapped.__crumbs = true
      rt.ds = wrapped
    }
    return { report: report, flushVitals: flushVitals, wire: wire, breadcrumbs: function () { return crumbs.slice() } }
  })()

  // The server-stamped LQIP background (`data-rt-lqip`) comes off once the image settles: a transparent image shows through.
  function rtClearLqip(img) {
    img.style.removeProperty('background-image'); img.style.removeProperty('background-size'); img.removeAttribute('data-rt-lqip')
  }
  if (typeof document !== 'undefined' && document.addEventListener) {
    const onImgSettled = function (e) { const t = e.target; if (t && t.tagName === 'IMG' && t.hasAttribute('data-rt-lqip')) rtClearLqip(t) }
    document.addEventListener('load', onImgSettled, true)
    document.addEventListener('error', onImgSettled, true)
    const sweepLqip = function () { document.querySelectorAll('img[data-rt-lqip]').forEach(function (img) { if (img.complete) rtClearLqip(img) }) }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sweepLqip); else sweepLqip()
  }

  // A bound `<img :src>` that lands on a platform file URL gets the same srcset/sizes the renderer gives a static one.
  const RT_FILE_URL = /^\/app\/(?:[0-9a-fA-F-]{36}\/)?file\/[0-9a-fA-F-]{36}$/
  function rtFileSrcset(el, v) {
    if (el.hasAttribute('data-rt-no-srcset')) return
    const owned = el.hasAttribute('data-rt-srcset')
    if (el.hasAttribute('srcset') && !owned) return
    const src = typeof v === 'string' ? v.trim() : ''
    if (!RT_FILE_URL.test(src)) {
      if (owned) { el.removeAttribute('srcset'); el.removeAttribute('data-rt-srcset') }
      return
    }
    if (!el.hasAttribute('sizes')) el.setAttribute('sizes', '(max-width: 480px) 100vw, 50vw')
    el.setAttribute('srcset', [320, 640, 960, 1280].map(function (w) { return src + '?w=' + w + ' ' + w + 'w' }).join(', '))
    el.setAttribute('data-rt-srcset', '')
  }

  // Template/event view of a scope: bare `n` reads/writes `n.value` on refs, pass-through otherwise.
  function proxyRefs(scope) {
    return new Proxy(scope, {
      get(t, key, recv) {
        if (key === Symbol.unscopables) return undefined
        const v = Reflect.get(t, key, recv)
        return isRef(v) ? v.value : v
      },
      set(t, key, val, recv) {
        const old = t[key]
        if (isRef(old) && !isRef(val)) { old.value = val; return true }
        return Reflect.set(t, key, val, recv)
      },
      // `has` claims every non-global identifier (unknown → undefined, never ReferenceError), except
      // `$event`/`$v` (compiled-fn params), `_`-internals and real globals.
      has(t, key) {
        if (typeof key === 'symbol') return Reflect.has(t, key)
        if (key in t) return true
        if (key === '$event' || key === '$v') return false
        if (key.charCodeAt(0) === 95 /* '_' */) return false
        return !(key in globalThisRef)
      },
    })
  }
  // The real global object (browser: window). Cached so the proxy `has` trap can
  // tell a genuine global from an unknown identifier without a hardcoded allowlist.
  var globalThisRef = (typeof globalThis !== 'undefined') ? globalThis
    : (typeof window !== 'undefined') ? window : {}

  const exprCache = new Map()
  function compileExpr(expr) {
    let fn = exprCache.get(expr)
    if (!fn) {
      // eslint-disable-next-line no-new-func
      fn = new Function('$s', '$event', 'with ($s) { return (' + expr + ') }')
      exprCache.set(expr, fn)
    }
    return fn
  }
  /** Evaluate a template expression against a scope (auto-unwrapping refs). */
  function evaluate(expr, scope, event) {
    return compileExpr(expr)(proxyRefs(scope), event)
  }

  // Vue's handler classification: a path (`save`, `form.reset`) or a function expression is a value to call, not a statement.
  var HANDLER_PATH_RE = /^[a-zA-Z_$][\w$]*(?:\.[a-zA-Z_$][\w$]*)*$/
  var HANDLER_FN_RE = /^(?:async\s*)?(?:\([^)]*?\)|[\w$]+)\s*=>|^(?:async\s+)?function(?:\s+[\w$]+)?\s*\(/
  var NOT_REF = {}
  // Calls a handler reference with `arg` (a dotted path keeps its owner as `this`); NOT_REF when `src` is a statement.
  function callHandlerRef(src, scope, arg) {
    var fn, self
    if (HANDLER_FN_RE.test(src)) fn = evaluate(src, scope, arg)
    else if (HANDLER_PATH_RE.test(src)) {
      var dot = src.lastIndexOf('.')
      if (dot < 0) fn = evaluate(src, scope, arg)
      else { self = evaluate(src.slice(0, dot), scope, arg); fn = self == null ? undefined : self[src.slice(dot + 1)] }
    } else return NOT_REF
    return typeof fn === 'function' ? fn.call(self, arg) : NOT_REF
  }

  const stmtCache = new Map()
  function compileStmt(stmt) {
    let fn = stmtCache.get(stmt)
    if (!fn) {
      // eslint-disable-next-line no-new-func
      fn = new Function('$s', '$event', 'with ($s) { ' + stmt + ' }')
      stmtCache.set(stmt, fn)
    }
    return fn
  }
  /** Run a template event statement (e.g. `n++`, `open(p)`) with ref write-back. */
  function runStmt(stmt, scope, event) {
    return compileStmt(stmt)(proxyRefs(scope), event)
  }


  // ── Utilities ────────────────────────────────────────────────────────

  /** Convert a value to text for DOM output (null/undefined → ''). */
  function stringify(v) {
    if (v === null || v === undefined) return ''
    if (typeof v === 'object') return JSON.stringify(v)
    return String(v)
  }

  /** Attach a stop fn to a DOM node for cleanup. */
  function addStop(node, fn) {
    if (!node.__islandStops) node.__islandStops = []
    node.__islandStops.push(fn)
  }

  // watchEffect tied to a DOM node: once the node is dead the effect stops itself.
  function nodeAlive(node) {
    if (!node) return false
    if (node.isConnected) return true
    var root = node.getRootNode ? node.getRootNode() : null
    return !!root && root.nodeType === 11
  }

  function nodeEffect(node, fn) {
    var stop = watchEffect(function () {
      // Dead = detached AND not inside a build fragment (getRootNode nodeType 11). Read the state each
      // run; a remembered "seen connected" flag never arms for a binding built inside the fragment.
      if (!nodeAlive(node)) { if (stop) stop(); return }
      fn()
    })
    addStop(node, stop)
    return stop
  }

  // Stop the effects of a node and its descendants; a descendant [data-island] root is torn down
  // whole. Callers disposing an island root themselves pass no `_isDescendant`.
  function stopNode(node, _isDescendant) {
    if (!node) return
    // Descendant island root → full teardown (dispose scope + drop + strip scripts),
    // then recurse into its subtree to stop the nested effects too.
    if (_isDescendant && node.nodeType === 1 && node.getAttribute &&
        node.getAttribute('data-island') !== null) {
      const tag = node.tagName && node.tagName.toLowerCase()
      if (tag !== 'script' && tag !== 'style' && tag !== 'template') {
        const islandId = node.getAttribute('data-island')
        if (islandId && Island.scopes[islandId]) {
          try { disposeScope(Island.scopes[islandId]) } catch (_) { /* */ }
          delete Island.scopes[islandId]
        }
        if (islandId) {
          const ownerDoc = node.ownerDocument || (typeof document !== 'undefined' ? document : null)
          if (ownerDoc && ownerDoc.querySelectorAll) {
            const comp = ownerDoc.querySelectorAll('script[data-island="' + islandId + '"]')
            for (let ci = 0; ci < comp.length; ci++) {
              if (comp[ci].parentNode) comp[ci].parentNode.removeChild(comp[ci])
            }
          }
        }
      }
    }
    if (node.__islandStops) {
      for (const s of node.__islandStops) s()
      node.__islandStops = []
    }
    if (node.childNodes) {
      for (const child of Array.from(node.childNodes)) stopNode(child, true)
    }
  }

  // ── SVG ───────────────────────────────────────────────────────────────────

  const SVG_NS = 'http://www.w3.org/2000/svg'
  // The HTML parser lowercases every attribute name; for SVG it restores the case
  // of the static names it knows, never of a `:viewBox` binding. A bound SVG
  // attribute is written under its canonical case from this list.
  const SVG_CAMEL_ATTRS = [
    'viewBox', 'preserveAspectRatio', 'patternUnits', 'patternContentUnits', 'patternTransform',
    'gradientUnits', 'gradientTransform', 'spreadMethod', 'markerWidth', 'markerHeight',
    'markerUnits', 'refX', 'refY', 'clipPathUnits', 'maskUnits', 'maskContentUnits',
    'textLength', 'lengthAdjust', 'startOffset', 'baseFrequency', 'numOctaves', 'stdDeviation',
    'tableValues', 'surfaceScale', 'specularConstant', 'specularExponent', 'diffuseConstant',
    'kernelMatrix', 'kernelUnitLength', 'edgeMode', 'pointsAtX', 'pointsAtY', 'pointsAtZ',
    'limitingConeAngle', 'attributeName', 'attributeType', 'repeatCount', 'repeatDur',
    'keyTimes', 'keySplines', 'keyPoints', 'calcMode', 'viewTarget', 'zoomAndPan',
    'primitiveUnits', 'filterUnits', 'xChannelSelector', 'yChannelSelector', 'targetX',
    'targetY', 'pathLength', 'requiredExtensions', 'systemLanguage', 'preserveAlpha',
  ]
  const SVG_ATTR_CASE = new Map(SVG_CAMEL_ATTRS.map((n) => [n.toLowerCase(), n]))
  function svgAttrName(name) { return SVG_ATTR_CASE.get(name.toLowerCase()) || name }

  // ── :class helper ─────────────────────────────────────────────────────────

  function applyClass(el, staticClass, dynVal) {
    // Reset to static classes. setAttribute, not className: on an SVG element
    // className is a read-only SVGAnimatedString.
    el.setAttribute('class', staticClass)
    if (!dynVal) return
    if (typeof dynVal === 'string') {
      dynVal.split(/\s+/).filter(Boolean).forEach(c => el.classList.add(c))
    } else if (Array.isArray(dynVal)) {
      for (const item of dynVal) {
        if (typeof item === 'string') item.split(/\s+/).filter(Boolean).forEach(c => el.classList.add(c))
        else if (item && typeof item === 'object') {
          for (const [cls, truthy] of Object.entries(item)) if (truthy) el.classList.add(cls)
        }
      }
    } else if (typeof dynVal === 'object') {
      for (const [cls, truthy] of Object.entries(dynVal)) if (truthy) el.classList.add(cls)
    }
  }

  // ── :style helper ─────────────────────────────────────────────────────────

  // Convert camelCase key to kebab-case
  function toKebab(key) {
    return key.replace(/([A-Z])/g, m => '-' + m.toLowerCase())
  }

  function applyStyle(el, staticStyle, dynVal) {
    // Restore static style first
    el.style.cssText = staticStyle || ''
    if (!dynVal) return
    if (typeof dynVal === 'string') {
      // append extra string — just combine
      el.style.cssText = (staticStyle || '') + ';' + dynVal
    } else if (typeof dynVal === 'object') {
      for (const [k, v] of Object.entries(dynVal)) {
        if (v === null || v === undefined || v === false) continue
        el.style.setProperty(toKebab(k), String(v))
      }
    }
  }

  function classesFromVal(dynVal) {
    var set = new Set()
    if (!dynVal) return set
    var add = function (s) { String(s).split(/\s+/).filter(Boolean).forEach(function (c) { set.add(c) }) }
    if (typeof dynVal === 'string') add(dynVal)
    else if (Array.isArray(dynVal)) {
      for (var i = 0; i < dynVal.length; i++) {
        var item = dynVal[i]
        if (typeof item === 'string') add(item)
        else if (item && typeof item === 'object') for (var k in item) if (item[k]) set.add(k)
      }
    } else if (typeof dynVal === 'object') {
      for (var k2 in dynVal) if (dynVal[k2]) set.add(k2)
    }
    return set
  }

  // The kebab-case keys a `:style` OBJECT value currently sets. Same purpose as
  // classesFromVal — recover the static cssText base for an adopted node.
  function styleKeysFromVal(dynVal) {
    var set = new Set()
    if (dynVal && typeof dynVal === 'object' && !Array.isArray(dynVal)) {
      for (var k in dynVal) {
        var v = dynVal[k]
        if (v === null || v === undefined || v === false) continue
        set.add(toKebab(k))
      }
    }
    return set
  }

  // Remove the given (kebab) properties from a cssText string.
  function stripStyleKeys(cssText, keys) {
    if (!cssText || !keys || keys.size === 0) return cssText || ''
    return cssText.split(';').map(function (d) { return d.trim() }).filter(Boolean).filter(function (decl) {
      var c = decl.indexOf(':')
      if (c < 0) return true
      return !keys.has(decl.slice(0, c).trim().toLowerCase())
    }).join('; ')
  }

  // v-model target compiles to a real assignment inside `with ($s)`, so any lvalue works.

  const setterCache = new Map()
  function compileSetter(path) {
    let fn = setterCache.get(path)
    if (!fn) {
      try {
        // eslint-disable-next-line no-new-func
        fn = new Function('$s', '$v', 'with ($s) { ' + path + ' = $v }')
      } catch (e) {
        throw new Error('v-model target is not assignable: "' + path + '" (' + e.message + ')')
      }
      setterCache.set(path, fn)
    }
    return fn
  }

  function setPath(scope, path, value) {
    compileSetter(path)(proxyRefs(scope), value)
  }

  // ── v-for item scope ─────────────────────────────────────────────────────

  // The item ref is shallow: the alias IS the element the list yields (Vue parity), so
  // `other.includes(t)` / `===` against another view of the same array hold.
  function shallowItemRef(value) {
    let _value = value
    const r = {
      __v_isRef: true,
      get value() { track(r, 'value'); return _value },
      set value(v) { if (Object.is(v, _value)) return; _value = v; trigger(r, 'value') },
    }
    rawMarked.add(r)
    return r
  }

  // A destructured alias (`[a, b]`, `{ id, name: label }`, one level) binds each name to its slot of the item;
  // same checks as sfc-renderer.ts forAliasBindings: an unsupported pattern binds the whole item, as SSR does.
  const forPatterns = new Map()
  const FOR_IDENT = /^[A-Za-z_$][\w$]*$/
  function forPattern(alias) {
    const open = alias.charAt(0)
    if (open !== '[' && open !== '{') return null
    if (forPatterns.has(alias)) return forPatterns.get(alias)
    let out = []
    if (alias.charAt(alias.length - 1) !== (open === '[' ? ']' : '}')) out = null
    const parts = out ? alias.slice(1, -1).split(',') : []
    for (let i = 0; i < parts.length; i++) {
      const p = parts[i].trim()
      if (!p) continue
      const c = open === '{' ? p.indexOf(':') : -1
      const name = open === '[' ? p : (c >= 0 ? p.slice(c + 1) : p).trim()
      const key = open === '[' ? i : (c >= 0 ? p.slice(0, c) : p).trim()
      if (!FOR_IDENT.test(name) || (open === '{' && !FOR_IDENT.test(key))) { out = null; break }
      out.push([name, key])
    }
    forPatterns.set(alias, out)
    return out
  }
  function bindItemPlain(target, alias, item) {
    const names = forPattern(alias)
    if (!names) { target[alias] = item; return }
    for (let i = 0; i < names.length; i++) target[names[i][0]] = item == null ? undefined : item[names[i][1]]
  }

  function makeItemScope(parentScope, alias, indexAlias, item, idx) {
    const itemRef = shallowItemRef(item)
    const idxRef = ref(idx)
    const childScope = Object.create(parentScope)
    const names = forPattern(alias)
    if (!names) childScope[alias] = itemRef
    else names.forEach(function (n) { childScope[n[0]] = computed(function () { const v = itemRef.value; return v == null ? undefined : v[n[1]] }) })
    if (indexAlias) childScope[indexAlias] = idxRef
    childScope.__itemRef = itemRef
    childScope.__idxRef = idxRef
    return childScope
  }

  // Slot content hydrates in the PARENT scope; outlet :props are computeds over the component
  // scope. Mirrors sfc-renderer.ts buildSlotScope + applySlotBinding.
  function buildSlotScopeClient(parentScope, frameSrc, bindSrc, componentScope) {
    var slotScope = Object.create(parentScope)
    var frame = {}
    try { frame = JSON.parse(frameSrc || '{}') } catch (_) {}
    // slot props = computed() over the COMPONENT scope (reactive to component changes).
    var props = {}
    for (var p in frame) {
      if (!Object.prototype.hasOwnProperty.call(frame, p)) continue
      ;(function (prop, expr) {
        props[prop] = computed(function () { return evaluate(expr, componentScope) })
      })(p, frame[p])
    }
    applySlotBindingClient(slotScope, (bindSrc || '').trim(), props)
    slotScope.__parentScope = parentScope
    return slotScope
  }

  // A fill resolves where it was written: a macro / slot region's own __parentScope, or for an island the scope its
  // instance tag sat in (stamped on its root or lazy placeholder by the parent's hydration), never the enclosing island.
  function slotParent(s) {
    for (var o = s; o; o = Object.getPrototypeOf(o)) {
      if (Object.prototype.hasOwnProperty.call(o, '__islandId')) return islandSlotOwner(o)
      if (Object.prototype.hasOwnProperty.call(o, '__parentScope')) return o.__parentScope
    }
    return s
  }
  function islandSlotOwner(island) {
    var root = island.__rootEl
    for (var el = root; el; el = el.parentElement) {
      if (el.__rtOwnerScope) return el.__rtOwnerScope
      if (el !== root && el.hasAttribute && el.hasAttribute('data-island')) break
    }
    return island.__parentScope || island
  }

  /** Layer slot props onto the slot scope per the fill's binding (computed-ref aware).
   *  Mirrors server applySlotBinding: simple `{ item }`, rename `{ item: alias }`,
   *  default `{ item = expr }`, ident `sp`; warns + skips nested / rest. */
  function applySlotBindingClient(target, binding, props) {
    if (!binding) return
    if (binding.charAt(0) === '{') {
      var inner = binding.replace(/^\{|\}$/g, '')
      var parts = inner.split(',')
      for (var i = 0; i < parts.length; i++) {
        var seg = parts[i].trim(); if (!seg) continue
        if (seg.indexOf('...') === 0) { console.warn('[slots] rest binding "' + seg + '" not supported; use #x="sp"'); continue }
        var eq = seg.indexOf('=')
        var namePart = (eq >= 0 ? seg.slice(0, eq) : seg).trim()
        var defaultExpr = eq >= 0 ? seg.slice(eq + 1).trim() : null
        var colon = namePart.indexOf(':')
        var key = (colon >= 0 ? namePart.slice(0, colon) : namePart).trim()
        var aliasRaw = colon >= 0 ? namePart.slice(colon + 1).trim() : ''
        if (aliasRaw.charAt(0) === '{' || aliasRaw.charAt(0) === '[' || key.charAt(0) === '{' || key.charAt(0) === '[') {
          console.warn('[slots] nested destructure "' + seg + '" not supported; use #x="sp"'); continue
        }
        var name = aliasRaw || key
        // target[name] is a computed ref → proxyRefs auto-unwraps on template read.
        // For a default, wrap so the default applies when the slot prop is absent/undefined.
        ;(function (propKey, defExpr, bindName) {
          if (defExpr) {
            target[bindName] = computed(function () {
              var v = props[propKey] ? props[propKey].value : undefined
              if (v === undefined) { try { return evaluate(defExpr, target) } catch (_) { return undefined } }
              return v
            })
          } else {
            target[bindName] = props[propKey]  // computed ref (or undefined if outlet didn't expose it)
          }
        })(key, defaultExpr, name)
      }
    } else {
      // ident → an object exposing each computed prop. Wrap so `sp.foo` reads the computed value.
      var obj = {}
      for (var k in props) if (Object.prototype.hasOwnProperty.call(props, k)) {
        ;(function (kk) { Object.defineProperty(obj, kk, { get: function () { return props[kk].value }, enumerable: true }) })(k)
      }
      target[binding] = obj
    }
  }

  // ── <transition>: the compiler stamps `data-rt-transition` (+ `-appear`, `-classes` JSON) on the child ──

  function rafNext(fn) {
    if (typeof requestAnimationFrame === 'function') requestAnimationFrame(fn)
    else setTimeout(fn, 16)
  }

  function cssMsList(v) {
    return String(v || '0s').split(',').map(function (x) {
      x = x.trim(); var n = parseFloat(x) || 0
      return /ms$/.test(x) ? n : n * 1000
    })
  }

  function maxTiming(durations, delays) {
    var t = 0
    for (var i = 0; i < durations.length; i++) t = Math.max(t, durations[i] + delays[i % delays.length])
    return t
  }

  function trTimeout(el) {
    var view = el.ownerDocument && el.ownerDocument.defaultView
    if (!view || typeof view.getComputedStyle !== 'function') return 0
    var cs = view.getComputedStyle(el)
    return Math.max(maxTiming(cssMsList(cs.transitionDuration), cssMsList(cs.transitionDelay)),
      maxTiming(cssMsList(cs.animationDuration), cssMsList(cs.animationDelay)))
  }

  function trConfig(el) {
    if (!el || el.nodeType !== 1) return null
    var name = el.getAttribute('data-rt-transition')
    if (name === null) return null
    var given = {}
    try { given = JSON.parse(el.getAttribute('data-rt-transition-classes') || '{}') } catch (_) { /* */ }
    var cfg = {}
    ;['enter', 'leave'].forEach(function (ph) {
      ;['From', 'Active', 'To'].forEach(function (st) {
        var v = given[ph + st] || (name + '-' + ph + '-' + st.toLowerCase())
        cfg[ph + st] = v.split(/\s+/).filter(Boolean)
      })
    })
    return cfg
  }

  function trCancel(el) {
    var rec = el && el.__rtTr
    if (rec) rec.cancel()
  }

  // One phase: -from + -active, next frame -from → -to, end on the element's own transitionend /
  // animationend or the computed duration (0 ms ends in that frame). cancel() never calls done.
  function trRun(el, phase, done) {
    var cfg = trConfig(el)
    if (!cfg) { if (done) done(); return }
    trCancel(el)
    var from = cfg[phase + 'From'], active = cfg[phase + 'Active'], to = cfg[phase + 'To']
    var timer = null, ended = false
    var rec = { phase: phase }
    function clear() {
      el.classList.remove.apply(el.classList, from.concat(active, to))
      if (timer) clearTimeout(timer)
      el.removeEventListener('transitionend', onEnd)
      el.removeEventListener('animationend', onEnd)
      if (el.__rtTr === rec) el.__rtTr = null
    }
    function onEnd(e) { if (e.target === el) rec.finish() }
    rec.cancel = function () { if (!ended) { ended = true; clear() } }
    rec.finish = function () { if (!ended) { ended = true; clear(); if (done) done() } }
    el.__rtTr = rec
    el.classList.add.apply(el.classList, from.concat(active))
    rafNext(function () {
      if (ended) return
      el.classList.remove.apply(el.classList, from)
      el.classList.add.apply(el.classList, to)
      var ms = trTimeout(el)
      if (!ms) { rec.finish(); return }
      el.addEventListener('transitionend', onEnd)
      el.addEventListener('animationend', onEnd)
      timer = setTimeout(rec.finish, ms + 1)
    })
  }

  // ── <teleport>: `<template data-rt-teleport="to">` holds `<!--rt-tp-->…<!--/rt-tp-->` (or the range follows it when
  // rendered disabled). Content binds in this scope first, then moves into a `[data-rt-owner]` box at the target.
  const RE_TP_OPEN = /^rt-tp$/
  const RE_TP_CLOSE = /^\/rt-tp$/

  function mountTeleport(tpl, scope, table) {
    // A template built inside another template's content belongs to an inert document (no body).
    var doc = (typeof document !== 'undefined' && document) || tpl.ownerDocument
    var inTpl = !!(tpl.content && tpl.content.firstChild)
    var start = inTpl ? tpl.content.firstChild : tpl.nextSibling
    if (!isComment(start) || !RE_TP_OPEN.test(commentData(start))) return tpl.nextSibling
    var end = findMarkerClose(start, RE_TP_OPEN, RE_TP_CLOSE)
    var after = inTpl ? tpl.nextSibling : (end ? end.nextSibling : null)
    hydrateRange(start.nextSibling, end, scope, table, doc)
    var to = tpl.getAttribute('data-rt-teleport') || 'body'
    var disExpr = tpl.getAttribute('data-rt-teleport-disabled')
    var box = doc.createElement('div')
    box.setAttribute('data-rt-owner', scope.__islandId || '')
    box.style.display = 'contents'
    var where = null
    var warned = false

    function moveRange(parent, ref) {
      for (var n = start; n;) {
        var nx = n.nextSibling
        parent.insertBefore(n, ref)
        if (n === end || !end) break
        n = nx
      }
    }
    function place(off) {
      var target = null
      if (!off) {
        try { target = to === 'body' ? doc.body : doc.querySelector(to) } catch (_) { target = null }
        if (!target && !warned) { warned = true; console.warn('[teleport] target "' + to + '" not found; rendering in place') }
      }
      if (target) {
        var sc = tpl.closest && tpl.closest('[data-scope]')
        if (sc && !box.hasAttribute('data-scope')) box.setAttribute('data-scope', sc.getAttribute('data-scope'))
        if (where !== 'box') moveRange(box, null)
        if (box.parentNode !== target) target.appendChild(box)
        where = 'box'
      } else if (where !== 'inplace') {
        if (tpl.parentNode) moveRange(tpl.parentNode, tpl.nextSibling)
        if (box.parentNode) box.parentNode.removeChild(box)
        where = 'inplace'
      }
    }

    if (disExpr !== null) nodeEffect(tpl, function () { place(!!evaluate(disExpr, scope)) })
    else place(false)
    // In place, the range is the parent's to remove; moved, it leaves with the template.
    addStop(tpl, function () {
      if (where !== 'box') return
      for (var n = start; n;) {
        var nx = n.nextSibling
        stopNode(n, true)
        if (n.parentNode) n.parentNode.removeChild(n)
        if (n === end || !end) break
        n = nx
      }
      if (box.parentNode) box.parentNode.removeChild(box)
    })
    return after
  }

  // ── Bind a single element's attributes ──────────────────────────────────

  function bindOneDirective(el, name, val, scope, staticClass, staticStyle, toRemove) {
      // ── v-show ──
      if (name === 'v-show') {
        toRemove.push(name)
        const hasTr = !!trConfig(el)
        let shown
        nodeEffect(el, () => {
          const show = !!evaluate(val, scope)
          if (show === shown) return
          const first = shown === undefined
          shown = show
          if (!hasTr || first) { el.style.display = show ? '' : 'none'; return }
          if (show) { trCancel(el); el.style.display = ''; trRun(el, 'enter') }
          else trRun(el, 'leave', () => { el.style.display = 'none' })
        })
        return
      }

      // ── v-text ──
      if (name === 'v-text') {
        toRemove.push(name)
        nodeEffect(el, () => { el.textContent = stringify(evaluate(val, scope)) })
        return
      }

      // ── v-html ──
      if (name === 'v-html' || name === 'v-html.raw') {
        toRemove.push(name)
        const raw = name === 'v-html.raw'
        nodeEffect(el, () => {
          const v = evaluate(val, scope)
          el.innerHTML = raw ? String(v ?? '') : rtSanitizeHtml(stringify(v))
        })
        return
      }

      // ── v-model ──
      if (name === 'v-model' || name.startsWith('v-model.')) {
        toRemove.push(name)
        const mods = name.includes('.') ? name.split('.').slice(1) : []
        const path = val

        // Push scope → DOM
        nodeEffect(el, () => {
          const v = evaluate(path, scope)
          const tag = el.tagName && el.tagName.toLowerCase()
          if (el.type === 'checkbox') {
            el.checked = Array.isArray(v) ? v.includes(el.value) : !!v
          } else if (el.type === 'radio') {
            el.checked = (String(v) === el.value)
          } else {
            el.value = v === null || v === undefined ? '' : String(v)
          }
        })

        // A <select> can only show a value one of its options carries, and options
        // built by a v-for arrive after this effect ran: re-apply the model value
        // whenever the option list (or an option's value) changes.
        if ((el.tagName || '').toLowerCase() === 'select' && typeof MutationObserver === 'function') {
          const reapply = () => {
            const v = evaluate(path, scope)
            const want = v === null || v === undefined ? '' : String(v)
            if (el.value !== want) el.value = want
          }
          const mo = new MutationObserver(reapply)
          mo.observe(el, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] })
          addStop(el, () => mo.disconnect())
        }

        // Pull DOM → scope
        const isCheckbox = el.type === 'checkbox'
        const isRadio = el.type === 'radio'
        const isSelect = (el.tagName || '').toLowerCase() === 'select'
        const eventName = (isCheckbox || isRadio || isSelect || mods.includes('lazy')) ? 'change' : 'input'

        const handler = () => {
          let newVal
          if (isCheckbox) { newVal = el.checked }
          else if (isRadio) { newVal = el.value }
          else { newVal = el.value }
          if (mods.includes('number')) newVal = parseFloat(newVal)
          else if (mods.includes('trim')) newVal = newVal.trim()
          setPath(scope, path, newVal)
        }
        el.addEventListener(eventName, handler)
        // remove listener on teardown
        addStop(el, () => el.removeEventListener(eventName, handler))
        return
      }

      // ── :class ──
      if (name === ':class') {
        toRemove.push(name)
        // An adopted SSR className already holds this :class's dynamic classes; subtract them to recover
        // the static base, or a mount-time class can never be removed.
        const dynNow = classesFromVal(evaluate(val, scope))
        const classBase = (staticClass || '').split(/\s+/).filter(Boolean)
          .filter((c) => !dynNow.has(c)).join(' ')
        nodeEffect(el, () => applyClass(el, classBase, evaluate(val, scope)))
        return
      }

      // ── :style ──
      if (name === ':style') {
        toRemove.push(name)
        // Same adoption trap as :class — strip the keys the current :style sets
        // from the captured cssText so a later removed key isn't baked back in.
        const styleBase = stripStyleKeys(staticStyle || '', styleKeysFromVal(evaluate(val, scope)))
        nodeEffect(el, () => applyStyle(el, styleBase, evaluate(val, scope)))
        return
      }

      // ── :key (consumed by v-for; skip here) ──
      if (name === ':key') { toRemove.push(name); return }

      // ── :attr (generic reactive attribute) ──
      if (name.startsWith(':')) {
        toRemove.push(name)
        const isSvg = el.namespaceURI === SVG_NS
        const attrName = isSvg ? svgAttrName(name.slice(1)) : name.slice(1)
        nodeEffect(el, () => {
          const v = evaluate(val, scope)
          if (typeof v === 'boolean' && isBooleanStringAttr(attrName)) {
            el.setAttribute(attrName, String(v))
          } else if (v === false || v === null || v === undefined) {
            el.removeAttribute(attrName)
          } else if (v === true) {
            el.setAttribute(attrName, '')
          } else {
            el.setAttribute(attrName, String(v))
          }
          // sync DOM property when it exists (SVG properties are read-only animated
          // values — the attribute is the only source of truth there)
          if (!isSvg && attrName in el) { try { el[attrName] = v } catch (_) {} }
          if (attrName === 'src' && el.tagName === 'IMG') rtFileSrcset(el, v)
        })
        return
      }

      // ── @event[.mods] ──
      if (name.startsWith('@')) {
        toRemove.push(name)
        const parts = name.slice(1).split('.')
        const eventType = parts[0]
        const mods = new Set(parts.slice(1))

        // Key filters
        const KEY_MAP = {
          enter: 'Enter', escape: 'Escape', tab: 'Tab', space: ' ',
          up: 'ArrowUp', down: 'ArrowDown', left: 'ArrowLeft', right: 'ArrowRight',
        }
        const keyFilters = parts.slice(1).filter(m => m in KEY_MAP).map(m => KEY_MAP[m])

        const stmt = val
        const listenerOpts = mods.has('once') ? { once: true } : undefined

        const handler = (e) => {
          if (mods.has('self') && e.target !== el) return
          if (keyFilters.length && !keyFilters.includes(e.key)) return
          if (mods.has('prevent')) e.preventDefault()
          if (mods.has('stop')) e.stopPropagation()

          // a method reference or an arrow / function expression is called with the event (Vue parity)
          if (callHandlerRef(stmt.trim(), scope, e) === NOT_REF) runStmt(stmt, scope, e)
        }
        el.addEventListener(eventType, handler, listenerOpts)
        addStop(el, () => el.removeEventListener(eventType, handler, listenerOpts))
        return
      }

      // plain attribute — nothing to bind
  }

  // Vue parity: `aria-*` and the enumerated attributes carry the strings "true" /
  // "false"; removing the attribute on false would change its meaning.
  var BOOLEAN_STRING_ATTRS = new Set(['contenteditable', 'draggable', 'spellcheck'])
  function isBooleanStringAttr(name) { var n = name.toLowerCase(); return n.startsWith('aria-') || BOOLEAN_STRING_ATTRS.has(n) }

  function bindElementAttrs(el, scope, table) {
    const staticClass = (el.getAttribute && el.getAttribute('class')) || ''
    const staticStyle = el.style ? el.style.cssText : ''
    const toRemove = []

    // Deferred directives: a v-for row carries `data-rt-b="<id>"` pointing at a
    // deduped { d:[[name,val],…] } bind-table entry instead of repeating the
    // directive attributes on every row. Bind those first (same dispatch).
    if (el.getAttribute) {
      const refId = el.getAttribute('data-rt-b')
      if (refId != null) {
        toRemove.push('data-rt-b')
        const entry = table && table[parseInt(refId, 10)]
        const pairs = entry && entry.d
        if (pairs) {
          for (let i = 0; i < pairs.length; i++) {
            bindOneDirective(el, pairs[i][0], pairs[i][1], scope, staticClass, staticStyle, toRemove)
          }
        }
      }
    }

    // Live directive attributes (verbatim path — unchanged for non-ref elements).
    const attrs = Array.from(el.attributes)
    for (const attr of attrs) {
      bindOneDirective(el, attr.name, attr.value, scope, staticClass, staticStyle, toRemove)
    }

    for (const n of toRemove) el.removeAttribute(n)
  }


  // Comment-data matchers.
  const RE_T_OPEN = /^t:(\d+)$/
  // if marker carries per-instance active branch: `if:ID` (legacy) or `if:ID|ACTIVE`.
  function parseActive(s) { return s === undefined || s === null ? -1 : parseInt(s, 10) }
  const RE_T_CLOSE = /^\/t$/
  const RE_IF_OPEN = /^if:(\d+)(?:\|(-?\d+))?$/
  const RE_IF_CLOSE = /^\/if$/
  const RE_FOR_OPEN = /^for:(\d+)$/
  const RE_FOR_CLOSE = /^\/for$/
  // `<component :is>`: `is:ID` (client-built) or `is:ID|<encoded name the server rendered>`.
  const RE_IS_OPEN = /^is:(\d+)(?:\|(.*))?$/
  const RE_IS_CLOSE = /^\/is$/
  // A client bundle's `<slot>` outlet: `so:ID` (entry { n | e, f, t }).
  const RE_SO_OPEN = /^so:(\d+)$/
  const RE_SO_CLOSE = /^\/so$/
  // `<template once>` in a client-built branch: `once:ID` (entry { once, t, s? }), always an empty range.
  const RE_ONCE_OPEN = /^once:(\d+)$/
  const RE_ONCE_CLOSE = /^\/once$/

  function isComment(n) { return n && n.nodeType === 8 }
  function commentData(n) { return n ? (n.data || '') : '' }

  // Depth-aware close finder: a nested region of the same kind shares the sibling axis.
  function findMarkerClose(open, openRe, closeRe) {
    let depth = 0
    for (let n = open.nextSibling; n; n = n.nextSibling) {
      if (!isComment(n)) continue
      const cd = commentData(n)
      if (openRe.test(cd)) depth++
      else if (closeRe.test(cd)) { if (depth === 0) return n; depth-- }
    }
    return null
  }

  // The marker pairs that open a span on a sibling axis, with their closes.
  const MARKER_SPANS = [[RE_T_OPEN, RE_T_CLOSE], [RE_IF_OPEN, RE_IF_CLOSE], [RE_FOR_OPEN, RE_FOR_CLOSE], [RE_IS_OPEN, RE_IS_CLOSE], [RE_ONCE_OPEN, RE_ONCE_CLOSE], [RE_SO_OPEN, RE_SO_CLOSE]]

  // Splits a sibling range [start, end) into root units: an element, or a marker span from its open comment
  // to the depth-matched close (inclusive, even when empty). Text and stray comments ride with the unit
  // before them (or the next one), so every node of the range belongs to exactly one unit.
  function rootUnits(start, end) {
    const units = []
    let pending = []
    for (let n = start; n && n !== end; n = n.nextSibling) {
      let unit = null
      if (n.nodeType === 1) unit = [n]
      else if (isComment(n)) {
        const cd = commentData(n)
        for (let i = 0; i < MARKER_SPANS.length && !unit; i++) {
          if (!MARKER_SPANS[i][0].test(cd)) continue
          const close = findMarkerClose(n, MARKER_SPANS[i][0], MARKER_SPANS[i][1])
          unit = [n]
          if (close) { for (let m = n.nextSibling; m && m !== close; m = m.nextSibling) unit.push(m); unit.push(close); n = close }
        }
      }
      if (!unit) { if (units.length) units[units.length - 1].push(n); else pending.push(n); continue }
      units.push(pending.concat(unit))
      pending = []
    }
    if (pending.length && units.length) units[units.length - 1].push.apply(units[units.length - 1], pending)
    return units
  }

  // The first top-level node of a marker-form template, parsed once (no hydration).
  function parseTplNodes(html, d) {
    const probe = d.createElement('template')
    probe.innerHTML = html
    return (probe.content || probe).firstChild
  }

  // Parse a marker-form template into DOM and hydrate it via hydrateChildren (top-level markers
  // too); nodes are collected after hydration since nested if/for may have built more.
  function buildFromTpl(html, scope, table, doc, parent) {
    const tpl = doc.createElement('template')
    // Content that lands inside SVG is parsed inside an <svg> wrapper so the
    // parser puts it in the SVG namespace (and fixes static camelCase attrs);
    // parsed bare it would be inert XHTML elements that never paint.
    const inSvg = !!parent && parent.namespaceURI === SVG_NS && parent.localName !== 'foreignObject'
    tpl.innerHTML = inSvg ? '<svg>' + html + '</svg>' : html
    // template.content holds a DocumentFragment in real DOM + jsdom.
    const content = inSvg ? (tpl.content || tpl).firstChild : (tpl.content || tpl)
    hydrateChildren(content, scope, table)
    const out = []
    let n = content.firstChild
    while (n) { out.push(n); n = n.nextSibling }
    return out
  }

  function hydrateRoot(rootEl, scope, table) {
    if (!rootEl) return
    if (rootEl.nodeType === 11) {
      // DocumentFragment container — walk children.
      hydrateChildren(rootEl, scope, table)
    } else if (rootEl.nodeType === 1) {
      if (rootEl.hasAttribute && rootEl.hasAttribute('data-i-props')) {
        // i-scope root: build the child scope and adopt children against it.
        hydrateNode(rootEl, scope, table)
      } else {
        bindElementAttrs(rootEl, scope, table)
        hydrateChildren(rootEl, scope, table)
      }
    } else {
      hydrateChildren(rootEl, scope, table)
    }
  }

  function hydrateChildren(parent, scope, table) {
    const doc = parent.ownerDocument || (parent.firstChild && parent.firstChild.ownerDocument)
    hydrateRange(parent.firstChild, null, scope, table, doc)
  }

  function hydrateRange(start, end, scope, table, doc) {
    const d = doc || (start && start.ownerDocument)
    let node = start
    while (node && node !== end) {
      // ── Text marker: <!--t:ID-->value<!--/t--> ──
      if (isComment(node)) {
        const data = commentData(node)
        let m
        if ((m = data.match(RE_T_OPEN))) {
          node = hydrateTextMarker(node, parseInt(m[1], 10), scope, table, d)
          continue
        }
        if ((m = data.match(RE_IF_OPEN))) {
          node = hydrateIfMarker(node, parseInt(m[1], 10), parseActive(m[2]), scope, table, d)
          continue
        }
        if ((m = data.match(RE_FOR_OPEN))) {
          node = hydrateForMarker(node, parseInt(m[1], 10), scope, table, d)
          continue
        }
        if ((m = data.match(RE_IS_OPEN))) {
          node = hydrateIsMarker(node, parseInt(m[1], 10), m[2] === undefined ? null : decodeURIComponent(m[2]), scope, table, d)
          continue
        }
        if ((m = data.match(RE_ONCE_OPEN))) {
          node = hydrateOnceMarker(node, parseInt(m[1], 10), scope, table)
          continue
        }
        if ((m = data.match(RE_SO_OPEN))) {
          node = hydrateOutletMarker(node, parseInt(m[1], 10), scope, table, d)
          continue
        }
        // island-slot / unrelated comments — leave untouched.
        node = node.nextSibling
        continue
      }
      // ── Element ──
      if (node.nodeType === 1) {
        node = hydrateNode(node, scope, table)
        continue
      }
      // text / other — leave as-is (no {{ }} scanning on the client).
      node = node.nextSibling
    }
  }

  function hydrateNode(node, scope, table) {
    if (node.nodeType !== 1) {
      // A stray top-level text/comment from buildFromTpl — skip.
      return node.nextSibling
    }
    const el = node
    const next = el.nextSibling

    // Inline lazy placeholder: mounted in place, torn down with its branch (stopNode), so re-showing
    // re-fetches. `data-island-loaded` guards against a double mount.
    if (el.getAttribute &&
        el.getAttribute('data-island-lazy') !== null &&
        el.getAttribute('data-component-name') &&
        el.getAttribute('data-island-loaded') === null) {
      mountLazyInline(el, scope, table)
      return next
    }

    if (el.tagName === 'TEMPLATE' && el.hasAttribute('data-rt-teleport')) return mountTeleport(el, scope, table)

    // Nested island root: never bind this scope into it; its bound props are pushed into the child, and the
    // fills its instance tag carries resolve in this scope (slotParent).
    if (el.hasAttribute && el.hasAttribute('data-island')) {
      el.__rtOwnerScope = scope
      linkNestedIslandProps(el, scope)
      return next
    }

    // <i-slot> hydrates against the scope that authored the fill; checked before data-i-props.
    if (el.hasAttribute && el.hasAttribute('data-slot-frame')) {
      const parentScope = slotParent(scope)
      const frameSrc = el.getAttribute('data-slot-frame') || '{}'
      const bindSrc = el.getAttribute('data-slot-bind') || ''
      el.removeAttribute('data-slot-frame'); el.removeAttribute('data-slot-bind')
      const slotScope = buildSlotScopeClient(parentScope, frameSrc, bindSrc, scope)
      hydrateChildren(el, slotScope, table)
      return next
    }

    // ── i-scope: <... data-i-props="{...}"> child-scope wrapper ──
    if (el.hasAttribute && el.hasAttribute('data-i-props')) {
      const iPropsSrc = el.getAttribute('data-i-props') || '{}'
      let iPropsMap = {}
      try { iPropsMap = JSON.parse(iPropsSrc) } catch (_) {}
      el.removeAttribute('data-i-props')
      const childScope = Object.create(scope)
      childScope.__parentScope = scope
      for (const pk in iPropsMap) {
        if (!Object.prototype.hasOwnProperty.call(iPropsMap, pk)) continue
        const descriptor = iPropsMap[pk]
        if (descriptor && typeof descriptor.expr === 'string') {
          ;(function (propName, expr) {
            childScope[propName] = computed(function () { return evaluate(expr, scope) })
          })(pk, descriptor.expr)
        } else if (descriptor && typeof descriptor.lit === 'string') {
          childScope[pk] = descriptor.lit
        }
      }
      if (iPropsMap.__on && iPropsMap.__on.on) {
        childScope.__modelOn = iPropsMap.__on.on
        childScope.__modelScope = scope
        childScope.emit = makeEmit(childScope)
      }
      bindElementAttrs(el, childScope, table)
      hydrateChildren(el, childScope, table)
      return next
    }

    // ── Bind this element's directive attributes IN PLACE + strip them. ──
    // bindElementAttrs already pushes every directive attr onto its toRemove
    // list and removes them at the end — so the DOM is left clean.
    bindElementAttrs(el, scope, table)

    // ── Recurse into children. ──
    hydrateChildren(el, scope, table)
    if (!scope.__mounted && el.hasAttribute('data-rt-transition-appear') && el.style.display !== 'none') trRun(el, 'enter')
    return next
  }

  function hydrateTextMarker(open, id, scope, table, doc) {
    const expr = table[id]
    const d = doc || open.ownerDocument
    let after = open.nextSibling
    let textNode
    if (after && after.nodeType === 3) {
      textNode = after
    } else {
      // markerTpl case: no text between markers — create an empty one.
      textNode = d.createTextNode('')
      open.parentNode.insertBefore(textNode, after)
    }
    // The matching <!--/t-->. Located ONCE: it is both the return cursor and,
    // below, the anchor this binding re-materialises against.
    let close = textNode.nextSibling
    while (close && !(isComment(close) && RE_T_CLOSE.test(commentData(close)))) close = close.nextSibling

    if (typeof expr === 'string') {
      // Text can be replaced outside the runtime (page translators, extensions). The markers survive,
      // so they decide whether the region exists: if so, restore a fresh text node between them.
      var stop = watchEffect(function () {
        if (!nodeAlive(textNode)) {
          if (!nodeAlive(open) && !nodeAlive(close)) { if (stop) stop(); return }
          if (nodeAlive(open) && nodeAlive(close) && open.parentNode === close.parentNode) {
            var rm = open.nextSibling
            while (rm && rm !== close) {
              var nx = rm.nextSibling
              stopNode(rm, true)
              if (rm.parentNode) rm.parentNode.removeChild(rm)
              rm = nx
            }
          }
          textNode = d.createTextNode('')
          if (nodeAlive(close) && close.parentNode) close.parentNode.insertBefore(textNode, close)
          else if (open.parentNode) open.parentNode.insertBefore(textNode, open.nextSibling)
          else { if (stop) stop(); return }
        }
        textNode.nodeValue = stringify(evaluate(expr, scope))
      })
      // Anchored on the CLOSE marker, not the text node: the text node is the
      // thing that gets replaced, so a disposer left on it would be lost with it
      // and stopNode would never reach this effect at unmount.
      addStop(close || textNode, stop)
    }
    return close ? close.nextSibling : null
  }

  // The fragment renders in this scope the first time its id appears in the document, then its bindings stop: a
  // static snapshot, like the server's. The id expression is read untracked so no enclosing effect re-runs on it.
  var onceWarned = new Set()
  function hydrateOnceMarker(open, id, scope, table) {
    var close = findMarkerClose(open, RE_ONCE_OPEN, RE_ONCE_CLOSE)
    var entry = table[id] || {}
    var doc = (typeof document !== 'undefined' && document) || open.ownerDocument
    var stop = watchEffect(function () {
      var key
      try { key = evaluate(entry.once, scope) } catch (_) { key = undefined }
      if (typeof key !== 'string' || !key) {
        if (!onceWarned.has(entry.once)) { onceWarned.add(entry.once); console.warn('[island] once_id_invalid: <template once="' + entry.once + '"> did not evaluate to a non-empty string') }
        return
      }
      if (onceRegistry(doc).has(key)) return
      var built = buildFromTpl(String(entry.t || ''), scope, table, doc, entry.s ? onceHost(doc, true) : null)
      for (var i = 0; i < built.length; i++) stopNode(built[i])
      ensureOnce(doc, key, built, !!entry.s)
    })
    stop()
    return close ? close.nextSibling : null
  }

  function hydrateIfMarker(open, id, active, scope, table, doc) {
    const entry = table[id]
    const branches = (entry && entry.if) || []
    const d = doc || open.ownerDocument

    // Depth-matched close: a depth-blind scan would orphan every sibling after a nested v-if.
    const close = findMarkerClose(open, RE_IF_OPEN, RE_IF_CLOSE)
    const anchor = close // <!--/if--> is our stable insertion anchor.
    const afterClose = close ? close.nextSibling : null

    let mountedIdx = typeof active === 'number' ? active : -1

    // ORDER MATTERS: this effect is created BEFORE the branch's own bindings (parent-first flush).
    let firstRun = true
    let adoptedGone = false
    const stop = watchEffect(() => {
      // pick the active branch: first truthy cond, or null cond (v-else).
      let picked = -1
      for (let i = 0; i < branches.length; i++) {
        const c = branches[i].c
        if (c === null || c === undefined) { picked = i; break }
        let v
        try { v = evaluate(c, scope) } catch (_) { v = false }
        if (v) { picked = i; break }
      }
      if (picked === mountedIdx) return
      if (firstRun) adoptedGone = true
      // Remove the LIVE range, not a captured array: nested if/for may have built nodes into it.
      let rm = open.nextSibling
      while (rm && rm !== close) {
        const nx = rm.nextSibling
        const leaving = rm
        if (leaving.__rtTr && leaving.__rtTr.phase === 'leave') { leaving.__rtTr.finish(); rm = nx; continue }
        stopNode(leaving, true)
        if (!firstRun && trConfig(leaving)) trRun(leaving, 'leave', () => { if (leaving.parentNode) leaving.parentNode.removeChild(leaving) })
        else if (leaving.parentNode) leaving.parentNode.removeChild(leaving)
        rm = nx
      }
      mountedIdx = picked
      if (picked === -1) return
      // build the chosen branch from its marker-tpl, insert before the anchor.
      const parent = anchor ? anchor.parentNode : open.parentNode
      const built = buildFromTpl(branches[picked].t, scope, table, d, parent)
      for (const bn of built) {
        parent.insertBefore(bn, anchor)
        if (!firstRun && trConfig(bn)) trRun(bn, 'enter')
      }
    })
    firstRun = false
    // Adopt the SSR branch's bindings AFTER the effect above exists, so they
    // sort behind it. Skipped when that first run already replaced the branch:
    // buildFromTpl hydrated what it built, and a second pass would double-bind.
    if (!adoptedGone) hydrateRange(open.nextSibling, close, scope, table, d)
    addStop(anchor || open, stop)
    return afterClose
  }

  // Build what `name` resolves to from the entry's `<rt-is-el>` template: the element re-tagged (native, no hyphen,
  // same rule as sfc-expand isNativeIsName) or a lazy placeholder carrying its attrs as props (tenant component).
  function buildIs(entry, name, scope, table, d, parent) {
    var t = String(entry.t || '')
    if (t.indexOf('<rt-is-el') !== 0 || !/^[a-z][a-z0-9-]*$/i.test(name)) {
      console.warn('[island] <component :is="' + name + '"> is not a valid tag or component name')
      return []
    }
    var native = name.indexOf('-') < 0
    var head = native ? '<' + name : '<div data-island-lazy="" data-component-name="' + name + '"'
    var html = head + t.slice('<rt-is-el'.length).replace(/<\/rt-is-el>$/, native ? '</' + name + '>' : '</div>')
    return buildFromTpl(html, scope, table, d, parent)
  }

  function hydrateIsMarker(open, id, rendered, scope, table, doc) {
    var entry = table[id] && table[id].is
    var d = doc || open.ownerDocument
    var close = findMarkerClose(open, RE_IS_OPEN, RE_IS_CLOSE)
    var afterClose = close ? close.nextSibling : null
    if (!entry) return afterClose
    var mounted = rendered
    var stop = watchEffect(function () {
      var v
      try { v = evaluate(entry.e, scope) } catch (_) { v = '' }
      var name = typeof v === 'string' ? v.trim() : ''
      if (name === mounted) return
      var rm = open.nextSibling
      while (rm && rm !== close) {
        var nx = rm.nextSibling
        stopNode(rm, true)
        if (rm.parentNode) rm.parentNode.removeChild(rm)
        rm = nx
      }
      mounted = name
      if (!name) return
      var parent = close ? close.parentNode : open.parentNode
      var built = buildIs(entry, name, scope, table, d, parent)
      for (var bi = 0; bi < built.length; bi++) parent.insertBefore(built[bi], close)
    })
    if (mounted === rendered && rendered !== null) hydrateRange(open.nextSibling, close, scope, table, d)
    addStop(close || open, stop)
    return afterClose
  }

  // The precompiled fills (`data-comp-local`) of the placeholder a bundle-mounted island was built in, or null.
  function islandLocalFills(s) {
    for (var o = s; o; o = Object.getPrototypeOf(o)) {
      if (!Object.prototype.hasOwnProperty.call(o, '__islandId')) continue
      for (var el = o.__rootEl; el; el = el.parentElement) {
        if (el.__rtLocalFills) return el.__rtLocalFills
        if (el !== o.__rootEl && el.hasAttribute && el.hasAttribute('data-island')) break
      }
      return null
    }
    return null
  }

  // A bundle outlet renders the fill its name picks (matchSlots on the server): the fill's tpl over its own bind
  // table, in the authoring scope plus the outlet's slot props; no fill → the fallback tpl in the component scope.
  function hydrateOutletMarker(open, id, scope, table, doc) {
    var entry = table[id] && table[id].so
    var d = doc || open.ownerDocument
    var close = findMarkerClose(open, RE_SO_OPEN, RE_SO_CLOSE)
    var afterClose = close ? close.nextSibling : null
    if (!entry) return afterClose
    var fills = islandLocalFills(scope)
    var mounted
    var render = function () {
      var name = entry.n
      if (name === null || name === undefined) { try { name = evaluate(entry.e, scope) } catch (_) { name = null } }
      var fill = fills && typeof name === 'string' && Object.prototype.hasOwnProperty.call(fills.s, name) ? fills.s[name] : null
      var key = fill ? name : null
      if (mounted !== undefined && key === mounted) return
      var rm = open.nextSibling
      while (rm && rm !== close) {
        var nx = rm.nextSibling
        stopNode(rm, true)
        if (rm.parentNode) rm.parentNode.removeChild(rm)
        rm = nx
      }
      mounted = key
      var parent = close ? close.parentNode : open.parentNode
      var built = fill
        ? buildFromTpl(fill.t, buildSlotScopeClient(slotParent(scope), entry.f, fill.b || '', scope), fills.e, d, parent)
        : buildFromTpl(entry.t || '', scope, table, d, parent)
      for (var bi = 0; bi < built.length; bi++) parent.insertBefore(built[bi], close)
    }
    if (entry.n !== null && entry.n !== undefined) render()
    else addStop(close || open, watchEffect(render))
    return afterClose
  }

  // MUST stay in lockstep with sfc-renderer.ts::toForArray so SSR and client build identical rows.
  function forArray(v) {
    if (Array.isArray(v)) return v
    if (typeof v === 'number') {
      if (!isFinite(v) || v < 1) return []
      var n = Math.floor(v)
      var out = new Array(n)
      for (var i = 0; i < n; i++) out[i] = i + 1
      return out
    }
    if (v == null || typeof v === 'string') return []
    if (typeof v === 'object' && typeof v[Symbol.iterator] === 'function') return Array.from(v)
    return []
  }

  function hydrateForMarker(open, id, scope, table, doc) {
    const entry = table[id] && table[id].for
    const d = doc || open.ownerDocument
    if (!entry) {
      // unknown — skip to the depth-matched close.
      const skipClose = findMarkerClose(open, RE_FOR_OPEN, RE_FOR_CLOSE)
      return skipClose ? skipClose.nextSibling : null
    }
    const { e: iterExpr, a: alias, i: indexAlias, k: keyExpr, t: tplHtml } = entry

    // How many top-level ROOTS does ONE item have? A `<template v-for>` item can carry several
    // (a main <tr> + a detail <tr>, a group header under v-if + the row). A root is an element or a
    // marker span (`<!--if:…-->…<!--/if-->`, text, nested for…) — a span counts even when SSR left it
    // empty, so a conditional root never skews the grouping. The tpl is static: count it once.
    const rootsPer = Math.max(1, rootUnits(parseTplNodes(tplHtml, d), null).length)

    // collect the mounted root units up to the DEPTH-MATCHED close anchor (a nested v-for inside an
    // item contributes its own open/close pair on this sibling axis — same hazard as the v-if scan).
    const close = findMarkerClose(open, RE_FOR_OPEN, RE_FOR_CLOSE)
    const mountedUnits = rootUnits(open.nextSibling, close)
    const anchor = close
    const afterClose = close ? close.nextSibling : null

    // keyed map: key → { nodes: Node[], childScope } (nodes = ALL of the item's
    // top-level nodes — one per tpl root for adopted items; built items also
    // keep their top-level marker comments so disposers travel with the group).
    const keyedMap = new Map()
    let orderedKeys = []

    // compute a key for an item (by keyExpr against a temp scope, else index).
    function keyFor(item, idx) {
      if (!keyExpr) return idx
      const tmp = Object.create(scope)
      bindItemPlain(tmp, alias, item)
      if (indexAlias) tmp[indexAlias] = idx
      try { return evaluate(keyExpr, tmp) } catch (_) { return idx }
    }

    // Adopt by index (SSR and client share the same data). keyedMap uses the full computed key, never
    // the shortened cosmetic data-rt-key.
    function adoptMountedItems(initialArr) {
      const adoptedCount = Math.floor(mountedUnits.length / rootsPer)
      for (let i = 0; i < adoptedCount; i++) {
        const group = [].concat.apply([], mountedUnits.slice(i * rootsPer, (i + 1) * rootsPer))
        const item = initialArr[i]
        const childScope = makeItemScope(scope, alias, indexAlias, item, i)
        // the group is a contiguous sibling range: markers hydrate through the same walker as a branch
        const last = group[group.length - 1]
        hydrateRange(group[0], last ? last.nextSibling : null, childScope, table, d)
        const key = String(keyFor(item, i))
        keyedMap.set(key, { nodes: group, childScope })
        orderedKeys.push(key)
      }
    }

    // Parent-first as in hydrateIfMarker: adoption runs inside the first pass of this effect.
    let firstRun = true
    const stop = watchEffect(() => {
      let xs
      try { xs = evaluate(iterExpr, scope) } catch (_) { xs = [] }
      const arr = forArray(xs)
      if (firstRun) { firstRun = false; adoptMountedItems(arr) }

      const newKeys = arr.map((item, i) => String(keyFor(item, i)))
      const newKeySet = new Set(newKeys)

      // remove gone keys — every node of the item's group leaves together.
      for (const key of Array.from(orderedKeys)) {
        if (!newKeySet.has(key)) {
          const ent = keyedMap.get(key)
          if (ent) {
            for (const nd of ent.nodes) {
              stopNode(nd, true)
              if (nd.parentNode) nd.parentNode.removeChild(nd)
            }
            keyedMap.delete(key)
          }
        }
      }
      orderedKeys = []

      // insert/update in order (walk forward, insert each group before the
      // anchor's current position by tracking the previous group's LAST node).
      const parent = anchor ? anchor.parentNode : open.parentNode
      let prev = null // node after which we insert; null = right after open marker
      for (let i = 0; i < arr.length; i++) {
        const item = arr[i]
        const key = newKeys[i]
        orderedKeys.push(key)
        let entCur = keyedMap.get(key)
        if (entCur) {
          // update existing — mutate refs so inner bindings react.
          entCur.childScope.__itemRef.value = item
          if (indexAlias) entCur.childScope.__idxRef.value = i
        } else {
          // build a new item from the marker-tpl. Keep ALL top-level nodes —
          // a multi-root item has several element roots, and top-level marker
          // comments (nested if/for) carry their disposers on the anchors.
          const childScope = makeItemScope(scope, alias, indexAlias, item, i)
          const built = buildFromTpl(tplHtml, childScope, table, d, parent)
          // Stamp a SHORTENED cosmetic data-rt-key to match the SSR rows (the
          // marker-tpl omits it). Reconciliation uses the full `key` in keyedMap,
          // not this attribute — so truncating it is purely a display nicety.
          const firstEl = built.find((b) => b.nodeType === 1)
          if (firstEl && firstEl.setAttribute) {
            firstEl.setAttribute('data-rt-key', key.length > 8 ? key.slice(0, 8) : key)
          }
          entCur = { nodes: built, childScope }
          keyedMap.set(key, entCur)
        }
        const target = prev ? prev.nextSibling : (open.nextSibling)
        const groupNodes = entCur.nodes
        if (groupNodes.length && groupNodes[0] !== target) {
          for (const nd of groupNodes) parent.insertBefore(nd, target)
        }
        if (groupNodes.length) prev = groupNodes[groupNodes.length - 1]
      }
    })
    addStop(anchor || open, stop)
    return afterClose
  }


  // `initial` is scope.props as the island seeded it: the compiled setup resets its own top-level bindings
  // (`const props = defineProps()` hoists `__scope.props = undefined`) before this call runs.
  function definePropsIn(scope, initial, decl) {
    var p = initial || scope.props || (scope.props = reactive({}))
    if (!decl || typeof decl !== 'object' || Array.isArray(decl)) return p
    for (var k in decl) {
      var d = decl[k]
      if (p[k] !== undefined || !d || typeof d !== 'object' || !('default' in d)) continue
      var fnType = d.type === Function || d.type === 'function'
      p[k] = typeof d.default === 'function' && !fnType ? d.default() : d.default
    }
    return p
  }

  function __defineComputed(scope, name, getter) {
    scope[name] = computed(getter)
  }

  // MUST match what compileScript may emit as free identifiers; order = parameter positions.
  const SETUP_PARAM_NAMES = [
    '__scope',
    '__defineComputed',
    'ref',
    'reactive',
    'computed',
    'watch',
    'watchEffect',
    'nextTick',
    'onMounted',
    'onBeforeMount',
    'onUnmounted',
    'onBeforeUnmount',
    'onUpdated',
    'onBeforeUpdate',
    'onErrorCaptured',
    'on',
    'emit',
    'provide',
    'inject',
    'ds',
    'useAsyncData',
    'useFetch',
    'markRaw',
    // Framework-globals composables — appended at the end so older compiled
    // setups (which don't reference them) simply receive `undefined` harmlessly.
    'useAppConfig',
    'useRoute',
    // Overlay spawner API — open()/close() spawn & tear down overlay components;
    // closeSelf() closes the calling component's own overlay instance.
    'open',
    'close',
    'closeSelf',
    // $live — isomorphic realtime publish. Server phase publishes in-process;
    // here it delegates to Runtime.live.publish (POST /runtime/live-publish).
    '$live',
    // $redirect/$status — server-only sentinels on the server phase; harmless
    // client-side shims so a setup block referencing them doesn't ReferenceError.
    '$redirect',
    '$status',
    // SEO head helpers — the server phase wrote the head; here they are no-ops so an isomorphic setup never ReferenceErrors.
    'useSeoMeta', 'useHead', 'useJsonLd',
    // beforeLeave(fn) — a leave guard released with the calling scope.
    'beforeLeave',
    // $fmt — the shared formatters (static/fmt.js), bound to the app's locale and timezone.
    '$fmt',
    // toast / commands / useDraft — the UI primitives (Runtime.toast, Runtime.commands, Runtime.draft).
    'toast',
    'commands',
    'useDraft',
    // Shared stores, browser composables (released with the scope) and the i18n lookup.
    'useStore', 'useMediaQuery', 'useLocalStorage', 'useOnline', 'useIdle', 'useClipboard',
    'useGeolocation', 'useDebounceFn', 'useIntervalFn', 'useDocumentVisibility', 'usePresence', 'useInfiniteList', '$t', '$flag',
    // Vue macros as runtime calls: defineProps() is scope.props (declared defaults filled), defineEmits() is emit.
    'defineProps', 'defineEmits',
  ]

  // ── Lifecycle record ──────────────────────────────────────────────────────────

  function makeLifecycleRecord() {
    return {
      onMounted: [],
      onBeforeMount: [],
      onUnmounted: [],
      onBeforeUnmount: [],
      onUpdated: [],
      onBeforeUpdate: [],
      onErrorCaptured: [],
    }
  }

  function lifecycleCollector(lc, key) {
    return function (fn) { if (typeof fn === 'function') lc[key].push(fn) }
  }

  function fireLifecycle(lc, key) {
    for (const fn of lc[key]) {
      try { fn() } catch (e) { console.error('[island] lifecycle error:', e) }
    }
  }

  // ── provide/inject map ────────────────────────────────────────────────────────

  function makeProvideMap() { return new Map() }

  // The provider chain: the DOM-enclosing island, else the scope that open()ed this overlay.
  function provideParent(s) {
    if (s.__parentScope) return s.__parentScope
    var root = s.__rootEl
    if (!root || !root.parentElement) return null
    var pEl = root.parentElement.closest('[data-island]')
    if (pEl) return Island.scopes[pEl.getAttribute('data-island')] || null
    var host = root.closest('[data-overlay-instance]')
    return (host && host.__rtOpenerScope) || null
  }

  // Nearest provider wins, the calling scope included; a provided ref is returned as is (stays reactive).
  function injectFrom(scope, key, fallback) {
    for (var s = scope, hops = 0; s && hops < 64; s = provideParent(s), hops++) {
      if (s.__provides && s.__provides.has(key)) return s.__provides.get(key)
    }
    return fallback
  }


  var eventBus = new Map() // Map<string, Set<fn>>

  function busSubscribe(name, fn) {
    var set = eventBus.get(name)
    if (!set) { set = new Set(); eventBus.set(name, set) }
    set.add(fn)
    return function () {
      var s = eventBus.get(name)
      if (s) { s.delete(fn); if (s.size === 0) eventBus.delete(name) }
    }
  }

  function busFire(name, payload) {
    var set = eventBus.get(name)
    if (!set) return
    // Copy so handlers that subscribe/unsubscribe during dispatch don't mutate
    // the live set mid-iteration.
    for (var fn of Array.from(set)) {
      try { fn(payload) } catch (e) { console.error('[island] event handler error (' + name + '):', e) }
    }
  }

  // Per-scope disposer registry.
  function addDisposer(scope, fn) {
    if (!scope) return
    if (!scope.__disposers) scope.__disposers = []
    scope.__disposers.push(fn)
  }

  // Every teardown path ends here. Idempotent: a mounted scope's hooks run exactly once.
  function disposeScope(scope) {
    if (!scope) return
    var lc = scope.__lifecycle
    var unmount = !!(lc && scope.__mounted && !scope.__unmounted)
    if (unmount) { scope.__unmounted = true; fireLifecycle(lc, 'onBeforeUnmount') }
    var ds = scope.__disposers || []
    scope.__disposers = []
    for (var i = 0; i < ds.length; i++) {
      try { ds[i]() } catch (e) { console.error('[island] disposer error:', e) }
    }
    if (unmount) fireLifecycle(lc, 'onUnmounted')
  }

  // onErrorCaptured: the hooks of every enclosing island see the error of a nested one, nearest first;
  // a hook returning false ends the walk and the global Island.onError report.
  function captureError(scope, id, err) {
    for (var s = scope && provideParent(scope), hops = 0; s && hops < 64; s = provideParent(s), hops++) {
      var hooks = s.__lifecycle ? s.__lifecycle.onErrorCaptured : null
      for (var i = 0; hooks && i < hooks.length; i++) {
        var r
        try { r = hooks[i](err, id) } catch (e) { console.error('[island] onErrorCaptured hook error:', e); continue }
        if (r === false) return true
      }
    }
    return false
  }

  function safeCall(scope, fn) {
    try { return fn() }
    catch (e) {
      var id = (scope && scope.__islandId) || '?'
      if (captureError(scope, id, e)) return
      if (typeof Island.onError === 'function') Island.onError(id, e)
      else console.error('[island]', id, e)
    }
  }

  function makeOn(scope) {
    return function on(trigger, a, b) {
      // 2-arg forms: on('online'|'offline', fn) and on('event:NAME', fn).
      if (b === undefined) {
        var handler2 = a
        if (trigger === 'online' || trigger === 'offline') {
          var win = (scope.__rootEl && scope.__rootEl.ownerDocument && scope.__rootEl.ownerDocument.defaultView) ||
            (typeof window !== 'undefined' ? window : null)
          if (!win) return function () {}
          var fnW = function () { safeCall(scope, handler2) }
          win.addEventListener(trigger, fnW)
          var disW = function () { win.removeEventListener(trigger, fnW) }
          addDisposer(scope, disW)
          return disW
        }
        if (typeof trigger === 'string' && trigger.indexOf('event:') === 0) {
          var wrapped = function (payload) { safeCall(scope, function () { handler2(payload) }) }
          var unsub = busSubscribe(trigger, wrapped)
          addDisposer(scope, unsub)
          return unsub
        }
        console.warn('[island] unsupported on() 2-arg trigger:', trigger)
        return function () {}
      }

      if (trigger === 'interval') {
        var idI = setInterval(function () { safeCall(scope, b) }, a)
        var disI = function () { clearInterval(idI) }
        addDisposer(scope, disI)
        return disI
      }
      if (trigger === 'timeout') {
        var idT = setTimeout(function () { safeCall(scope, b) }, a)
        var disT = function () { clearTimeout(idT) }
        addDisposer(scope, disT)
        return disT
      }
      if (trigger === 'visible' || trigger === 'hidden') {
        var selector = a, handlerV = b
        var docV = (scope.__rootEl && scope.__rootEl.ownerDocument) ||
          (typeof document !== 'undefined' ? document : null)
        var winV = docV && docV.defaultView
        if (!docV || !winV || typeof winV.IntersectionObserver !== 'function') return function () {}
        var ob = new winV.IntersectionObserver(function (entries) {
          for (var ei = 0; ei < entries.length; ei++) {
            var e = entries[ei]
            var isVisible = e.isIntersecting
            if ((trigger === 'visible' && isVisible) || (trigger === 'hidden' && !isVisible)) {
              safeCall(scope, function () { handlerV(e) })
            }
          }
        })
        var observeTargets = function () {
          var targets = (scope.__rootEl || docV).querySelectorAll(selector)
          for (var ti = 0; ti < targets.length; ti++) ob.observe(targets[ti])
        }
        // Defer until the island is mounted: a client-built island has no DOM yet
        // while setup runs, so an eager query would observe nothing.
        if (scope.__lifecycle && !scope.__mounted) scope.__lifecycle.onMounted.push(observeTargets)
        else observeTargets()
        var disV = function () { ob.disconnect() }
        addDisposer(scope, disV)
        return disV
      }

      // Delegated DOM event: on('click', '.sel', handler).
      // Listen at the island root (so events outside the scope don't reach it),
      // falling back to document when no root is recorded.
      var selD = a, handlerD = b
      var rootD = scope.__rootEl ||
        (typeof document !== 'undefined' ? document : null)
      if (!rootD) return function () {}
      var fnD = function (ev) {
        var tgt = ev.target && ev.target.closest ? ev.target.closest(selD) : null
        if (tgt) {
          if (tgt.__rtData !== undefined) ev.data = tgt.__rtData
          safeCall(scope, function () { handlerD(ev) })
        }
      }
      rootD.addEventListener(trigger, fnD)
      var disD = function () { rootD.removeEventListener(trigger, fnD) }
      addDisposer(scope, disD)
      return disD
    }
  }

  // A component `v-model` listener (sfc-expand lowerComponentModel): `.number` keeps a non-numeric value, `.trim` strings only.
  function applyModelUpdate(scope, model, v) {
    var mods = model.mods || []
    if (mods.indexOf('number') >= 0) { var n = parseFloat(v); if (!isNaN(n)) v = n }
    else if (mods.indexOf('trim') >= 0 && typeof v === 'string') v = v.trim()
    setPath(scope, model.path, v)
  }

  // A handler that is one expression returns its value (`save($event)` → the promise); anything else runs as statements.
  var handlerExprCache = new Map()
  function runHandlerStmt(stmt, scope, payload) {
    var src = stmt.trim().replace(/;+$/, '')
    var fn = handlerExprCache.get(src)
    if (fn === undefined) {
      try { fn = new Function('$s', '$event', 'with ($s) { return (' + src + '\n) }') } catch (_) { fn = null }
      handlerExprCache.set(src, fn)
    }
    return fn ? fn(proxyRefs(scope), payload) : runStmt(stmt, scope, payload)
  }

  // `@name="h"` on a component tag: a method reference or an arrow is called with the payload, anything else runs as a statement.
  function runComponentHandler(stmt, scope, payload) {
    var t = stmt.trim()
    try {
      var out = callHandlerRef(t, scope, payload)
      return out !== NOT_REF ? out : runHandlerStmt(stmt, scope, payload)
    } catch (e) { console.error('[island] component @handler "' + t + '" failed:', e) }
  }

  // The listener map arrives after setup when the parent links late: `emit.has` reads a revision so templates re-evaluate.
  var listenerRevs = new WeakMap()
  function listenerRev(scope) {
    var raw = toRaw(scope), r = listenerRevs.get(raw)
    if (!r) { r = ref(0); listenerRevs.set(raw, r) }
    return r
  }

  // `emit` returns the `@event` handler's value (a promise for an async one); `emit.has(name)` says whether the tag listens.
  function makeEmit(scope) {
    var rev = listenerRev(scope)
    function emit(event, payload, opts) {
      var out
      var model = scope.__modelOn && Object.prototype.hasOwnProperty.call(scope.__modelOn, event) ? scope.__modelOn[event] : null
      if (model && typeof model.path === 'string') applyModelUpdate(scope.__modelScope, model, payload)
      if (model && model.handler) out = runComponentHandler(model.handler, scope.__modelScope, payload)
      if (!model || (model.handler && typeof model.path !== 'string')) busFire(event, payload)
      if (opts && opts.bubble && scope.__rootEl) {
        var docE = scope.__rootEl.ownerDocument
        var winE = docE && docE.defaultView
        var Ctor = winE && winE.CustomEvent
        if (Ctor) {
          try {
            scope.__rootEl.dispatchEvent(new Ctor(event, { detail: payload, bubbles: true }))
          } catch (_) { /* */ }
        }
      }
      return out
    }
    emit.has = function (event) {
      void rev.value
      return !!(scope.__modelOn && Object.prototype.hasOwnProperty.call(scope.__modelOn, event))
    }
    return emit
  }

  // ── ds default ───────────────────────────────────────────────────────────────

  let _ds = async function (_uid, _input) {
    throw new Error('ds not configured')
  }


  function parseState(jsonText) {
    if (!jsonText || !jsonText.trim()) return {}
    try { return JSON.parse(jsonText) } catch (_) { return {} }
  }


  // `scopeOf()` names the owning scope: its entries leave the query registry when it is disposed.
  function makeUseAsyncData(state, scopeOf) {
    async function useAsyncData(key, fetcher, opts) {
      opts = opts || {}
      const handle = {
        data:    ref(undefined),
        pending: ref(false),
        error:   ref(null),
        refresh: null,
      }
      var entry = {
        key: key, uids: new Set(), tags: tagList(opts.tags), scope: null, fetchedAt: 0,
        staleTime: opts.staleTime != null ? opts.staleTime : DS_STALE_MS,
        focus: opts.refetchOnFocus !== false, reconnect: opts.refetchOnReconnect !== false,
        get: function () { return handle.data.value },
        set: function (v) { handle.data.value = v },
      }
      var seq = 0

      // Old data stays on screen until the new one lands; a newer run supersedes an older one.
      handle.refresh = async function () {
        var my = ++seq
        handle.pending.value = true
        try {
          var uids = new Set(), prev = queryCollecting, started
          queryCollecting = uids
          try { started = fetcher() } finally { queryCollecting = prev }
          const d = await started
          if (my !== seq) return
          uids.forEach(function (u) { entry.uids.add(u) })
          handle.data.value = d
          handle.error.value = null
          entry.fetchedAt = Date.now()
          if (key) state[key] = { data: d }
          if (entry.scope !== null) queryTouched(entry)
        } catch (e) {
          if (my !== seq) return
          const m = e instanceof Error ? e.message : String(e)
          handle.error.value = m
          if (key) state[key] = { error: m }
        } finally {
          if (my === seq) handle.pending.value = false
        }
      }
      entry.refetch = handle.refresh

      if (key && Object.prototype.hasOwnProperty.call(state, key)) {
        // Resume from dehydration blob — do NOT call fetcher.
        var dehydrated = state[key]
        handle.data.value  = dehydrated.data
        handle.error.value = dehydrated.error != null ? dehydrated.error : null
        tagList(dehydrated.uids).forEach(function (u) { entry.uids.add(u) })
        entry.fetchedAt = Date.now()
      } else {
        // No cached entry — run the fetcher now.
        await handle.refresh()
      }

      var owner = scopeOf ? scopeOf() : null
      if (owner) { entry.scope = owner; queryRegister(owner, entry) }
      return handle
    }

    return useAsyncData
  }

  // ── Default (no-state) stubs — used when no island/state blob is present ──────

  var _defaultState = {}
  var _useAsyncData = makeUseAsyncData(_defaultState)

  async function _useFetch(url, opts) {
    return _useAsyncData(url, async function () {
      const res = await fetch(url, opts)
      return res.json()
    })
  }

  // ── Island.runSetup ───────────────────────────────────────────────────────────

  // Resolves false when the setup failed to compile or threw (the error is already captured or reported).
  async function runSetup(code, scope, apis) {
    if (!code || !code.trim()) return true
    // Build the AsyncFunction with all param names in fixed order.
    // eslint-disable-next-line no-new-func
    const AsyncFunction = Object.getPrototypeOf(async function () {}).constructor
    let fn
    try {
      fn = new AsyncFunction(...SETUP_PARAM_NAMES, code)
    } catch (e) {
      var cid = (scope && scope.__islandId) || (apis && apis.__islandId) || '?'
      if (captureError(scope, cid, e)) return false
      if (typeof Island.onError === 'function') Island.onError(cid, e)
      else console.error('[island] runSetup compile error (id=' + cid + '):', e)
      return false
    }
    // Map param names to their values from apis + defaults.
    const lc = apis.__lifecycle
    const provideMap = apis.__provideMap || makeProvideMap()

    var useHelpers = null
    var seededProps = scope && scope.props
    const args = SETUP_PARAM_NAMES.map(function (name) {
      if (RT_USE_NAMES.indexOf(name) >= 0) return (useHelpers = useHelpers || makeUseHelpers(scope && scope.__disposers ? scope : null))[name]
      switch (name) {
        case '__scope':           return scope
        case '__defineComputed':  return __defineComputed
        case 'ref':               return ref
        case 'reactive':          return reactive
        case 'computed':          return computed
        case 'watch':             return watch
        case 'watchEffect':       return watchEffect
        case 'nextTick':          return nextTick
        case 'onMounted':
        case 'onBeforeMount':
        case 'onUnmounted':
        case 'onBeforeUnmount':
        case 'onUpdated':
        case 'onBeforeUpdate':
        case 'onErrorCaptured':   return lc ? lifecycleCollector(lc, name) : function () {}
        case 'on':                return apis.on || function () {}
        case 'emit':              return apis.emit || function () {}
        case 'provide':           return function (key, val) { provideMap.set(key, val) }
        case 'inject':            return function (key, fallback) { return injectFrom(scope, key, fallback) }
        case 'ds':                return apis.ds || _ds
        case 'useAsyncData':      return apis.useAsyncData || _useAsyncData
        case 'useFetch':          return apis.useFetch || _useFetch
        case 'markRaw':           return markRaw
        case 'useAppConfig':      return apis.useAppConfig || function () { return undefined }
        case 'useRoute':          return apis.useRoute || function () { return undefined }
        case 'open':              return apis.open || Island.open || function () { return Promise.resolve(null) }
        case 'close':             return Island.close || function () {}
        case 'closeSelf':         return apis.closeSelf || function () {}
        case '$live':             return (typeof Runtime !== 'undefined' && Runtime.live) || { publish: function () { return Promise.resolve({ ok: false, reason: 'unsupported' }) } }
        case '$redirect':         return function (p) { if (typeof Runtime !== 'undefined' && Runtime && typeof Runtime.navigate === 'function') Runtime.navigate(p); else if (typeof location !== 'undefined') location.assign(p) }
        case '$status':           return function () { console.warn('[island] $status is server-only; ignored on the client') }
        case 'useSeoMeta':
        case 'useHead':
        case 'useJsonLd':         return function () {}
        case 'beforeLeave':       return apis.beforeLeave || registerLeaveGuard
        case '$fmt':              return rtFmt()
        case 'toast':             return toast
        case 'commands':          return apis.commands || commandsRegister
        case 'useDraft':          return apis.useDraft || function (k, src, o) { return useDraftIn(scope, k, src, o) }
        case '$t':                return rtT()
        case '$flag':             return rtFlag
        case 'defineProps':       return function (decl) { return definePropsIn(scope, seededProps, decl) }
        case 'defineEmits':       return function () { return apis.emit || function () {} }
        default:                  return undefined
      }
    })

    try {
      await fn.apply(null, args)
    } catch (e) {
      const id = apis.__islandId || '?'
      if (captureError(scope, id, e)) return false
      if (typeof Island.onError === 'function') {
        Island.onError(id, e)
      } else {
        console.error('[island] runSetup error (id=' + id + '):', e)
      }
      return false
    }
    return true
  }

  // ── Island.mountIsland ────────────────────────────────────────────────────────

  var JS_RESERVED = new Set(('break case catch class const continue debugger default delete do else enum export extends false finally for function if ' +
    'implements import in instanceof interface let new null package private protected public return static super switch this throw true try typeof var void ' +
    'while with yield await arguments eval').split(' '))
  // A name a `const` declaration can bind (not `row-key`, not `class`).
  function isBindableName(k) { return /^[A-Za-z_$][\w$]*$/.test(k) && !JS_RESERVED.has(k) }
  // Framework globals a prop of the same name never shadows on the scope.
  var PROP_SHADOW_SKIP = new Set(['app', 'tenant', 'user', 'params', 'query', 'route', 'admin', 'props', 'request', 'ds'])

  // id → promise that settles once that island's DOM is hydrated (or its mount
  // ended). A child island whose bound props its parent still has to link waits
  // on its nearest ancestor's entry, so the parent's live values seed it.
  var hydrating = Object.create(null)

  async function mountIsland(rootEl) {
    const id = rootEl.getAttribute('data-island')
    if (!id) return null
    var settle
    var hydrated = new Promise(function (r) { settle = r })
    if (!hydrating[id]) hydrating[id] = hydrated
    try {
      return await mountIslandBody(rootEl, id, settle)
    } finally {
      settle()
      if (hydrating[id] === hydrated) delete hydrating[id]
    }
  }

  // `{"p":[fragments],"e":[entries]}` (serializeBindTable): a `{"$t":["lit",0]}` leaf (or fragment) joins literals and pool refs.
  function expandBindPool(raw) {
    if (Array.isArray(raw) || !raw || !Array.isArray(raw.e)) return raw || []
    var pool = raw.p || []
    function frag(i) {
      if (typeof pool[i] !== 'string') pool[i] = walk(pool[i])
      return pool[i]
    }
    function walk(v) {
      if (Array.isArray(v)) { for (var i = 0; i < v.length; i++) v[i] = walk(v[i]); return v }
      if (!v || typeof v !== 'object') return v
      if (Array.isArray(v.$t)) {
        var s = ''
        for (var j = 0; j < v.$t.length; j++) s += typeof v.$t[j] === 'number' ? frag(v.$t[j]) : v.$t[j]
        return s
      }
      for (var k in v) v[k] = walk(v[k])
      return v
    }
    return walk(raw.e)
  }

  // `<script type="island/setup" src>`: an immutable shell/component asset, fetched once per URL (the head preloads it).
  var islandAssetTexts = Object.create(null)
  function islandAssetText(url) {
    if (!islandAssetTexts[url]) {
      islandAssetTexts[url] = fetch(url).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status)
        return r.text()
      })
      islandAssetTexts[url].catch(function () { delete islandAssetTexts[url] })
    }
    return islandAssetTexts[url]
  }

  async function mountIslandBody(rootEl, id, settleHydrated) {

    const doc = rootEl.ownerDocument

    // Find the companion scripts.
    const setupEl = doc.querySelector('script[type="island/setup"][data-island="' + id + '"]')
    const bindEl = doc.querySelector('script[type="island/bind"][data-island="' + id + '"]')
    const stateEl = doc.querySelector('script[type="island/state"][data-island="' + id + '"]')
    // CLIENT-MODE marker: `<script setup client>` ships the marker-form template
    // here instead of resolved SSR HTML, so this island BUILDS its root instead
    // of adopting it (see the build branch below).
    const tplEl = doc.querySelector('script[type="island/tpl"][data-island="' + id + '"]')

    // A static island may wrap setup-component islands; soft-nav mounts only the page root, so
    // recurse here or their handlers stay unbound.
    if (!setupEl) {
      settleHydrated()
      await start(rootEl)
      return null
    }

    // Stamp mounted synchronously, before any await, so a concurrent start() pass skips this root.
    if (rootEl.getAttribute('data-island-mounted') !== null) return Island.scopes[id] || null
    rootEl.setAttribute('data-island-mounted', '')

    // Claim every island root inside a client-mode fallback synchronously too — except the kept
    // SSR page islands of a client shell and everything inside them (contains(), bounded to rootEl).
    if (tplEl) {
      var keepRoots = rootEl.querySelectorAll('[data-island^="page:"]')
      var stale = rootEl.querySelectorAll('[data-island]:not([data-island-mounted])')
      for (var si = 0; si < stale.length; si++) {
        var inKept = false
        for (var kj = 0; kj < keepRoots.length; kj++) {
          if (keepRoots[kj] === stale[si] || keepRoots[kj].contains(stale[si])) { inKept = true; break }
        }
        if (inKept) continue
        stale[si].setAttribute('data-island-mounted', '')
      }
    }

    if (rootEl.hasAttribute('data-props-bind') || rootEl.hasAttribute('data-props-on')) {
      var owner = rootEl.parentElement && rootEl.parentElement.closest('[data-island]')
      var ownerHydrated = owner && hydrating[owner.getAttribute('data-island')]
      if (ownerHydrated) await ownerHydrated
    }

    var setupCode = setupEl.textContent || ''
    var setupSrc = setupEl.getAttribute('src')
    if (setupSrc && !setupCode) {
      try { setupCode = await islandAssetText(setupSrc) } catch (err) {
        console.error('[island] ' + id + ': setup asset ' + setupSrc + ' did not load (' + ((err && err.message) || err) + ')')
        return null
      }
    }

    // Parse the bind table (numeric-id → text expr / structural descriptor).
    // Parsed INSIDE this realm so the resulting array/objects belong to the
    // document's realm (matters for jsdom test harnesses).
    var table = []
    try { table = expandBindPool(JSON.parse(bindEl ? bindEl.textContent || '[]' : '[]')) } catch (_) { table = [] }

    // Parse the dehydrated state blob (may be empty / absent).
    const islandState = parseState(stateEl ? stateEl.textContent || '' : '')

    // Build per-island useAsyncData that closes over islandState.
    const islandUseAsyncData = makeUseAsyncData(islandState, function () { return scope })
    const islandUseFetch = async function (url, opts) {
      return islandUseAsyncData(url, async function () {
        const res = await fetch(url, opts)
        return res.json()
      })
    }

    // Build scope + lifecycle record.
    const scope = {}
    // Identity + DOM root for the on/emit event bus (delegated DOM listeners +
    // IntersectionObserver target queries are rooted here; error reporting uses the id).
    scope.__islandId = id
    scope.__rootEl = rootEl
    scope.__disposers = []
    const lc = makeLifecycleRecord()
    // Published on the scope so setup-time APIs that need a BUILT DOM (on('visible')
    // queries the island subtree) can defer themselves to onMounted — a client-mode
    // island has no DOM at all while setup runs.
    scope.__lifecycle = lc
    scope.__mounted = false
    const provideMap = makeProvideMap()
    scope.__provides = provideMap
    // Settles once this scope is registered: a nested island's setup waits for it to `inject` (concurrent start passes).
    var settleSetup
    rootEl.__rtSetup = new Promise(function (r) { settleSetup = r })

    const globalsEl = doc.querySelector('script[type="island/globals"][data-island="' + id + '"]')
    const globals = parseState(globalsEl ? globalsEl.textContent || '' : '')
    for (var gk in globals) {
      if (!Object.prototype.hasOwnProperty.call(globals, gk)) continue
      var gv = globals[gk]
      scope[gk] = (gv !== null && typeof gv === 'object') ? reactive(gv) : gv
    }
    liveGlobalsTrack(scope)
    var propLink = propLinks[id]
    if (propLink) { delete propLinks[id]; propLink.scope = scope; adoptModelLink(scope, propLink) }
    if (globals.props && typeof globals.props === 'object' && !Array.isArray(globals.props)) {
      var rawProps = Object.assign({}, globals.props)
      if (propLink && propLink.seed) {
        for (var sk in propLink.seed) {
          var sv = toRaw(propLink.seed[sk])
          rawProps[sk] = sv
          var sc = camelizeProp(sk)
          if (sc !== sk && !Object.prototype.hasOwnProperty.call(propLink.exprs, sc)) rawProps[sc] = sv
        }
      }
      var propsProxy = reactive(rawProps)
      scope.props = propsProxy
      var linked = new Set()
      if (propLink) for (var lk in propLink.exprs) { linked.add(lk); linked.add(camelizeProp(lk)) }
      Object.keys(rawProps).forEach(function (pk) {
        if (PROP_SHADOW_SKIP.has(pk) || !isBindableName(pk)) return
        if (!Object.prototype.hasOwnProperty.call(globals, pk) && !linked.has(pk)) return
        Object.defineProperty(scope, pk, {
          configurable: true,
          enumerable: true,
          get: function () { return propsProxy[pk] },
          set: function (v) { Object.defineProperty(scope, pk, { value: v, writable: true, configurable: true, enumerable: true }) },
        })
      })
    }

    function _useAppConfig() {
      return scope['app']
    }
    function _useRoute() {
      if (scope['route']) return scope['route']
      return { params: scope['params'] || {}, query: scope['query'] || {}, path: '' }
    }

    const apis = {
      __islandId: id,
      __lifecycle: lc,
      __provideMap: provideMap,
      ds: makeScopedDs(scope, Island.ds || Runtime.ds || _ds),
      useAsyncData: Island.useAsyncData || islandUseAsyncData,
      useFetch: Island.useFetch || islandUseFetch,
      on: makeOn(scope),
      emit: makeEmit(scope),
      useAppConfig: Island.useAppConfig || _useAppConfig,
      useRoute: Island.useRoute || _useRoute,
      // closeSelf() — close THIS island's overlay host (when it was spawned via open()).
      closeSelf: function () { if (scope.__overlayHost) destroyOverlayHost(scope.__overlayHost) },
      beforeLeave: function (fn) { var off = registerLeaveGuard(fn); addDisposer(scope, off); return off },
      open: function (name, props) { return open(name, props, scope) },
      commands: function (list) { var off = commandsRegister(list); addDisposer(scope, off); return off },
      useDraft: function (key, src, o) { return useDraftIn(scope, key, src, o) },
    }

    // Instance APIs live on the scope so template handlers resolve them; assigned before setup so a
    // same-named user binding wins.
    var HANDLER_APIS = { closeSelf: apis.closeSelf, emit: apis.emit, on: apis.on, open: apis.open, close: close, ds: apis.ds, $live: Runtime.live, $fmt: rtFmt(), $t: rtT(), $flag: rtFlag, toast: toast,
      provide: function (key, val) { provideMap.set(key, val) }, inject: function (key, fallback) { return injectFrom(scope, key, fallback) } }
    for (var __ak in HANDLER_APIS) { if (!(__ak in scope)) scope[__ak] = HANDLER_APIS[__ak] }

    // Globals prologue: free references (`user`, `app`) in setup resolve to the seeded scope values.
    const globalKeys = Object.keys(globals)
    var globalsProlog = ''
    if (globalKeys.length > 0) {
      globalsProlog = globalKeys.filter(isBindableName).map(function (k) {
        return 'const ' + k + ' = __scope[' + JSON.stringify(k) + '];'
      }).join(' ') + ' '
    }
    // Server-function stubs (island/fns): `const notify = __scope["notify"]` in the
    // setup prologue AND on the scope so template handlers (`@click="notify(x)"`,
    // evaluated with `with (proxyRefs(scope))`) resolve the same stub.
    var fnsEl = doc.querySelector('script[type="island/fns"][data-island="' + id + '"]')
    var fnsMeta = parseState(fnsEl ? fnsEl.textContent || '' : '')
    var fnsProlog = ''
    if (fnsMeta && typeof fnsMeta.ref === 'string' && Array.isArray(fnsMeta.names)) {
      for (var fi = 0; fi < fnsMeta.names.length; fi++) {
        var fnName = fnsMeta.names[fi]
        // hasOwnProperty, not `in`: `in` walks the prototype chain, so an export
        // named `toString` / `constructor` / `valueOf` would look "already bound"
        // and silently ship no stub.
        if (typeof fnName !== 'string' || !/^[A-Za-z_$][\w$]*$/.test(fnName) || Object.prototype.hasOwnProperty.call(scope, fnName)) continue
        scope[fnName] = serverFn(fnsMeta.ref, fnName)
        fnsProlog += 'const ' + fnName + ' = __scope[' + JSON.stringify(fnName) + ']; '
      }
    }
    // Linked before setup so `inject` in setup reaches the enclosing island's provides.
    var pEl = rootEl.parentElement && rootEl.parentElement.closest('[data-island]')
    if (pEl) {
      var pId = pEl.getAttribute('data-island')
      if (!Island.scopes[pId] && pEl.__rtSetup) {
        await Promise.race([pEl.__rtSetup, new Promise(function (r) { setTimeout(r, 3000) })])
      }
      if (Island.scopes[pId]) scope.__parentScope = Island.scopes[pId]
    }
    var setupOk = true
    try {
      // A one-line prolog keeps a setup frame at code line + 3 (engine/script-cache.ts SETUP_FRAME_OFFSET).
      if (setupCode.trim()) setupOk = await runSetup(globalsProlog + fnsProlog + '\n' + setupCode, scope, apis)
    } finally {
      // A failed setup must not hold a nested island for the full ceiling.
      if (!Island.scopes[id]) Promise.resolve().then(settleSetup)
    }


    // Fire onBeforeMount.
    fireLifecycle(lc, 'onBeforeMount')

    // Stored before hydrating so a nested island can find this scope as its __parentScope.
    Island.scopes[id] = scope
    settleSetup()

    if (tplEl && !setupOk) {
      // A client-built island whose setup failed paints nothing: its fallback goes, no template is built.
      while (rootEl.firstChild) { stopNode(rootEl.firstChild, true); rootEl.removeChild(rootEl.firstChild) }
    } else if (tplEl) {
      var tplJson = parseState(tplEl.textContent || '')
      var tplHtml = tplJson && typeof tplJson.t === 'string' ? tplJson.t : ''
      // A malformed / truncated island/tpl would otherwise blank the island
      // silently — the fallback is torn down and nothing replaces it.
      if (!tplHtml) console.warn('[island] empty or malformed island/tpl for "' + id + '" — the island will render empty')
      // 1. Keep ONLY the SSR page island (client SHELL case); everything else in the
      //    fallback is torn down with it.
      var keep = Array.prototype.slice.call(rootEl.querySelectorAll('[data-island^="page:"]')).filter(function (el) {
        var t = el.tagName && el.tagName.toLowerCase(); return t !== 'script' && t !== 'style' && t !== 'template'
      })
      for (var ki = 0; ki < keep.length; ki++) keep[ki].parentNode.removeChild(keep[ki])
      // 2. Tear the fallback down properly (stopNode disposes nested islands + their scripts).
      while (rootEl.firstChild) { stopNode(rootEl.firstChild, true); rootEl.removeChild(rootEl.firstChild) }
      // 3. Build + append synchronously (lazy placeholders / nodeAlive need an attached tree).
      var built = buildFromTpl(tplHtml, scope, table, doc, rootEl)
      for (var bi = 0; bi < built.length; bi++) rootEl.appendChild(built[bi])
      // 4. Re-splice the kept page island at the shell's slot anchor.
      respliceKeptIslands(rootEl, keep)
    } else {
      await hydrateRoot(rootEl, scope, table)
    }
    settleHydrated()

    // Fire onMounted.
    fireLifecycle(lc, 'onMounted')
    scope.__mounted = true
    // Parent changes that landed while this island was fetching / setting up.
    if (propLink && propLink.scope === scope) flushPropLink(propLink)

    // Mount any nested island roots the rebuilt template brought into the DOM
    // (inline fragments, or a page island spliced into a shell's <slot>) — one
    // pass, so a single top-level start() hydrates the whole tree.
    await start(rootEl)

    return scope
  }

  // ── Hydration scheduling ─────────────────────────────────────────────────────
  // Top-level roots of one pass mount in parallel; each parent mounts its own nested roots (its start()).

  var deferredRoots = new WeakSet()

  function isDeferredMode(mode) { return mode === 'visible' || mode === 'idle' || mode === 'interaction' }

  /** 'visible' | 'idle' | 'interaction' for a component root carrying data-hydrate; page and shell islands are always eager. */
  function hydrateMode(el) {
    var id = el.getAttribute('data-island') || ''
    if (id.indexOf('page:') === 0 || id.indexOf('shell:') === 0) return null
    var mode = el.getAttribute('data-hydrate')
    return isDeferredMode(mode) ? mode : null
  }

  // Any of these inside the inert root starts the mount; a click (or submit) that lands before the mount
  // settles is held and re-dispatched on its target afterwards, so the first tap still acts.
  var INTERACTION_TRIGGERS = ['pointerdown', 'focusin', 'keydown', 'click', 'submit']
  function whenInteracted(el, mount) {
    var held = [], started = false
    function onEvent(e) {
      if (e.__rtReplayed) return
      if (e.type === 'click' || e.type === 'submit') { held.push(e); e.preventDefault(); e.stopPropagation() }
      if (started) return
      started = true
      Promise.resolve().then(mount).then(finish, finish)
    }
    function finish() {
      for (var i = 0; i < INTERACTION_TRIGGERS.length; i++) el.removeEventListener(INTERACTION_TRIGGERS[i], onEvent, true)
      for (var j = 0; j < held.length; j++) {
        var orig = held[j], t = orig.target
        if (!t || t.isConnected === false) continue
        var Ctor = orig.constructor || Event
        var ev
        try { ev = new Ctor(orig.type, orig) } catch (_) { ev = new Event(orig.type, { bubbles: true, cancelable: true }) }
        ev.__rtReplayed = true
        t.dispatchEvent(ev)
      }
      held = []
    }
    for (var i = 0; i < INTERACTION_TRIGGERS.length; i++) el.addEventListener(INTERACTION_TRIGGERS[i], onEvent, true)
  }

  async function mountRoot(el) {
    // A prior mount may have handled this node, or detached it (a shell rebuild swaps in a fresh page island).
    if (el.getAttribute('data-island-mounted') !== null || el.isConnected === false) return
    try {
      await mountIsland(el)
    } catch (e) {
      const id = el.getAttribute('data-island') || '?'
      if (captureError(Island.scopes[id] || { __rootEl: el }, id, e)) return
      if (typeof Island.onError === 'function') {
        Island.onError(id, e)
      } else {
        console.error('[island] mountIsland error (id=' + id + '):', e)
      }
    }
  }

  /** One observer per pass, so lazy roots of a soft-navigated page are observed by that page's start(). */
  function makeDeferrer() {
    var observer = null
    var idle = typeof requestIdleCallback === 'function'
      ? function (fn) { requestIdleCallback(fn, { timeout: 3000 }) }
      : function (fn) { setTimeout(fn, 1) }
    return function defer(el, mode) {
      deferredRoots.add(el)
      if (mode === 'interaction') { whenInteracted(el, function () { return mountRoot(el) }); return }
      if (mode === 'visible' && typeof IntersectionObserver === 'function') {
        if (!observer) {
          observer = new IntersectionObserver(function (entries) {
            for (var i = 0; i < entries.length; i++) {
              if (!entries[i].isIntersecting) continue
              observer.unobserve(entries[i].target)
              mountRoot(entries[i].target)
            }
          }, { rootMargin: '200px' })
        }
        observer.observe(el)
        return
      }
      idle(function () { mountRoot(el) })
    }
  }

  async function mountRoots(roots) {
    var inPass = new Set(roots)
    var defer = makeDeferrer()
    function nearestRoot(el) {
      for (var p = el.parentElement; p; p = p.parentElement) if (inPass.has(p)) return p
      return null
    }
    function run(el) {
      var mode = hydrateMode(el)
      if (!mode) return mountRoot(el)
      if (!deferredRoots.has(el)) defer(el, mode)
      return null
    }
    await Promise.all(roots.filter(function (el) { return !nearestRoot(el) }).map(run))
    // A nested root whose parent mounted (or failed) without reaching it; never inside a still-deferred parent.
    for (const el of roots) {
      var parent = nearestRoot(el)
      if (parent && parent.getAttribute('data-island-mounted') !== null && el.getAttribute('data-island-mounted') === null) await run(el)
    }
  }

  // ── Island.start ─────────────────────────────────────────────────────────────

  async function start(root) {
    const searchRoot = root || (typeof document !== 'undefined' ? document : null)
    if (!searchRoot) return
    // F18 — adopt the server-emitted library tags into the asset registry
    // (page-scoped ones are released on the first soft-nav away).
    if (!root) bootRegisterSsrAssets()
    // Select only actual container elements (not <script> companion tags which also carry data-island).
    const roots = Array.from(searchRoot.querySelectorAll('[data-island]:not([data-island-mounted])')).filter(function (el) {
      const tag = el.tagName && el.tagName.toLowerCase()
      return tag !== 'script' && tag !== 'style' && tag !== 'template'
    })
    await mountRoots(roots)
    if (!root && typeof window !== 'undefined') {
      markCurrentLinks(searchRoot, window, window.location.pathname)
      restoreBootScroll(window)
      viewportPrefetchArm(searchRoot)
    }
  }

  var componentBaseUrl = '/runtime/component/'
  var openCounter = 0

  function overlayLayer(doc) {
    var d = doc || document
    var layer = d.getElementById('i-overlay-layer')
    if (!layer) {
      layer = d.createElement('div')
      layer.id = 'i-overlay-layer'
      // The layer hangs off <body>, outside the shell's font wrapper: overlays read the app's `--app-font` token.
      layer.style.fontFamily = 'var(--app-font, inherit)'
      d.body.appendChild(layer)
    }
    return layer
  }

  function rtAppUid() { return rtReadMeta('rt-app-uid') || '' }

  // Component CSS is keyed by the payload's per-instance scopeId and ref-counted, so a second
  // instance never reuses #1's rules and the <style> leaves with the last holder.
  var compStyleRefs = Object.create(null)

  // Keys reach the DOM as an element id, so keep them to id-safe characters
  // (`#` in `component-<uid>#<inst>` is the reason this exists).
  function compStyleId(key) { return 'i-comp-style-' + String(key).replace(/[^A-Za-z0-9_-]/g, '_') }

  function injectComponentCss(css, key) {
    if (!css || !key || typeof document === 'undefined') return
    var id = compStyleId(key)
    compStyleRefs[key] = (compStyleRefs[key] || 0) + 1
    if (document.getElementById(id)) return // already injected for this key
    var s = document.createElement('style')
    s.id = id
    s.setAttribute('data-comp-style', key)
    s.textContent = css
    ;(document.head || document.documentElement).appendChild(s)
  }

  // ── Once fragments (sfc-once.ts): `[data-rt-once="svg"] > defs` and `[data-rt-once="html"]`, each fragment led by
  // `<!--o:KEY-->`. Fragments are shared and tiny, so they are never removed.
  function onceRegistry(doc) {
    if (doc.__rtOnce) return doc.__rtOnce
    var keys = new Set()
    var boxes = doc.querySelectorAll('[data-rt-once]')
    for (var i = 0; i < boxes.length; i++) {
      var host = boxes[i].getAttribute('data-rt-once') === 'svg' ? (boxes[i].querySelector('defs') || boxes[i]) : boxes[i]
      for (var n = host.firstChild; n; n = n.nextSibling) {
        if (n.nodeType === 8 && n.data.indexOf('o:') === 0) { try { keys.add(decodeURIComponent(n.data.slice(2))) } catch (_) { /* */ } }
      }
    }
    doc.__rtOnce = keys
    return keys
  }

  function onceHost(doc, svg) {
    var box = doc.querySelector('[data-rt-once="' + (svg ? 'svg' : 'html') + '"]')
    if (!box) {
      if (svg) {
        box = doc.createElementNS(SVG_NS, 'svg')
        box.setAttribute('width', '0'); box.setAttribute('height', '0')
        box.setAttribute('style', 'position:absolute'); box.setAttribute('aria-hidden', 'true')
        box.appendChild(doc.createElementNS(SVG_NS, 'defs'))
      } else {
        box = doc.createElement('div')
        box.setAttribute('hidden', '')
      }
      box.setAttribute('data-rt-once', svg ? 'svg' : 'html')
      var body = doc.body || doc.documentElement
      body.insertBefore(box, body.firstChild)
    }
    return svg ? (box.querySelector('defs') || box) : box
  }

  // Adds fragment `key` (markup or built nodes) unless the document already has it; true when it was added.
  function ensureOnce(doc, key, content, svg) {
    var keys = onceRegistry(doc)
    if (keys.has(key)) return false
    keys.add(key)
    var host = onceHost(doc, svg)
    var nodes = content
    if (typeof content === 'string') {
      var t = doc.createElement('template')
      t.innerHTML = svg ? '<svg>' + content + '</svg>' : content
      var from = svg ? t.content.firstChild : t.content
      nodes = []
      for (var n = from ? from.firstChild : null; n; n = n.nextSibling) nodes.push(n)
    }
    host.appendChild(doc.createComment('o:' + encodeURIComponent(key)))
    for (var i = 0; i < nodes.length; i++) host.appendChild(nodes[i])
    return true
  }

  // A payload's `once` map ({ id: { html, svg } }: soft-nav, /runtime/component, a bundle's fallback).
  function mergeOnce(map) {
    if (!map || typeof document === 'undefined') return
    for (var k in map) {
      if (Object.prototype.hasOwnProperty.call(map, k) && map[k]) ensureOnce(document, k, String(map[k].html || ''), !!map[k].svg)
    }
  }

  // Drop one instance's hold on a key's <style>; remove it at zero.
  function releaseComponentCss(key) {
    if (!key || typeof document === 'undefined' || !compStyleRefs[key]) return
    compStyleRefs[key]--
    if (compStyleRefs[key] <= 0) {
      delete compStyleRefs[key]
      var el = document.getElementById(compStyleId(key))
      if (el && el.parentNode) el.parentNode.removeChild(el)
    }
  }

  // Asset registry: url → { el, kind, scope, owners, loaded }; owner `app` is never released.
  // A JS tag at zero owners is RETAINED (re-inserting would re-execute it); CSS/font tags are removed.
  var assetRefs = Object.create(null)
  var assetsBootDone = false
  var ASSET_LOAD_TIMEOUT_MS = 15000

  function assetUrlOf(el) {
    var t = el.tagName && el.tagName.toLowerCase()
    return t === 'script' ? el.getAttribute('src') : el.getAttribute('href')
  }
  function assetOwnerCount(e) { return Object.keys(e.owners).length }
  function cssEscapeAttr(v) { return String(v).replace(/\\/g, '\\\\').replace(/"/g, '\\"') }

  // Adopt the tags the server emitted into the initial document.
  function bootRegisterSsrAssets() {
    if (assetsBootDone || typeof document === 'undefined' || !document.querySelectorAll) return
    assetsBootDone = true
    var tags = document.querySelectorAll('[data-rt-asset]')
    for (var i = 0; i < tags.length; i++) {
      var el = tags[i], url = assetUrlOf(el)
      if (!url) continue
      var scope = el.getAttribute('data-rt-asset') || 'app'
      var owner = scope === 'app' ? 'app' : (el.getAttribute('data-rt-asset-owner') || 'app')
      var e = assetRefs[url]
      if (!e) {
        e = assetRefs[url] = {
          el: el, kind: (el.tagName.toLowerCase() === 'script') ? 'js' : 'css', scope: scope, owners: {}, loaded: null,
        }
      }
      e.owners[owner] = 1
    }
  }

  // Resolve when the tag has loaded (or failed — a broken CDN URL must not
  // block the island mount forever; the failure is logged and mount proceeds).
  function waitAssetLoad(el, url) {
    return new Promise(function (resolve) {
      var done = false
      function finish(ok) {
        if (done) return
        done = true
        if (!ok) console.warn('[runtime] asset failed to load: ' + url)
        resolve()
      }
      el.addEventListener('load', function () { finish(true) })
      el.addEventListener('error', function () { finish(false) })
      // Runtime.assets.timeoutMs is overridable (tests; slow CDNs).
      var ms = (Runtime.assets && Runtime.assets.timeoutMs) || ASSET_LOAD_TIMEOUT_MS
      setTimeout(function () { finish(false) }, ms)
    })
  }

  function createAssetEl(a) {
    var el
    if (a.kind === 'js') {
      el = document.createElement('script')
      el.src = a.url
      // Dynamically inserted scripts default to async — keep the declared
      // order (library A before plugin B) unless the operator asked for async.
      el.async = !!a.jsAsync
      if (a.jsDefer) el.defer = true
    } else {
      el = document.createElement('link')
      el.rel = 'stylesheet'
      el.href = a.url
      if (a.media) el.media = a.media
    }
    if (a.integrity) { el.integrity = a.integrity; el.crossOrigin = 'anonymous' }
    return el
  }

  // Acquire every asset in `list` for `ownerId`; resolves once all are loaded.
  function acquireAssets(list, ownerId) {
    bootRegisterSsrAssets()
    if (!list || !list.length || typeof document === 'undefined') return Promise.resolve()
    var waits = []
    for (var i = 0; i < list.length; i++) {
      var a = list[i]
      if (!a || typeof a.url !== 'string' || !a.url) continue
      var scope = a.scope || 'app'
      var owner = scope === 'app' ? 'app' : (ownerId || 'app')
      var e = assetRefs[a.url]
      if (!e) {
        // A tag someone else put in the document (hand-authored in the shell,
        // an older server) — adopt it rather than loading the URL twice.
        var sel = a.kind === 'js'
          ? 'script[src="' + cssEscapeAttr(a.url) + '"]'
          : 'link[rel="stylesheet"][href="' + cssEscapeAttr(a.url) + '"]'
        var existing = document.querySelector(sel)
        if (existing) {
          e = assetRefs[a.url] = { el: existing, kind: a.kind === 'js' ? 'js' : 'css', scope: scope, owners: {}, loaded: null }
        }
      }
      if (e) {
        e.owners[owner] = 1
        if (e.el) {
          e.el.removeAttribute('data-rt-asset-retained')
          if (!e.el.getAttribute('data-rt-asset')) e.el.setAttribute('data-rt-asset', e.scope)
          if (owner !== 'app' && !e.el.getAttribute('data-rt-asset-owner')) e.el.setAttribute('data-rt-asset-owner', owner)
        }
        if (e.loaded) waits.push(e.loaded)
        continue
      }
      var el = createAssetEl(a)
      el.setAttribute('data-rt-asset', scope)
      if (owner !== 'app') el.setAttribute('data-rt-asset-owner', owner)
      e = assetRefs[a.url] = { el: el, kind: a.kind === 'js' ? 'js' : 'css', scope: scope, owners: {}, loaded: null }
      e.owners[owner] = 1
      e.loaded = waitAssetLoad(el, a.url)
      var target = (a.location === 'body' && document.body) ? document.body : (document.head || document.documentElement)
      target.appendChild(el)
      waits.push(e.loaded)
    }
    return Promise.all(waits).then(function () { /* settled */ })
  }

  // Drop `ownerId`'s hold on every asset; at zero owners a non-app CSS/font
  // tag is removed, a JS tag is retained (see caveat above).
  function releaseAssets(ownerId) {
    if (!ownerId || ownerId === 'app') return
    var urls = Object.keys(assetRefs)
    for (var i = 0; i < urls.length; i++) {
      var e = assetRefs[urls[i]]
      if (!e.owners[ownerId]) continue
      delete e.owners[ownerId]
      if (assetOwnerCount(e) > 0 || e.scope === 'app') continue
      if (e.kind === 'js') {
        if (e.el) { e.el.setAttribute('data-rt-asset-retained', ''); e.el.removeAttribute('data-rt-asset-owner') }
        continue
      }
      if (e.el && e.el.parentNode) e.el.parentNode.removeChild(e.el)
      delete assetRefs[urls[i]]
    }
  }

  // Inspection: [{ url, kind, scope, owners: [...], retained }].
  function listAssets() {
    bootRegisterSsrAssets()
    return Object.keys(assetRefs).map(function (u) {
      var e = assetRefs[u]
      return { url: u, kind: e.kind, scope: e.scope, owners: Object.keys(e.owners), retained: !!(e.el && e.el.hasAttribute('data-rt-asset-retained')) }
    })
  }

  // Component fetches issued in the same tick share ONE POST <base minus '/'>-batch/<app> (a lone fetch keeps the single
  // route); each caller gets its own { status, body } slot, so 401/404 handling and the ReadCache stay per item.
  var COMPONENT_BATCH_MAX = 25
  var componentQueues = {}
  function postComponent(base, appUid, name, bodyObj) {
    var key = base + appUid
    var q = componentQueues[key]
    if (!q) {
      q = componentQueues[key] = []
      setTimeout(function () {
        delete componentQueues[key]
        for (var i = 0; i < q.length; i += COMPONENT_BATCH_MAX) sendComponents(base, appUid, q.slice(i, i + COMPONENT_BATCH_MAX))
      }, 0)
    }
    return new Promise(function (resolve, reject) { q.push({ name: name, body: bodyObj || {}, resolve: resolve, reject: reject }) })
  }
  function sendComponents(base, appUid, items) {
    var single = items.length === 1
    var url = single ? base + appUid + '/' + encodeURIComponent(items[0].name) : base.replace(/\/$/, '') + '-batch/' + appUid
    var payload = single ? items[0].body : { calls: items.map(function (it) { return Object.assign({}, it.body, { name: it.name }) }) }
    fetch(url, { method: 'POST', headers: rtAdminTargetHeaders({ 'Content-Type': 'application/json' }), body: JSON.stringify(payload), credentials: 'include' })
      .then(function (res) {
        return res.json().then(function (data) {
          var results = !single && res.ok && data && Array.isArray(data.results) && data.results.length === items.length ? data.results : null
          items.forEach(function (it, i) {
            var r = single || !results ? { status: res.status, body: data } : results[i] || {}
            it.resolve({ status: r.status, ok: r.status >= 200 && r.status < 300, data: r.body })
          })
        })
      })
      .catch(function (e) { items.forEach(function (it) { it.reject(e) }) })
  }

  async function fetchComponentPayload(name, bodyObj, opts) {
    var appUid = rtAppUid()
    var cacheKey = 'comp:' + name + ':' + ReadCache.keyOf(bodyObj || {})
    var res, data
    try {
      res = await postComponent(Island.componentBaseUrl || componentBaseUrl, appUid, name, bodyObj)
      data = res.data
    } catch (e) {
      if (ReadCache.enabled()) {
        var hit = await ReadCache.get(cacheKey)
        if (hit && hit.value) return hit.value
      }
      throw e
    }
    if (res && res.status === 401) {
      // Expired / revoked end-user session — bounce to the sign-in page, same
      // as Runtime.ds(). The background prewarm passes silent401: a warmup 401
      // (auth-gated component fetched from a public page) must NOT redirect.
      if (!(opts && opts.silent401)) Runtime.onUnauthorized()
      var unauth = new Error('Unauthorized'); unauth.status = 401
      throw unauth
    }
    if (res && res.ok && data && data.html && ReadCache.enabled()) {
      ReadCache.put(cacheKey, data) // fire-and-forget
    }
    return data
  }

  // A call identical to one in flight (name + props) shares its promise. A tenant component already open is
  // focused and its handle returned; `ui-*` system overlays stack (a confirmation over a dialog).
  var openPending = Object.create(null)
  function open(name, props, fromScope) {
    var key = null
    try { key = name + '|' + ReadCache.keyOf(props || {}) } catch (_) { /* uncomparable props never join */ }
    if (key !== null && openPending[key]) return openPending[key]
    var single = String(name).indexOf('ui-') !== 0
    var live = single && typeof document !== 'undefined' ? openInstanceOf(name) : null
    if (live) { if (live.hasAttribute('data-rt-modal')) dialogFocus(live, 0); return Promise.resolve(live.__rtHandle || null) }
    var p = openMount(name, props, fromScope)
    if (key !== null) { openPending[key] = p; var clear = function () { if (openPending[key] === p) delete openPending[key] }; p.then(clear, clear) }
    return p
  }

  function openInstanceOf(name) {
    var layer = document.getElementById('i-overlay-layer')
    var hosts = layer ? layer.querySelectorAll('[data-overlay-instance]:not([data-rt-persistent])') : []
    for (var i = hosts.length - 1; i >= 0; i--) if (hosts[i].getAttribute('data-component-name') === name && !hosts[i].__rtDestroyed) return hosts[i]
    return null
  }

  async function openMount(name, props, fromScope) {
    var opener = typeof document !== 'undefined' ? document.activeElement : null
    var data
    try {
      data = await fetchComponentPayload(name, { props: props || {} })
    } catch (e) { console.error('[island] open() fetch error:', e); return null }
    var html = data && data.html ? data.html : ''
    if (!html) return null
    // scoped CSS ships separately from html, keyed by this render's island id
    var cssKey = (data && typeof data.scopeId === 'string' && data.scopeId) || name
    injectComponentCss(data && data.css, cssKey)
    mergeOnce(data && data.once)
    // F18 — the component's libraries must be loaded BEFORE its setup runs.
    try { await acquireAssets(data && data.assets, cssKey) } catch (e) { console.warn('[island] open() asset load error:', e) }

    var host = document.createElement('div')
    host.setAttribute('data-overlay-instance', String(++openCounter))
    host.setAttribute('data-component-name', name)
    host.setAttribute('data-comp-css-key', cssKey)
    if (fromScope) host.__rtOpenerScope = fromScope
    host.innerHTML = html
    var scripts = Array.prototype.slice.call(host.querySelectorAll('script[type^="island/"]'))
    for (var i = 0; i < scripts.length; i++) {
      var o = scripts[i], c = document.createElement('script')
      c.type = o.type
      if (o.getAttribute('data-island')) c.setAttribute('data-island', o.getAttribute('data-island'))
      c.textContent = o.textContent
      document.body.appendChild(c); if (o.parentNode) o.parentNode.removeChild(o)
    }
    overlayLayer(document).appendChild(host)
    await start(host)

    var root = host.querySelector('[data-island]')
    if (root) {
      var sid = root.getAttribute('data-island')
      if (sid && Island.scopes[sid]) Island.scopes[sid].__overlayHost = host
    }
    dialogOpened(host, opener)
    host.__rtHandle = { id: host.getAttribute('data-overlay-instance'), name: name, close: function () { destroyOverlayHost(host) } }
    return host.__rtHandle
  }

  // Closing plays the leave phase of every <transition> element in the overlay (ui-dialog / ui-sheet roots), then
  // tears down; the host ignores input meanwhile and a second close is a no-op.
  function destroyOverlayHost(host) {
    if (!host || host.__rtDestroyed || host.__rtLeaving) return
    var leaving = Array.prototype.filter.call(host.querySelectorAll('[data-rt-transition]'), function (el) { return !!trConfig(el) })
    if (!leaving.length) { teardownOverlayHost(host); return }
    host.__rtLeaving = true
    host.style.pointerEvents = 'none'
    var left = leaving.length
    leaving.forEach(function (el) { trRun(el, 'leave', function () { if (--left === 0) teardownOverlayHost(host) }) })
  }

  function teardownOverlayHost(host) {
    if (host.__rtDestroyed) return
    host.__rtDestroyed = true
    var roots = Array.prototype.slice.call(host.querySelectorAll('[data-island]')).filter(function (el) {
      var t = el.tagName && el.tagName.toLowerCase(); return t !== 'script' && t !== 'style' && t !== 'template'
    })
    for (var i = 0; i < roots.length; i++) {
      var id = roots[i].getAttribute('data-island')
      if (id && Island.scopes[id]) disposeScope(Island.scopes[id])
      stopNode(roots[i])
      if (id) {
        delete Island.scopes[id]
        var comp = Array.prototype.slice.call(document.querySelectorAll('script[data-island="' + id + '"]'))
        for (var k = 0; k < comp.length; k++) if (comp[k].parentNode) comp[k].parentNode.removeChild(comp[k])
      }
    }
    if (host.parentNode) host.parentNode.removeChild(host)
    // Release this instance's hold on its injected <head> <style> and libraries.
    releaseComponentCss(host.getAttribute('data-comp-css-key') || host.getAttribute('data-component-name'))
    releaseAssets(host.getAttribute('data-comp-css-key'))
    dialogClosed(host)
  }

  function close(target) {
    if (!target) return
    if (typeof target === 'object' && typeof target.close === 'function') { target.close(); return }
    var hosts = Array.prototype.slice.call(document.querySelectorAll('[data-overlay-instance][data-component-name="' + target + '"]'))
    for (var i = 0; i < hosts.length; i++) destroyOverlayHost(hosts[i])
  }

  function closeAllOverlays() {
    var layer = (typeof document !== 'undefined') ? document.getElementById('i-overlay-layer') : null
    if (!layer) return
    var hosts = Array.prototype.slice.call(layer.querySelectorAll('[data-overlay-instance]:not([data-rt-persistent])'))
    for (var i = 0; i < hosts.length; i++) destroyOverlayHost(hosts[i])
  }

  // ── Accessibility: page focus after navigation + open() as a modal dialog ─────
  var FOCUSABLE_SEL = 'a[href], button:not([disabled]), input:not([disabled]):not([type=hidden]), ' +
    'select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
  var scrollLockPrev = null
  var dialogKeysInstalled = false

  function ensureA11yStyle() {
    if (typeof document === 'undefined' || document.querySelector('style[data-rt-a11y]')) return
    var st = document.createElement('style')
    st.setAttribute('data-rt-a11y', '')
    st.textContent = '[data-island][tabindex="-1"]:focus,[data-overlay-instance][tabindex="-1"]:focus,h1[tabindex="-1"]:focus{outline:none}'
    ;(document.head || document.documentElement).appendChild(st)
  }

  function focusQuietly(el) {
    try { if (el && typeof el.focus === 'function') el.focus({ preventScroll: true }) } catch (_) { /* */ }
  }

  function focusPageRoot(root) {
    if (!root || typeof document === 'undefined' || !root.isConnected) return
    ensureA11yStyle()
    if (root.contains(document.activeElement)) return
    // The page's first heading announces the new page; the island root (whose name would be all its text) is the last resort.
    var target = root.querySelector('[data-rt-focus]') || root.querySelector('h1')
    if (!target) target = root
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1')
    focusQuietly(target)
  }

  // A [data-rt-focus] may arrive inside a lazily fetched component: without one yet, focus waits for the page's
  // in-flight component mounts (at most LATE_FOCUS_WAIT_MS), then applies the rule above — unless the user (or a
  // dialog) moved focus during the wait.
  var LATE_FOCUS_WAIT_MS = 1500
  function focusPageRootSettled(root, live) {
    if (!root || root.querySelector('[data-rt-focus]') || !lateMountsIn(root).length) { focusPageRoot(root); return }
    var before = document.activeElement
    settleLateMounts(root, LATE_FOCUS_WAIT_MS).then(function () {
      var now = document.activeElement
      if (live() && (now === before || !now || now === document.body)) focusPageRoot(root)
    })
  }

  function overlayRoot(host) {
    var els = host.querySelectorAll('[data-island]')
    for (var i = 0; i < els.length; i++) {
      var t = els[i].tagName.toLowerCase()
      if (t !== 'script' && t !== 'style' && t !== 'template') return els[i]
    }
    return null
  }

  // A control hidden by CSS (a mobile-only back button on desktop) cannot take focus: with a layout engine
  // only rendered controls count; without one (jsdom) every control does.
  function focusablesIn(host) {
    var layout = !!(document.body && document.body.getClientRects && document.body.getClientRects().length)
    return Array.prototype.filter.call(host.querySelectorAll(FOCUSABLE_SEL), function (el) {
      if (el.closest('[hidden],[inert]')) return false
      return !layout || el.getClientRects().length > 0
    })
  }

  function topModalHost() {
    var all = document.querySelectorAll('[data-rt-modal]')
    return all.length ? all[all.length - 1] : null
  }

  function lockScroll() {
    var de = document.documentElement
    if (de.hasAttribute('data-rt-scroll-lock')) return
    // clientWidth is 0 without layout; the scrollbar gap is only measurable when it is not.
    var gap = de.clientWidth ? Math.max(0, (window.innerWidth || 0) - de.clientWidth) : 0
    scrollLockPrev = { overflow: de.style.overflow, paddingRight: de.style.paddingRight }
    de.style.overflow = 'hidden'
    if (gap) de.style.paddingRight = gap + 'px'
    de.setAttribute('data-rt-scroll-lock', '')
  }

  function unlockScroll() {
    var de = document.documentElement
    if (!de.hasAttribute('data-rt-scroll-lock')) return
    de.style.overflow = scrollLockPrev ? scrollLockPrev.overflow : ''
    de.style.paddingRight = scrollLockPrev ? scrollLockPrev.paddingRight : ''
    de.removeAttribute('data-rt-scroll-lock')
    scrollLockPrev = null
  }

  // Escape listens in the bubble phase: a popup inside the dialog that handles it (preventDefault) closes first.
  function onDialogEscape(e) {
    var host = topModalHost()
    if (!host || e.key !== 'Escape' || e.defaultPrevented) return
    if (host.hasAttribute('data-rt-no-escape') || overlayFlag(host, 'data-rt-no-escape')) return
    e.preventDefault()
    if (host.hasAttribute('data-overlay-instance')) destroyOverlayHost(host)
    else if (typeof host.__rtDismiss === 'function') host.__rtDismiss('escape')
  }

  function onDialogKey(e) {
    var host = topModalHost()
    if (!host || e.key !== 'Tab') return
    var items = focusablesIn(host)
    var active = document.activeElement
    if (!items.length) { e.preventDefault(); focusQuietly(host); return }
    var first = items[0], last = items[items.length - 1]
    if (!host.contains(active)) { e.preventDefault(); focusQuietly(e.shiftKey ? last : first) }
    else if (e.shiftKey && (active === first || active === host)) { e.preventDefault(); focusQuietly(last) }
    else if (!e.shiftKey && active === last) { e.preventDefault(); focusQuietly(first) }
  }

  // A flag sits on the component's template root (or on the island wrapper itself).
  function overlayFlag(host, name) {
    var root = overlayRoot(host)
    if (!root) return false
    var first = root.firstElementChild
    return root.hasAttribute(name) || !!(first && first.hasAttribute(name))
  }

  // A host is modal unless its component root carries `data-rt-nonmodal` (toast, popover).
  function dialogOpened(host, opener) {
    if (!host.isConnected || overlayFlag(host, 'data-rt-nonmodal')) return
    host.setAttribute('role', 'dialog')
    host.setAttribute('aria-modal', 'true')
    host.setAttribute('data-rt-modal', '')
    host.__rtOpener = opener && opener !== document.body ? opener : null
    ensureA11yStyle()
    if (!dialogKeysInstalled) { dialogKeysInstalled = true; document.addEventListener('keydown', onDialogKey, true); document.addEventListener('keydown', onDialogEscape) }
    lockScroll()
    dialogFocus(host, 0)
    toastReplace()
  }

  // A dialog whose content mounts or animates in after open() gets a second and third try (0 / 150 / 400 ms).
  var DIALOG_FOCUS_RETRY_MS = [150, 400]
  function dialogFocus(host, attempt) {
    if (!host.isConnected) return
    if (attempt > 0 && host.contains(document.activeElement)) return
    var target = host.querySelector('[autofocus]') || focusablesIn(host)[0]
    if (!target) { host.setAttribute('tabindex', '-1'); target = host }
    focusQuietly(target)
    var next = DIALOG_FOCUS_RETRY_MS[attempt]
    if (next && (!host.contains(document.activeElement) || target === host)) setTimeout(function () { dialogFocus(host, attempt + 1) }, next)
  }

  function dialogClosed(host) {
    if (!host.hasAttribute('data-rt-modal') || typeof document === 'undefined') return
    modalEnd(host)
  }

  function modalEnd(host) {
    if (!topModalHost()) unlockScroll()
    var opener = host.__rtOpener
    host.__rtOpener = null
    if (opener && opener.isConnected) focusQuietly(opener)
    toastReplace()
  }

  // Runtime.modal(el, { dismissible, onDismiss }): an in-page element joins the open() dialog stack —
  // role=dialog, focus trap, Escape → onDismiss('escape'), scroll lock, focus back to the opener on release().
  function modalAttach(el, opts) {
    var o = opts || {}
    if (!el || typeof document === 'undefined') return { release: function () {} }
    var opener = document.activeElement
    el.setAttribute('role', 'dialog')
    el.setAttribute('aria-modal', 'true')
    el.setAttribute('data-rt-modal', '')
    if (o.dismissible === false) el.setAttribute('data-rt-no-escape', '')
    el.__rtDismiss = typeof o.onDismiss === 'function' ? o.onDismiss : null
    el.__rtOpener = opener && opener !== document.body && !el.contains(opener) ? opener : null
    ensureA11yStyle()
    if (!dialogKeysInstalled) { dialogKeysInstalled = true; document.addEventListener('keydown', onDialogKey, true); document.addEventListener('keydown', onDialogEscape) }
    lockScroll()
    dialogFocus(el, 0)
    toastReplace()
    return {
      release: function () {
        if (!el.hasAttribute('data-rt-modal')) return
        el.removeAttribute('data-rt-modal')
        el.__rtDismiss = null
        modalEnd(el)
      },
    }
  }

  // ── UI primitives: floating panels, toasts, command palette, form drafts ─────
  function rtRaf(fn) { return (typeof requestAnimationFrame === 'function') ? requestAnimationFrame(fn) : setTimeout(fn, 16) }
  function rtCaf(id) { if (typeof cancelAnimationFrame === 'function') cancelAnimationFrame(id); else clearTimeout(id) }
  var FLOAT_OPPOSITE = { top: 'bottom', bottom: 'top', left: 'right', right: 'left' }

  function floatCoords(a, w, h, side, align, off) {
    var x, y
    if (side === 'top' || side === 'bottom') {
      y = side === 'top' ? a.top - h - off : a.bottom + off
      x = align === 'start' ? a.left : align === 'end' ? a.right - w : a.left + (a.width - w) / 2
    } else {
      x = side === 'left' ? a.left - w - off : a.right + off
      y = align === 'start' ? a.top : align === 'end' ? a.bottom - h : a.top + (a.height - h) / 2
    }
    return { x: x, y: y }
  }

  function floatFits(c, w, h, side, vw, vh, pad) {
    if (side === 'top' || side === 'bottom') return c.y >= pad && c.y + h <= vh - pad
    return c.x >= pad && c.x + w <= vw - pad
  }

  function clampTo(v, lo, hi) { return hi < lo ? lo : Math.min(Math.max(v, lo), hi) }

  // Runtime.float(anchor, panel, { placement: 'bottom-start', offset: 6, flip: true, shift: true, padding: 8 }).
  function floatPanel(anchor, panel, opts) {
    var o = opts || {}
    var parts = String(o.placement || 'bottom').split('-')
    var side0 = FLOAT_OPPOSITE[parts[0]] ? parts[0] : 'bottom', align = parts[1] || 'center'
    var off = o.offset == null ? 6 : Number(o.offset), pad = o.padding == null ? 8 : Number(o.padding)
    var frame = 0, done = false, current = side0
    function update() {
      if (done) return null
      if (!anchor || !panel || !anchor.isConnected || !panel.isConnected) { destroy(); return null }
      var a = anchor.getBoundingClientRect(), p = panel.getBoundingClientRect()
      var vw = window.innerWidth || document.documentElement.clientWidth, vh = window.innerHeight || document.documentElement.clientHeight
      var side = side0, c = floatCoords(a, p.width, p.height, side, align, off)
      if (o.flip !== false && !floatFits(c, p.width, p.height, side, vw, vh, pad)) {
        var alt = FLOAT_OPPOSITE[side], c2 = floatCoords(a, p.width, p.height, alt, align, off)
        if (floatFits(c2, p.width, p.height, alt, vw, vh, pad)) { side = alt; c = c2 }
      }
      if (o.shift !== false) {
        if (side === 'top' || side === 'bottom') c.x = clampTo(c.x, pad, vw - p.width - pad)
        else c.y = clampTo(c.y, pad, vh - p.height - pad)
      }
      current = side
      panel.style.position = 'fixed'
      panel.style.left = Math.round(c.x) + 'px'
      panel.style.top = Math.round(c.y) + 'px'
      panel.setAttribute('data-placement', side + (align === 'center' ? '' : '-' + align))
      return { x: Math.round(c.x), y: Math.round(c.y), placement: side }
    }
    function schedule() { if (!done && !frame) frame = rtRaf(function () { frame = 0; update() }) }
    function destroy() {
      if (done) return
      done = true
      if (frame) rtCaf(frame)
      window.removeEventListener('scroll', schedule, true)
      window.removeEventListener('resize', schedule)
    }
    window.addEventListener('scroll', schedule, true)
    window.addEventListener('resize', schedule)
    update()
    return { update: update, destroy: destroy, get placement() { return current }, get active() { return !done } }
  }

  // Toasts: the queue lives here; <ui-toast>, mounted once through open(), renders it (event:rt-toast).
  var TOAST_TONES = { info: 1, success: 1, warning: 1, error: 1 }
  var TOAST_VISIBLE = 3
  var toastState = { items: [], seq: 0, host: null, mounting: null }

  function toastView() {
    return toastState.items.slice(0, TOAST_VISIBLE).map(function (t) {
      var acts = []
      if (t.action && t.action.label) acts.push({ key: 'action', label: String(t.action.label) })
      if (t.undo) acts.push({ key: 'undo', label: 'Deshacer' })
      return { id: t.id, message: t.message, tone: t.tone, actions: acts, dismissible: t.dismissible }
    })
  }

  function toastFind(id) { for (var i = 0; i < toastState.items.length; i++) if (toastState.items[i].id === Number(id)) return toastState.items[i]; return null }

  function toastArm(t) {
    if (t.timer || t.paused || !(t.remaining > 0) || t.remaining === Infinity) return
    t.startedAt = Date.now()
    t.timer = setTimeout(function () { t.timer = null; toastDismiss(t.id) }, t.remaining)
  }

  function toastSync() {
    for (var i = 0; i < toastState.items.length && i < TOAST_VISIBLE; i++) toastArm(toastState.items[i])
    busFire('event:rt-toast', toastView())
    if (toastState.host) rtRaf(toastPlace)
  }

  function toastDismiss(id) {
    var t = toastFind(id)
    if (!t) return
    if (t.timer) clearTimeout(t.timer)
    toastState.items.splice(toastState.items.indexOf(t), 1)
    toastSync()
  }

  function toastPause(id) {
    var t = toastFind(id)
    if (!t || t.paused) return
    t.paused = true
    if (t.timer) { clearTimeout(t.timer); t.timer = null; t.remaining = Math.max(0, t.remaining - (Date.now() - t.startedAt)) }
  }

  function toastResume(id) {
    var t = toastFind(id)
    if (!t || !t.paused) return
    t.paused = false
    if (toastState.items.indexOf(t) < TOAST_VISIBLE) toastArm(t)
  }

  function toastAct(id, key) {
    var t = toastFind(id)
    if (!t) return
    var fn = key === 'undo' ? t.undo : (t.action && t.action.onClick)
    toastDismiss(id)
    if (typeof fn === 'function') { try { fn() } catch (e) { console.error('[island] toast action error:', e) } }
  }

  function ensureToastHost() {
    if (toastState.host && toastState.host.isConnected) return
    if (toastState.mounting || typeof document === 'undefined') return
    toastState.mounting = open('ui-toast', {}).then(function (h) {
      toastState.mounting = null
      var el = h && document.querySelector('[data-overlay-instance="' + h.id + '"]')
      if (el) el.setAttribute('data-rt-persistent', '')
      toastState.host = el || null
      busFire('event:rt-toast', toastView())
      if (el && !toastState.resizeBound) { toastState.resizeBound = true; window.addEventListener('resize', toastPlace) }
      rtRaf(toastPlace)
    }, function () { toastState.mounting = null })
  }

  // While a modal layer is open the toast region takes the first corner that covers none of the top modal's
  // controls (the least covered area when every corner does); with no modal it keeps its default corner.
  var TOAST_GAP = 16
  var TOAST_PLACES = ['bottom-end', 'bottom-start', 'top-end', 'top-start', 'top-center']
  var toastPlaceTimers = []

  function toastBox(place, w, h, vw, vh) {
    var align = place.split('-')[1]
    var x = align === 'end' ? vw - TOAST_GAP - w : align === 'start' ? TOAST_GAP : (vw - w) / 2
    var y = place.indexOf('top') === 0 ? TOAST_GAP : vh - TOAST_GAP - h
    return { left: x, top: y, right: x + w, bottom: y + h }
  }

  function toastPlace() {
    var host = toastState.host
    var region = host && host.isConnected ? host.querySelector('.ui-toasts') : null
    if (!region) return
    var modal = topModalHost(), r = region.getBoundingClientRect()
    if (!modal || !r.height) { region.removeAttribute('data-place'); return }
    var vw = window.innerWidth || document.documentElement.clientWidth, vh = window.innerHeight || document.documentElement.clientHeight
    var ctrls = Array.prototype.map.call(modal.querySelectorAll(FOCUSABLE_SEL), function (el) { return el.getBoundingClientRect() })
      .filter(function (c) { return c.width > 0 && c.height > 0 })
    var places = r.width >= vw - 2 * TOAST_GAP - 1 ? ['bottom-center', 'top-center'] : TOAST_PLACES
    var best = places[0], bestCost = Infinity
    for (var i = 0; i < places.length && bestCost > 0; i++) {
      var b = toastBox(places[i], r.width, r.height, vw, vh), cost = 0
      for (var j = 0; j < ctrls.length; j++) {
        var c = ctrls[j]
        cost += Math.max(0, Math.min(b.right, c.right) - Math.max(b.left, c.left)) * Math.max(0, Math.min(b.bottom, c.bottom) - Math.max(b.top, c.top))
      }
      if (cost < bestCost) { best = places[i]; bestCost = cost }
    }
    if (best === places[0]) region.removeAttribute('data-place')
    else region.setAttribute('data-place', best)
  }

  // A modal that opens or closes moves the region at once and again once its content has mounted and animated in;
  // while it stays open, content it mounts later (an awaited read) moves the region again.
  var toastWatch = null
  function toastReplace() {
    if (!toastState.host || typeof document === 'undefined') return
    rtRaf(toastPlace)
    toastPlaceTimers.forEach(clearTimeout)
    toastPlaceTimers = [150, 400].map(function (ms) { return setTimeout(toastPlace, ms) })
    var modal = topModalHost()
    if (toastWatch && toastWatch.target === modal) return
    if (toastWatch) { toastWatch.mo.disconnect(); toastWatch = null }
    if (!modal || typeof MutationObserver === 'undefined') return
    var mo = new MutationObserver(function () { rtRaf(toastPlace) })
    mo.observe(modal, { childList: true, subtree: true })
    toastWatch = { target: modal, mo: mo }
  }

  // Haptics: navigator.vibrate patterns (ms); a no-op that returns false where the device or browser has none.
  var HAPTICS = { tick: 8, light: 12, medium: 25, success: [12, 60, 18], error: [30, 50, 30, 50, 30] }
  function haptic(kind) {
    var nav = typeof navigator !== 'undefined' ? navigator : null
    if (!nav || typeof nav.vibrate !== 'function') return false
    try { return nav.vibrate(HAPTICS[kind] || HAPTICS.light) !== false } catch (e) { return false }
  }

  function toast(message, opts) {
    var o = opts || {}
    var dur = o.duration == null ? 4000 : Number(o.duration)
    var t = { id: ++toastState.seq, message: String(message == null ? '' : message), tone: TOAST_TONES[o.tone] ? o.tone : 'info',
      remaining: dur > 0 ? dur : Infinity, action: o.action || null, undo: typeof o.undo === 'function' ? o.undo : null,
      dismissible: o.dismissible !== false, timer: null, paused: false, startedAt: 0 }
    toastState.items.push(t)
    toastSync()
    ensureToastHost()
    if (t.tone === 'error') haptic('error')
    return { id: t.id, dismiss: function () { toastDismiss(t.id) } }
  }
  toast.dismiss = toastDismiss
  toast.pause = toastPause
  toast.resume = toastResume
  toast.act = toastAct
  toast.items = toastView
  toast.clear = function () { toastState.items.slice().forEach(function (t) { toastDismiss(t.id) }) }

  // Commands: registered lists + the shell nav's internal links, fuzzy-ranked, recents first.
  var commandLists = []
  var CMD_RECENT_MAX = 5

  function commandsRegister(list) {
    var arr = (Array.isArray(list) ? list : [list]).filter(function (c) { return c && c.id != null && c.label && typeof c.run === 'function' })
    var entry = { items: arr }
    commandLists.push(entry)
    return function unregister() { var i = commandLists.indexOf(entry); if (i >= 0) commandLists.splice(i, 1) }
  }

  function navCommands() {
    if (typeof document === 'undefined') return []
    var out = [], seen = Object.create(null)
    var links = document.querySelectorAll('nav a[href], [role="navigation"] a[href], [data-rt-nav] a[href]')
    for (var i = 0; i < links.length; i++) {
      var a = links[i]
      if (a.closest('#i-overlay-layer') || a.hasAttribute('download') || (a.getAttribute('target') || '_self') !== '_self') continue
      var u
      try { u = new URL(a.getAttribute('href'), location.href) } catch (_) { continue }
      if (u.origin !== location.origin || !/^https?:$/.test(u.protocol)) continue
      var path = u.pathname + u.search
      var label = (a.getAttribute('aria-label') || a.textContent || '').replace(/\s+/g, ' ').trim()
      if (!label || seen[path]) continue
      seen[path] = 1
      out.push({ id: 'nav:' + path, label: label, hint: path, group: 'Ir a', run: (function (p) { return function () { return Runtime.navigate(p) } })(path) })
    }
    return out
  }

  function commandsAll() {
    var out = [], seen = Object.create(null)
    var all = [].concat.apply([], commandLists.map(function (e) { return e.items })).concat(navCommands())
    for (var i = 0; i < all.length; i++) { var id = String(all[i].id); if (!seen[id]) { seen[id] = 1; out.push(all[i]) } }
    return out
  }

  function cmdRecentKey() { return 'rt-cmd-recent:' + rtAppUid() }
  function commandsRecent() {
    try { var v = JSON.parse(localStorage.getItem(cmdRecentKey()) || '[]'); return Array.isArray(v) ? v : [] } catch (_) { return [] }
  }
  function cmdRemember(id) {
    var r = commandsRecent().filter(function (x) { return x !== id })
    r.unshift(id)
    try { localStorage.setItem(cmdRecentKey(), JSON.stringify(r.slice(0, CMD_RECENT_MAX))) } catch (_) { /* storage off */ }
  }

  // Prefix 1000+, word prefix 800+, substring 600+, subsequence up to 400 (tighter = higher); -1 = no match.
  function fuzzyScore(query, text) {
    var q = String(query || '').toLowerCase().trim(), t = String(text || '').toLowerCase()
    if (!q) return 0
    if (t.indexOf(q) === 0) return 1000 - t.length
    var at = t.indexOf(q)
    if (at > 0) return (/[\s\-_/:.]/.test(t.charAt(at - 1)) ? 800 : 600) - at
    var pos = -1, gaps = 0
    for (var i = 0; i < q.length; i++) {
      var n = t.indexOf(q.charAt(i), pos + 1)
      if (n < 0) return -1
      if (pos >= 0) gaps += n - pos - 1
      pos = n
    }
    return Math.max(1, 400 - gaps * 10 - t.length)
  }

  function commandsSearch(query) {
    var recent = commandsRecent(), q = String(query || '').trim()
    var rows = commandsAll().map(function (c, order) {
      var hay = [c.label].concat(c.keywords || [], c.hint ? [c.hint] : [])
      var s = Math.max.apply(null, hay.map(function (h) { return fuzzyScore(q, h) }))
      var r = recent.indexOf(String(c.id))
      return { id: String(c.id), label: String(c.label), hint: c.hint || '', shortcut: c.shortcut ? String(c.shortcut) : '', group: (!q && r >= 0) ? 'Recientes' : (c.group || 'Comandos'), score: s, recent: r, order: order }
    }).filter(function (r) { return r.score >= 0 })
    rows.sort(function (a, b) {
      if (!q && (a.recent >= 0 || b.recent >= 0)) return (a.recent < 0 ? 99 : a.recent) - (b.recent < 0 ? 99 : b.recent)
      if (b.score !== a.score) return b.score - a.score
      if ((a.recent >= 0) !== (b.recent >= 0)) return a.recent >= 0 ? -1 : 1
      return a.order - b.order
    })
    return rows
  }

  function commandsRun(id) {
    var all = commandsAll(), c = null
    for (var i = 0; i < all.length; i++) if (String(all[i].id) === String(id)) { c = all[i]; break }
    if (!c) return Promise.resolve(false)
    cmdRemember(String(c.id))
    close('ui-command')
    return Promise.resolve().then(function () { return c.run() }).then(function () { return true }, function (e) {
      console.error('[island] command "' + c.id + '" failed:', e); return false
    })
  }

  function commandsIsOpen() { return typeof document !== 'undefined' && !!document.querySelector('[data-overlay-instance][data-component-name="ui-command"]') }
  function commandsOpen() { return commandsIsOpen() ? Promise.resolve(null) : open('ui-command', {}) }
  function commandsToggle() { if (commandsIsOpen()) { close('ui-command'); return Promise.resolve(null) } return commandsOpen() }

  // Shortcut specs: steps split by spaces ('g p'), keys of a step by '+' ('mod+s'); mod = ⌘ on Apple, Ctrl elsewhere.
  var KEY_MODS = { mod: 1, ctrl: 1, meta: 1, cmd: 1, alt: 1, option: 1, shift: 1 }
  var KEY_ALIAS = { esc: 'escape', return: 'enter', del: 'delete', up: 'arrowup', down: 'arrowdown', left: 'arrowleft', right: 'arrowright', plus: '+' }
  var KEY_GLYPH = { escape: 'Esc', enter: '↵', arrowup: '↑', arrowdown: '↓', arrowleft: '←', arrowright: '→', ' ': 'Space', space: 'Space', backspace: '⌫', delete: 'Supr', tab: 'Tab' }

  function keysIsMac() {
    try { var n = navigator, p = (n.userAgentData && n.userAgentData.platform) || n.platform || ''; return /mac|iphone|ipad|ipod/i.test(p) } catch (_) { return false }
  }

  function keysParse(spec) {
    return String(spec || '').trim().split(/\s+/).filter(Boolean).map(function (step) {
      var parts = step.length > 1 ? step.split(/\+(?=.)/) : [step], s = { mod: false, ctrl: false, meta: false, alt: false, shift: false, key: '' }
      for (var i = 0; i < parts.length; i++) {
        var k = parts[i].toLowerCase()
        if (i < parts.length - 1 && KEY_MODS[k]) { s[k === 'cmd' ? 'meta' : k === 'option' ? 'alt' : k] = true; continue }
        s.key = KEY_ALIAS[k] || k
      }
      return s
    }).filter(function (s) { return s.key })
  }

  function keysFormat(spec, mac) {
    var m = mac == null ? keysIsMac() : !!mac
    return keysParse(spec).map(function (s) {
      var out = []
      if (s.ctrl || (s.mod && !m)) out.push(m ? '⌃' : 'Ctrl')
      if (s.alt) out.push(m ? '⌥' : 'Alt')
      if (s.shift) out.push(m ? '⇧' : 'Shift')
      if (s.meta || (s.mod && m)) out.push(m ? '⌘' : 'Meta')
      out.push(KEY_GLYPH[s.key] || (s.key.length === 1 ? s.key.toUpperCase() : s.key.charAt(0).toUpperCase() + s.key.slice(1)))
      return out
    })
  }

  function keysLabel(spec, mac) { return keysFormat(spec, mac).map(function (s) { return s.join(' + ') }).join(' luego ') }

  function keysMatch(step, e) {
    if (!step || String(e.key || '').toLowerCase() !== step.key) return false
    var mac = keysIsMac()
    if (!!e.ctrlKey !== (step.ctrl || (step.mod && !mac)) || !!e.metaKey !== (step.meta || (step.mod && mac)) || !!e.altKey !== step.alt) return false
    return step.shift ? !!e.shiftKey : !(e.shiftKey && /^[a-z0-9]$/.test(step.key))
  }

  // Built-in keys the palette owns, listed first in the help overlay.
  var BUILTIN_SHORTCUTS = [
    { id: 'rt:palette', label: 'Paleta de comandos', group: 'General', shortcut: 'mod+k' },
    { id: 'rt:search', label: 'Buscar un comando', group: 'General', shortcut: '/' },
    { id: 'rt:help', label: 'Atajos de teclado', group: 'General', shortcut: '?' },
  ]
  var SEQ_TIMEOUT_MS = 1000
  var seqBuf = [], seqAt = 0

  function commandsShortcuts() {
    var own = commandsAll().filter(function (c) { return c.shortcut && keysParse(c.shortcut).length })
      .map(function (c) { return { id: String(c.id), label: String(c.label), group: c.group || 'Comandos', shortcut: String(c.shortcut) } })
    return BUILTIN_SHORTCUTS.concat(own)
  }

  function helpIsOpen() { return typeof document !== 'undefined' && !!document.querySelector('[data-overlay-instance][data-component-name="ui-shortcuts"]') }
  function shortcutsHelp() { return helpIsOpen() ? Promise.resolve(null) : open('ui-shortcuts', {}) }

  // A registered shortcut: never inside an input/textarea/contenteditable unless its first step has a modifier,
  // never while a dialog is open; a sequence keeps its prefix for SEQ_TIMEOUT_MS.
  function runShortcut(e) {
    if (/^(shift|control|alt|meta)$/i.test(String(e.key || '')) || topModalHost()) return false
    var typing = isTypingTarget(document.activeElement), now = Date.now()
    if (now - seqAt > SEQ_TIMEOUT_MS) seqBuf = []
    var list = commandsAll().filter(function (c) { return c.shortcut }).map(function (c) { return { c: c, steps: keysParse(c.shortcut) } })
      .filter(function (x) { var f = x.steps[0]; return x.steps.length && (!typing || f.mod || f.ctrl || f.meta) })
    function attempt(prefix) {
      var at = prefix.length, partial = false
      for (var i = 0; i < list.length; i++) {
        var st = list[i].steps
        if (st.length <= at || !keysMatch(st[at], e)) continue
        var ok = true
        for (var j = 0; j < at; j++) if (!keysMatch(st[j], prefix[j])) { ok = false; break }
        if (!ok) continue
        if (st.length === at + 1) return list[i].c
        partial = true
      }
      return partial
    }
    var snap = { key: e.key, ctrlKey: e.ctrlKey, metaKey: e.metaKey, altKey: e.altKey, shiftKey: e.shiftKey }
    var hit = seqBuf.length ? attempt(seqBuf) : false
    if (!hit) { seqBuf = []; hit = attempt([]) }
    if (!hit) return false
    e.preventDefault()
    if (hit === true) { seqBuf.push(snap); seqAt = now; return true }
    seqBuf = []
    commandsRun(hit.id)
    return true
  }

  function isTypingTarget(el) {
    if (!el) return false
    var t = (el.tagName || '').toLowerCase()
    return t === 'input' || t === 'textarea' || t === 'select' || !!el.isContentEditable || el.getAttribute('contenteditable') === 'true'
  }

  function onCommandKey(e) {
    if (e.defaultPrevented || document.querySelector('meta[name="rt-no-command"]')) return
    var k = String(e.key || '').toLowerCase()
    if (k === 'k' && (e.ctrlKey || e.metaKey) && !e.altKey && !e.shiftKey) { e.preventDefault(); commandsToggle(); return }
    if (k === '/' && !e.ctrlKey && !e.metaKey && !e.altKey && !isTypingTarget(document.activeElement) && !commandsIsOpen()) { e.preventDefault(); commandsOpen(); return }
    if (commandsIsOpen() || runShortcut(e)) return
    if (e.key === '?' && !e.ctrlKey && !e.metaKey && !e.altKey && !isTypingTarget(document.activeElement) && !topModalHost()) { e.preventDefault(); shortcutsHelp() }
  }

  var commandKeysInstalled = false
  function installCommandKeys() {
    if (commandKeysInstalled || typeof document === 'undefined') return
    commandKeysInstalled = true
    document.addEventListener('keydown', onCommandKey)
  }

  // Drafts: one row per key in IndexedDB `rt-drafts-<app>` (localStorage when IndexedDB is unavailable), 7-day TTL.
  var DRAFT_TTL_MS = 7 * 24 * 3600 * 1000
  var draftStorePromise = null

  function draftLsStore(app) {
    var pre = 'rt-draft:' + app + ':'
    function keys() {
      var out = []
      for (var i = 0; i < localStorage.length; i++) { var k = localStorage.key(i); if (k && k.indexOf(pre) === 0) out.push(k) }
      return out
    }
    return {
      get: function (key) { try { return Promise.resolve(JSON.parse(localStorage.getItem(pre + key) || 'null')) } catch (_) { return Promise.resolve(null) } },
      put: function (row) { try { localStorage.setItem(pre + row.key, JSON.stringify(row)) } catch (_) { /* quota */ } return Promise.resolve() },
      del: function (key) { try { localStorage.removeItem(pre + key) } catch (_) { /* */ } return Promise.resolve() },
      prune: function (before) {
        keys().forEach(function (k) { try { var r = JSON.parse(localStorage.getItem(k) || 'null'); if (!r || r.updatedAt < before) localStorage.removeItem(k) } catch (_) { localStorage.removeItem(k) } })
        return Promise.resolve()
      },
      kind: 'localStorage',
    }
  }

  function idbReq(r) { return new Promise(function (res, rej) { r.onsuccess = function () { res(r.result) }; r.onerror = function () { rej(r.error) } }) }

  function draftIdbStore(app) {
    return new Promise(function (resolve, reject) {
      var req = indexedDB.open('rt-drafts-' + app, 1)
      req.onupgradeneeded = function () { req.result.createObjectStore('drafts', { keyPath: 'key' }) }
      req.onerror = function () { reject(req.error) }
      req.onsuccess = function () {
        var db = req.result
        function os(mode) { return db.transaction('drafts', mode).objectStore('drafts') }
        resolve({
          get: function (key) { return idbReq(os('readonly').get(key)).then(function (r) { return r || null }) },
          put: function (row) { return idbReq(os('readwrite').put(row)).then(function () {}) },
          del: function (key) { return idbReq(os('readwrite').delete(key)).then(function () {}) },
          prune: function (before) {
            return new Promise(function (res) {
              var c = os('readwrite').openCursor()
              c.onsuccess = function () { var cur = c.result; if (!cur) return res(); if (!cur.value || cur.value.updatedAt < before) cur.delete(); cur.continue() }
              c.onerror = function () { res() }
            })
          },
          kind: 'indexedDB',
        })
      }
    })
  }

  function draftStore() {
    if (draftStorePromise) return draftStorePromise
    var app = rtAppUid() || 'app'
    var p = (typeof indexedDB !== 'undefined' && indexedDB) ? draftIdbStore(app).catch(function () { return draftLsStore(app) }) : Promise.resolve(draftLsStore(app))
    draftStorePromise = p.then(function (s) { return s.prune(Date.now() - DRAFT_TTL_MS).then(function () { return s }, function () { return s }) })
    return draftStorePromise
  }

  function draft(key) {
    var k = String(key)
    var has = ref(false)
    function row() {
      return draftStore().then(function (s) {
        return s.get(k).then(function (r) {
          if (r && r.updatedAt < Date.now() - DRAFT_TTL_MS) return s.del(k).then(function () { return null })
          return r
        })
      }).then(function (r) { has.value = !!r; return r || null })
    }
    return {
      key: k,
      has: has,
      row: row,
      load: function () { return row().then(function (r) { return r ? r.state : null }) },
      save: function (state) {
        var r = { key: k, state: JSON.parse(JSON.stringify(state == null ? null : state)), updatedAt: Date.now() }
        return draftStore().then(function (s) { return s.put(r) }).then(function () { has.value = true })
      },
      clear: function () { return draftStore().then(function (s) { return s.del(k) }).then(function () { has.value = false }) },
    }
  }

  // useDraft(key, formRef, { debounce }): autosave; a stored draft is offered (available) and holds autosave until restore()/discard().
  function useDraftIn(scope, key, source, opts) {
    var d = draft(key), wait = opts && opts.debounce != null ? Number(opts.debounce) : 800
    var timer = null, holding = true, changedWhileHolding = false, pending = null
    var h = { available: ref(false), savedAt: ref(null), has: d.has }
    function read() { return isRef(source) ? source.value : (typeof source === 'function' ? source() : source) }
    function write(v) {
      if (isRef(source)) { source.value = v; return }
      var cur = read()
      if (cur && typeof cur === 'object' && v && typeof v === 'object') {
        Object.keys(cur).forEach(function (x) { if (!(x in v)) delete cur[x] })
        Object.keys(v).forEach(function (x) { cur[x] = v[x] })
      }
    }
    function saveNow() {
      if (timer) { clearTimeout(timer); timer = null }
      return d.save(read()).then(function () { h.savedAt.value = Date.now() })
    }
    function schedule() { if (timer) clearTimeout(timer); timer = setTimeout(function () { timer = null; saveNow() }, wait) }
    function release() { holding = false; if (changedWhileHolding) { changedWhileHolding = false; schedule() } }
    var stop = watch(function () { return read() }, function () { if (holding) changedWhileHolding = true; else schedule() }, { deep: true })
    d.row().then(function (r) {
      if (r && r.state != null) { pending = r.state; h.savedAt.value = r.updatedAt; h.available.value = true } else release()
    }, release)
    h.restore = function () { if (pending != null) write(JSON.parse(JSON.stringify(pending))); pending = null; h.available.value = false; holding = false }
    h.discard = function () { pending = null; h.available.value = false; return d.clear().then(function () { h.savedAt.value = null; release() }) }
    h.clear = function () { if (timer) { clearTimeout(timer); timer = null } pending = null; h.available.value = false; holding = false; return d.clear().then(function () { h.savedAt.value = null }) }
    h.flush = function () { return timer ? saveNow() : Promise.resolve() }
    addDisposer(scope, function () { stop(); if (timer) saveNow() })
    return h
  }

  function attachUiPrims(R) {
    R.toast = toast
    R.haptic = haptic
    R.float = floatPanel
    R.commands = { register: commandsRegister, list: commandsAll, search: commandsSearch, run: commandsRun, open: commandsOpen, toggle: commandsToggle, recent: commandsRecent, shortcuts: commandsShortcuts, help: shortcutsHelp }
    R.draft = draft
    R.modal = modalAttach
    R.keys = { parse: keysParse, format: keysFormat, label: keysLabel, isMac: keysIsMac }
    installCommandKeys()
  }

  function findSlotAnchor(root, name) {
    var walker = root.ownerDocument.createTreeWalker(root, 128 /* NodeFilter.SHOW_COMMENT */)
    var n
    while ((n = walker.nextNode())) { if (n.data === 'island-slot:' + name) return n }
    return null
  }

  // A client shell whose slot anchor sits inside a nested island (a frame component wrapping `<slot name="main">`)
  // has no anchor when it builds: the kept page island waits at the shell root until that island mounts.
  var pendingPageSplice = null
  function respliceKeptIslands(rootEl, keep) {
    pendingPageSplice = null
    for (var i = 0; i < keep.length; i++) {
      var anchor = findSlotAnchor(rootEl, 'main') || findSlotAnchor(rootEl, 'default')
      if (anchor) anchor.parentNode.replaceChild(keep[i], anchor)
      else { pendingPageSplice = rootEl; rootEl.appendChild(keep[i]) }
    }
  }
  function spliceLatePageAnchor(ph) {
    if (!pendingPageSplice || !pendingPageSplice.contains(ph)) return
    var page = findPageIslandRoot(ph.ownerDocument)
    if (!page || page.contains(ph)) return
    var anchor = findSlotAnchor(ph, 'main') || findSlotAnchor(ph, 'default')
    if (!anchor) return
    anchor.parentNode.replaceChild(page, anchor)
    pendingPageSplice = null
  }

  // ── Island.serverFn — RPC stub for a <script server> export ───────────────
  function serverFn(ref, name) {
    return async function () {
      var args = Array.prototype.slice.call(arguments)
      var res, json = null
      try {
        res = await fetch('/runtime/fn/' + rtAppUid(), { method: 'POST', credentials: 'include',
          headers: rtAdminTargetHeaders({ 'Content-Type': 'application/json' }), body: JSON.stringify({ ref: ref, name: name, args: args }) })
      } catch (err) { var ne = new Error(err && err.message ? err.message : 'Network error'); ne.status = 0; throw ne }
      try { json = await res.json() } catch (_) { json = null }
      if (res.status === 401) { Runtime.onUnauthorized(); var ue = new Error('Unauthorized'); ue.status = 401; throw ue }
      // A coded body without `result` is a failure whatever the status (`$status(200)` in a guard).
      var codedErr = json && typeof json === 'object' && typeof json.code === 'string' && !('result' in json)
      if (!res.ok || codedErr) {
        var e = new Error((json && (json.error || json.message)) || ('serverFn ' + name + ' failed (' + res.status + ')'))
        e.status = res.status
        if (json && json.code) e.code = json.code
        if (json && json.errors) e.errors = json.errors
        if (json && json.issues) e.issues = json.issues
        if (json && json.redirect) e.redirect = json.redirect
        if (res.status === 410 && json && json.code === 'fn_version_stale') busFire('event:app-update-ready', { reason: 'fn_version_stale', ref: ref })
        throw e
      }
      return json ? json.result : undefined
    }
  }

  var propLinks = Object.create(null)

  function camelizeProp(name) {
    return name.replace(/-+([a-z0-9])/gi, function (_, c) { return c.toUpperCase() })
  }

  function makePropLink(exprs) {
    return { exprs: exprs, values: Object.create(null), seed: null, scope: null, on: null, onScope: null }
  }

  // The child's `emit('update:x', v)` assigns into the parent scope the tag sits in.
  function adoptModelLink(child, link) {
    if (link.on) { child.__modelOn = link.on; child.__modelScope = link.onScope; listenerRev(child).value++ }
  }

  function readModelOn(el, attr, link, scope) {
    var src = el.getAttribute(attr)
    if (src === null) return
    el.removeAttribute(attr)
    try { link.on = JSON.parse(src) } catch (_) { return }
    link.onScope = scope
  }

  // Assign one prop into a mounted child scope: the key, and its camelCase alias
  // unless the parent also passes that camelCase key itself.
  function assignScopeProp(link, key, value) {
    var s = link.scope
    if (!s || !s.__mounted || s.__unmounted || !s.props) return
    s.props[key] = value
    var camel = camelizeProp(key)
    if (camel !== key && !Object.prototype.hasOwnProperty.call(link.exprs, camel)) s.props[camel] = value
  }

  // One effect per bound prop, evaluated against the scope the tag sits in (the
  // island, a v-for item or a slot scope). The first run is synchronous, so
  // link.values holds every initial value when this returns.
  function bindPropLink(node, link, scope) {
    Object.keys(link.exprs).forEach(function (key) {
      var expr = link.exprs[key]
      nodeEffect(node, function () {
        var v
        try { v = evaluate(expr, scope) } catch (_) { v = undefined }
        link.values[key] = v
        assignScopeProp(link, key, v)
      })
    })
  }

  // Hand a link to the child island `id`: the scope when it is already mounted,
  // otherwise parked until mountIsland consumes it.
  function attachPropLink(node, id, link) {
    var live = Island.scopes[id]
    if (live) { link.scope = live; adoptModelLink(live, link); flushPropLink(link); return }
    propLinks[id] = link
    addStop(node, function () { if (propLinks[id] === link) delete propLinks[id]; link.scope = null })
  }

  // After the child mounted: push every value that moved away from its seed.
  function flushPropLink(link) {
    var seed = link.seed || {}
    for (var k in link.values) {
      if (!Object.is(link.values[k], seed[k])) assignScopeProp(link, k, link.values[k])
    }
  }

  // An SSR-rendered component island nested in this island's DOM: the compiler
  // put its bound prop expressions on the root as data-props-bind.
  function linkNestedIslandProps(el, scope) {
    var src = el.getAttribute('data-props-bind')
    if (src === null && !el.hasAttribute('data-props-on')) return
    el.removeAttribute('data-props-bind')
    var exprs = {}
    try { exprs = JSON.parse(src || '{}') || {} } catch (_) { return }
    var id = el.getAttribute('data-island')
    var link = makePropLink(exprs)
    readModelOn(el, 'data-props-on', link, scope)
    bindPropLink(el, link, scope)
    link.seed = Object.assign({}, link.values)
    attachPropLink(el, id, link)
  }

  // A placeholder in a client-mode page keeps `hydrate` as a raw attribute: visible/idle defer the fetch + mount;
  // interaction fetches at once and paints the markup, and only the mount waits for the first interaction (as on SSR).
  function whenHydratable(el, mode, fn) {
    if (mode === 'interaction') { whenInteracted(el, fn); return }
    if (mode === 'visible' && typeof IntersectionObserver === 'function') {
      var ob = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) if (entries[i].isIntersecting) { ob.disconnect(); fn(); return }
      }, { rootMargin: '200px' })
      ob.observe(el)
      return
    }
    if (typeof requestIdleCallback === 'function') requestIdleCallback(fn, { timeout: 3000 }); else setTimeout(fn, 1)
  }

  async function mountLazyInline(ph, scope, table) {
    ph.__rtOwnerScope = scope
    var hmode = ph.getAttribute('hydrate') || ph.getAttribute('data-comp-hydrate')
    if (isDeferredMode(hmode) && hmode !== 'interaction' && !ph.__rtHydrateDeferred) {
      ph.__rtHydrateDeferred = true
      whenHydratable(ph, hmode, function () { if (ph.isConnected) return mountLazyInline(ph, scope, table) })
      return
    }
    // Guard against double-mount (the same placeholder hydrated twice).
    ph.setAttribute('data-island-loaded', '')
    return trackLateMount(ph, fetchMountLazyInline(ph, scope, table))
  }

  // In-flight lazy component mounts: a navigate's focus pass waits for the ones inside the new page, and each
  // settled mount marks aria-current and observes viewport-prefetch links in what it brought.
  var lateMounts = []
  function trackLateMount(ph, p) {
    var entry = { ph: ph, p: p }
    lateMounts.push(entry)
    var settle = function () {
      var i = lateMounts.indexOf(entry)
      if (i >= 0) lateMounts.splice(i, 1)
      lateContentMounted(ph)
    }
    p.then(settle, settle)
    return p
  }
  function lateMountsIn(root) {
    var ps = []
    for (var i = 0; i < lateMounts.length; i++) if (root.contains(lateMounts[i].ph)) ps.push(lateMounts[i].p.catch(function () {}))
    return ps
  }
  // Resolves once no lazy mount inside root is in flight (nested ones included), or after ms.
  function settleLateMounts(root, ms) {
    var deadline = Date.now() + ms
    var next = function () {
      var ps = lateMountsIn(root)
      var left = deadline - Date.now()
      if (!ps.length || left <= 0) return Promise.resolve()
      return Promise.race([Promise.all(ps), new Promise(function (r) { setTimeout(r, left) })]).then(next)
    }
    return next()
  }
  function lateContentMounted(root) {
    if (typeof window === 'undefined' || !root || !root.isConnected || navPendingRef.value) return
    markCurrentLinks(root, window, window.location.pathname)
    viewportPrefetchObserve(root)
  }

  // `rt-island-comps` (+ each soft-nav's `islandComps`): setup component name → immutable client bundle URL.
  var islandComps = null
  function islandCompUrl(name) {
    if (!islandComps) {
      islandComps = Object.create(null)
      var pairs = (rtReadMeta('rt-island-comps') || '').split(',')
      for (var i = 0; i < pairs.length; i++) {
        var eq = pairs[i].indexOf('=')
        if (eq > 0) islandComps[pairs[i].slice(0, eq)] = pairs[i].slice(eq + 1)
      }
    }
    return islandComps[name] || null
  }
  function registerIslandComps(map) {
    islandCompUrl('')
    for (var k in map) if (Object.prototype.hasOwnProperty.call(map, k)) islandComps[k] = map[k]
  }

  // A lazy placeholder's payload built from the component's bundle (the shape /runtime/component answers), or null
  // when there is none or it cannot serve these props (a missing required prop): the caller fetches as before.
  var BUNDLE_SKIP_GLOBALS = { app: 1, tenant: 1, user: 1, params: 1, query: 1, props: 1, route: 1, request: 1, ds: 1, admin: 1 }
  async function localComponentPayload(name, input, scope, local) {
    var url = islandCompUrl(name)
    if (!url) return null
    if (local && !local.s) { console.debug('[island] "' + name + '" mounts through the server: ' + (local.why || 'no precompiled fills')); return null }
    var b
    try { b = JSON.parse(await islandAssetText(url)) } catch (e) { console.warn('[island] bundle of "' + name + '" unavailable, fetching:', e); return null }
    var props = {}
    var k
    for (k in input) props[k] = input[k]
    for (k in input) { var c = camelizeProp(k); if (c !== k && !(c in input)) props[c] = input[k] }
    var spec = b.props
    if (spec) {
      for (var bi = 0; bi < spec.booleans.length; bi++) {
        var bn = spec.booleans[bi], bv = props[bn]
        if (bv === '' || bv === null || bv === bn || bv === bn.replace(/[A-Z]/g, function (x) { return '-' + x.toLowerCase() })) props[bn] = true
      }
      for (k in spec.defaults) if (props[k] === undefined) props[k] = JSON.parse(JSON.stringify(spec.defaults[k]))
      for (var ri = 0; ri < spec.required.length; ri++) if (props[spec.required[ri]] === undefined) return null
    }
    var globals = { $slots: {} }
    if (local) for (k in local.s) globals.$slots[k] = true
    var keys = ['app', 'tenant', 'user', 'params', 'query', 'route', 'admin']
    for (var gi = 0; gi < keys.length; gi++) {
      if (scope && keys[gi] in scope) globals[keys[gi]] = toRaw(scope[keys[gi]])
      else if (keys[gi] !== 'admin') globals[keys[gi]] = null
    }
    for (k in props) if (!BUNDLE_SKIP_GLOBALS[k] && typeof props[k] !== 'function' && props[k] !== undefined) globals[k] = props[k]
    globals.props = props
    var scopeId = 'component-' + b.short + '#' + Math.random().toString(36).slice(2, 10)
    // `</script` → `<\/script`: the HTML tokenizer ends the element there; JSON and JS read both identically.
    var esc = function (s) { return String(s).replace(/<\/script/gi, '<\\/script') }
    var tag = function (type, body) { return '<script type="island/' + type + '" data-island="' + scopeId + '">' + esc(body) + '</script>' }
    var html = '<div data-island="' + scopeId + '">' + (b.fallback || '') + '</div>' +
      tag('bind', JSON.stringify(b.bind)) + tag('tpl', JSON.stringify({ t: b.tpl })) + tag('setup', b.setup) + tag('globals', JSON.stringify(globals))
    return { html: html, css: b.css, once: b.once || null, scopeId: scopeId, assets: b.assets || [], localFills: local || null }
  }

  async function fetchMountLazyInline(ph, scope, table) {
    var name = ph.getAttribute('data-component-name')
    var fills = ph.getAttribute('data-comp-fills')
    var local = null
    if (fills) {
      try { local = JSON.parse(ph.getAttribute('data-comp-local') || '{}') } catch (_) { local = {} }
    }

    // Props from the placeholder's kept attrs: static ones as written, bound ones
    // (`:x="expr"`) linked to the parent scope — evaluated now for the fetch and
    // pushed into the mounted child whenever they change.
    var props = {}
    var exprs = {}
    var hasBound = false
    for (var i = 0; i < ph.attributes.length; i++) {
      var a = ph.attributes[i], n = a.name
      if (n === 'data-island-lazy' || n === 'data-component-name' || n === 'data-island-loaded' || n === 'data-comp-fills' || n === 'data-comp-local' || n === 'data-comp-client' || n === 'data-comp-css-key' || n === 'data-comp-on' || n === 'hydrate' || n === 'data-comp-hydrate') continue
      if (n.charAt(0) === ':') {
        exprs[n.slice(1)] = a.value
        hasBound = true
      } else if (n.charAt(0) !== '@' && n.indexOf('v-') !== 0) {
        props[n] = a.value
      }
    }
    var link = null
    if (hasBound || ph.hasAttribute('data-comp-on')) {
      link = makePropLink(exprs)
      readModelOn(ph, 'data-comp-on', link, scope)
      bindPropLink(ph, link, scope)
      for (var ek in exprs) props[ek] = link.values[ek]
      link.seed = Object.assign({}, link.values)
    }

    var data
    try {
      // `client: true` asks the server to compile this component in client mode
      // (island/tpl + fallback) — the placeholder carries data-comp-client when
      // the component's own <script setup> declared `client`.
      var reqBody = { props: props }
      if (fills) reqBody.fills = fills
      if (ph.getAttribute('data-comp-client') !== null) reqBody.client = true
      data = await localComponentPayload(name, props, scope, local) || await fetchComponentPayload(name, reqBody)
    } catch (e) { console.error('[island] lazy inline fetch error:', e); return }
    // A placeholder removed while its payload loads (a fast v-if toggle, a navigation) mounts nothing.
    if (!ph.isConnected) return
    var html = data && data.html ? data.html : ''
    if (!html) { console.warn('[island] component "' + name + '" rendered nothing (unknown component or empty template)'); return }
    // scoped CSS ships separately from html, keyed by this render's island id
    var cssKey = (data && typeof data.scopeId === 'string' && data.scopeId) || name
    injectComponentCss(data && data.css, cssKey)
    mergeOnce(data && data.once)
    ph.setAttribute('data-comp-css-key', cssKey)
    // F18 — the component's libraries must be loaded BEFORE its setup runs.
    try { await acquireAssets(data && data.assets, cssKey) } catch (e) { console.warn('[island] lazy asset load error:', e) }
    if (!ph.isConnected) { releaseComponentCss(cssKey); releaseAssets(cssKey); return }

    // Swap the island block into the placeholder; relocate island/* scripts to
    // <body> so mountIsland's querySelector lookups (by data-island) find them.
    ph.innerHTML = html
    ph.__rtLocalFills = (data && data.localFills) || null
    var scripts = Array.prototype.slice.call(ph.querySelectorAll('script[type^="island/"]'))
    for (var j = 0; j < scripts.length; j++) {
      var o = scripts[j], c = document.createElement('script')
      c.type = o.type
      if (o.getAttribute('data-island')) c.setAttribute('data-island', o.getAttribute('data-island'))
      c.textContent = o.textContent
      document.body.appendChild(c)
      if (o.parentNode) o.parentNode.removeChild(o)
    }

    // The child island's scope seeds its props from the link and follows the
    // parent from then on.
    var childRoot = null
    var cands = ph.querySelectorAll('[data-island]')
    for (var ci = 0; ci < cands.length && !childRoot; ci++) {
      var ct = cands[ci].tagName && cands[ci].tagName.toLowerCase()
      if (ct !== 'script' && ct !== 'style' && ct !== 'template') childRoot = cands[ci]
    }
    if (link && childRoot) attachPropLink(ph, childRoot.getAttribute('data-island'), link)
    var phMode = ph.getAttribute('hydrate') || ph.getAttribute('data-comp-hydrate')
    if (phMode === 'interaction' && childRoot) childRoot.setAttribute('data-hydrate', 'interaction')

    // Mount the nested island(s) the swapped HTML brought in.
    await start(ph)
    spliceLatePageAnchor(ph)

    // Disposer: when the v-if branch unmounts, stopNode recurses into the
    // placeholder and runs this — tearing down the mounted island scope(s) and
    // removing their relocated companion scripts so re-show starts clean.
    addStop(ph, function () {
      var roots = Array.prototype.slice.call(ph.querySelectorAll('[data-island]')).filter(function (el) {
        var t = el.tagName && el.tagName.toLowerCase(); return t !== 'script' && t !== 'style' && t !== 'template'
      })
      for (var k = 0; k < roots.length; k++) {
        var id = roots[k].getAttribute('data-island')
        if (id && Island.scopes[id]) { disposeScope(Island.scopes[id]); delete Island.scopes[id] }
        stopNode(roots[k])
        if (id) {
          var comp = Array.prototype.slice.call(document.querySelectorAll('script[data-island="' + id + '"]'))
          for (var m = 0; m < comp.length; m++) if (comp[m].parentNode) comp[m].parentNode.removeChild(comp[m])
        }
      }
      // Release this instance's hold on its injected <head> <style> and libraries.
      releaseComponentCss(ph.getAttribute('data-comp-css-key') || name)
      releaseAssets(ph.getAttribute('data-comp-css-key'))
    })
  }

  // Self-bootstrap on DOMContentLoaded. Concurrent start() passes are safe (synchronous mount stamp).
  if (typeof document !== 'undefined' && typeof document.addEventListener === 'function') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { start() })
    }
  }

  const Runtime = {}
  Object.defineProperty(Runtime, 'fmt', { get: rtFmt, enumerable: true })

  function rtReadMeta(name) {
    if (typeof document === 'undefined' || !document.querySelector) return null
    const el = document.querySelector('meta[name="' + name + '"]')
    return el ? el.getAttribute('content') : null
  }
  // A comma-separated meta as a lookup set: `a, b` → { a: true, b: true }.
  function rtMetaSet(name) {
    var out = {}
    ;(rtReadMeta(name) || '').split(',').forEach(function (s) { if (s) out[s.trim()] = true })
    return out
  }
  function rtUuid() {
    try { if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID() } catch (_) { /* */ }
    var b = new Uint8Array(16)
    if (typeof crypto !== 'undefined' && crypto.getRandomValues) crypto.getRandomValues(b)
    else for (var i = 0; i < 16; i++) b[i] = Math.floor(Math.random() * 256)
    b[6] = (b[6] & 0x0f) | 0x40; b[8] = (b[8] & 0x3f) | 0x80
    var h = Array.prototype.map.call(b, function (x) { return ('0' + x.toString(16)).slice(-2) }).join('')
    return h.slice(0, 8) + '-' + h.slice(8, 12) + '-' + h.slice(12, 16) + '-' + h.slice(16, 20) + '-' + h.slice(20)
  }

  Runtime.onUnauthorized = function () {
    try {
      // Under the /admin console mount a 401 means the OPERATOR session ended.
      if (rtReadMeta('rt-admin')) {
        if (location.pathname === '/admin/sign-in') return
        location.assign('/admin/sign-in?next=' + encodeURIComponent(location.pathname + location.search))
        return
      }
      if (rtReadMeta('rt-auth-enabled') !== 'true') return
      var signin = rtReadMeta('rt-signin-path') || '/sign-in'
      var here = location.pathname + location.search
      if (location.pathname === signin || location.pathname === signin.split('?')[0]) return
      window.location.href = signin + (signin.indexOf('?') >= 0 ? '&' : '?') + 'next=' + encodeURIComponent(here)
    } catch (_) { /* */ }
  }

  // ── Runtime.admin — the /admin mount's target app, env, host and operator ──
  //   Parsed once from <meta name="rt-admin">, frozen; null outside the mount.
  var rtAdminCache
  Object.defineProperty(Runtime, 'admin', {
    enumerable: true,
    get: function () {
      if (rtAdminCache !== undefined) return rtAdminCache
      var raw = rtReadMeta('rt-admin')
      var parsed = null
      if (raw) { try { parsed = JSON.parse(raw) } catch (_) { parsed = null } }
      rtAdminCache = parsed ? rtDeepFreeze(parsed) : null
      return rtAdminCache
    },
  })
  // Under the /admin mount, a /runtime/* call names the app the console operates
  // on, so the backend files its errors under that app too. Outside the mount: unchanged.
  function rtAdminTargetHeaders(h) {
    var adm = Runtime.admin
    if (adm && adm.app && adm.app.uid) h['x-admin-target'] = adm.app.uid
    return h
  }
  function rtDeepFreeze(o) {
    if (o && typeof o === 'object' && !Object.isFrozen(o)) {
      Object.freeze(o)
      for (var k in o) { if (Object.prototype.hasOwnProperty.call(o, k)) rtDeepFreeze(o[k]) }
    }
    return o
  }

  // A console path in the console env (and the `?app=` target of the platform host): `admin.qs`, `over` replacing keys.
  Runtime.envHref = function (path, over) {
    var adm = Runtime.admin
    var q = new URLSearchParams(adm ? adm.qs : '')
    for (var k in (over || {})) q.set(k, over[k])
    if (adm && q.get('env') === adm.env.host_env) q.delete('env')
    var s = q.toString()
    if (!s) return path
    var hash = path.indexOf('#')
    var base = hash >= 0 ? path.slice(0, hash) : path
    return base + (base.indexOf('?') >= 0 ? '&' : '?') + s + (hash >= 0 ? path.slice(hash) : '')
  }

  Runtime.studio = async function (path, opts) {
    opts = opts || {}
    var url = '/studio' + (path.charAt(0) === '/' ? path : '/' + path)
    if (opts.query) {
      var qs = new URLSearchParams()
      for (var qk in opts.query) {
        var qv = opts.query[qk]
        if (qv !== undefined && qv !== null) qs.append(qk, String(qv))
      }
      var qstr = qs.toString()
      if (qstr) url += (url.indexOf('?') >= 0 ? '&' : '?') + qstr
    }
    var headers = { accept: 'application/json' }
    var adm = Runtime.admin
    if (adm && adm.app && adm.app.uid) headers['x-app-uid'] = adm.app.uid
    // The console env pins every call; `env` names another, `env: null` sends none (a read across every env).
    var pin = opts.env !== undefined ? opts.env : (adm && adm.env && adm.env.name)
    if (pin) headers['x-env-name'] = pin
    if (opts.headers) { for (var hk in opts.headers) headers[hk] = opts.headers[hk] }
    var init = { method: opts.method || 'GET', credentials: 'include', headers: headers }
    if (opts.body !== undefined) {
      var blob = typeof Blob !== 'undefined' && opts.body instanceof Blob
      if (blob || opts.body instanceof ArrayBuffer || ArrayBuffer.isView(opts.body)) {
        // A File / Blob / buffer goes out as the raw body (the brand routes); its MIME is the content-type.
        if (!headers['content-type']) headers['content-type'] = (blob && opts.body.type) || 'application/octet-stream'
        init.body = opts.body
      } else {
        headers['content-type'] = 'application/json'
        init.body = typeof opts.body === 'string' ? opts.body : JSON.stringify(opts.body)
      }
    }
    if (opts.signal) init.signal = opts.signal
    var res = await fetch(url, init)
    var ctype = res.headers.get('content-type') || ''
    var body
    if (ctype.indexOf('application/json') >= 0) body = await rtSafeJson(res)
    else { try { body = await res.text() } catch (_) { body = null } }
    if (!res.ok) {
      if (res.status === 401) Runtime.onUnauthorized()
      var msg = (body && typeof body === 'object' && (body.error || body.message)) || res.statusText || ('studio ' + res.status)
      var err = new Error(typeof msg === 'string' ? msg : JSON.stringify(msg))
      err.status = res.status
      err.body = body
      throw err
    }
    return body
  }

  async function rtSafeJson(res) { try { return await res.json() } catch (_) { return null } }
  // Last envelope + ETag of each read (uid + canonical input): a refetch sends If-None-Match, a 304 replays it.
  var DS_ETAG_MAX = 200
  var dsEtagStore = new Map()
  function dsEtagKey(uid, input) { return uid + '|' + ReadCache.keyOf(input || {}) }
  function dsEtagRemember(key, etag, env) {
    if (!etag || !env) return
    dsEtagStore.delete(key)
    dsEtagStore.set(key, { etag: etag, json: JSON.stringify(env) })
    if (dsEtagStore.size > DS_ETAG_MAX) dsEtagStore.delete(dsEtagStore.keys().next().value)
  }
  function dsEtagReplay(key) { var e = dsEtagStore.get(key); return e ? JSON.parse(e.json) : null }
  async function dsFetchEnvelope(uid, input, opts) {
    // opts.datasetSince — incremental dataset sync: the server ANDs
    // `updated_at > :since` into the SELECT so only changed rows come back.
    var body = { input: input || {} }
    if (opts && opts.datasetSince) body.dataset_since = opts.datasetSince
    var hasExpect = !!opts && opts.expect !== undefined && opts.expect !== null
    var idemKey = opts && opts.idempotencyKey
    var etagKey = opts && (opts.datasetSince || hasExpect || idemKey) ? null : dsEtagKey(uid, input)
    var known = etagKey && !(opts && opts.noEtag) ? dsEtagStore.get(etagKey) : null
    var headers = { 'Content-Type': 'application/json', 'X-DS-Full': '1', 'X-RT-Origin': RT_ORIGIN }
    if (known) headers['If-None-Match'] = known.etag
    // Optimistic concurrency: the version the caller read; a stale write answers 409 stale_write + conflict.current.
    if (hasExpect) headers['If-Match'] = String(opts.expect instanceof Date ? opts.expect.toISOString() : opts.expect)
    if (idemKey) headers['Idempotency-Key'] = String(idemKey)
    let res
    try {
      res = await fetch('/runtime/ds/' + uid, {
        method: 'POST',
        credentials: 'include',
        headers: rtAdminTargetHeaders(headers),
        body: JSON.stringify(body),
      })
    } catch (err) {
      const e = new Error((err && err.message) || 'Network error')
      e.status = 0
      throw e
    }
    if (res.status === 401) {
      Runtime.onUnauthorized()
      const e = new Error('Unauthorized'); e.status = 401; throw e
    }
    if (res.status === 304 && etagKey) {
      var replay = dsEtagReplay(etagKey)
      return replay || dsFetchEnvelope(uid, input, { noEtag: true })
    }
    const json = await rtSafeJson(res)
    if (!res.ok) {
      const msg = (json && (json.error || json.message)) || ('ds() ' + res.status)
      const e = new Error(msg); e.status = res.status
      if (json && json.code) e.code = json.code
      if (json && json.errors) e.errors = json.errors
      if (json && json.issues) e.issues = json.issues
      if (json && json.conflict) e.conflict = json.conflict
      throw e
    }
    if (etagKey) dsEtagRemember(etagKey, res.headers && res.headers.get && res.headers.get('etag'), json)
    return json
  }
  // Same-tick reads share ONE POST /runtime/ds/batch; identical reads in flight share one promise.
  // Mutations (offline DSs, X-Mutation-Id replay, dataset sync) call dsFetchEnvelope directly and never land here.
  var DS_BATCH_MAX = 25
  var dsInflight = Object.create(null) // uid + canonical input → Promise<envelope>
  var dsBatchQueue = null
  // Only a DS the document declares as a read (rt-cached-reads / rt-prewarm-ds / rt-ds-tags) is deduped and
  // retried: the browser cannot tell a repeated tap on a write from a repeated read.
  function dsIsDeclaredRead(uid) {
    if (ReadCache.cachedReadSet()[uid] || dsTagMap()[uid]) return true
    var raw = rtReadMeta('rt-prewarm-ds') || ''
    var parts = raw.split(',')
    for (var i = 0; i < parts.length; i++) if (parts[i].split(/[@#]/)[0].trim() === uid) return true
    return false
  }
  // A read made from a useAsyncData fetcher (`opts.read`) retries too; `opts.retry` overrides the count.
  function dsReadEnvelope(uid, input, opts) {
    var declared = dsIsDeclaredRead(uid)
    var retries = opts && opts.retry != null ? opts.retry : (declared || (opts && opts.read) ? DS_RETRY_DELAYS.length : 0)
    var send = function () { return dsWithRetry(function () { return dsBatchEnqueue(uid, input) }, retries) }
    if (!declared) return send()
    var key = uid + '|' + ReadCache.keyOf(input || {})
    var hit = dsInflight[key]
    if (hit) return hit
    var p = send()
    dsInflight[key] = p
    var clear = function () { if (dsInflight[key] === p) delete dsInflight[key] }
    p.then(clear, clear)
    return p
  }
  function dsBatchEnqueue(uid, input) {
    var offline = false
    try { offline = typeof navigator !== 'undefined' && navigator.onLine === false } catch (_) { /* */ }
    if (offline) return dsFetchEnvelope(uid, input)
    return new Promise(function (resolve, reject) {
      if (!dsBatchQueue) { dsBatchQueue = []; Promise.resolve().then(dsBatchFlush) }
      dsBatchQueue.push({ uid: uid, input: input || {}, resolve: resolve, reject: reject })
    })
  }
  function dsBatchFlush() {
    var q = dsBatchQueue
    dsBatchQueue = null
    for (var i = 0; i < q.length; i += DS_BATCH_MAX) dsBatchSend(q.slice(i, i + DS_BATCH_MAX))
  }
  function dsSettleSingle(c) { dsFetchEnvelope(c.uid, c.input).then(c.resolve, c.reject) }
  function dsBatchError(message, status, extra) {
    var e = new Error(message); e.status = status
    if (extra && extra.code) e.code = extra.code
    if (extra && extra.errors) e.errors = extra.errors
    return e
  }
  async function dsBatchSend(calls) {
    if (calls.length === 1) { dsSettleSingle(calls[0]); return }
    var res
    try {
      var batchHeaders = { 'Content-Type': 'application/json', 'X-DS-Full': '1', 'X-RT-Origin': RT_ORIGIN }
      var appUid = rtReadMeta('rt-app-uid')
      if (appUid) batchHeaders['X-App-Uid'] = appUid
      res = await fetch('/runtime/ds/batch', {
        method: 'POST',
        credentials: 'include',
        headers: rtAdminTargetHeaders(batchHeaders),
        body: JSON.stringify({ calls: calls.map(function (c) {
          var known = dsEtagStore.get(dsEtagKey(c.uid, c.input))
          return known ? { uid: c.uid, input: c.input, etag: known.etag } : { uid: c.uid, input: c.input }
        }) }),
      })
    } catch (err) {
      calls.forEach(function (c) { c.reject(dsBatchError((err && err.message) || 'Network error', 0)) })
      return
    }
    if (res.status === 401) {
      Runtime.onUnauthorized()
      calls.forEach(function (c) { c.reject(dsBatchError('Unauthorized', 401)) })
      return
    }
    var json = await rtSafeJson(res)
    var results = res.ok && json && Array.isArray(json.results) && json.results.length === calls.length ? json.results : null
    // A host without the batch route (or any unexpected answer) gets the calls one by one.
    if (!results) { calls.forEach(dsSettleSingle); return }
    var unauthorized = false
    results.forEach(function (r, i) {
      var err = r && typeof r === 'object' && !Object.prototype.hasOwnProperty.call(r, 'data') && r.error && typeof r.error === 'object' ? r.error : null
      if (!err) {
        var key = dsEtagKey(calls[i].uid, calls[i].input)
        if (r && r.notModified === true) {
          var replay = dsEtagReplay(key)
          if (replay) calls[i].resolve(replay); else dsFetchEnvelope(calls[i].uid, calls[i].input, { noEtag: true }).then(calls[i].resolve, calls[i].reject)
          return
        }
        if (r && typeof r.etag === 'string') { var tag = r.etag; delete r.etag; dsEtagRemember(key, tag, r) }
        calls[i].resolve(r)
        return
      }
      if (err.status === 401) { unauthorized = true; calls[i].reject(dsBatchError('Unauthorized', 401)); return }
      calls[i].reject(dsBatchError(err.message || ('ds() ' + err.status), err.status, err))
    })
    if (unauthorized) Runtime.onUnauthorized()
  }
  var Offline = (function () {
    var pendingRef = ref(0)
    var queueRef = ref([]) // pending mutation rows — read-your-own-writes merges
    var conflictsRef = ref([])
    var rejectedRef = ref([])
    var replaying = false
    var retryTimer = null
    var retryDelay = 2000
    var authPaused = false

    function offlineDsSet() { return rtMetaSet('rt-offline-ds') }

    // ── Storage adapter: IndexedDB, in-memory fallback ─────────────────────
    var memStore = { mutations: [], conflicts: [], rejected: [], files: [], seq: 1 }
    var hasIdb = (typeof indexedDB !== 'undefined')
    var dbPromise = null
    function idb() {
      if (!hasIdb) return Promise.resolve(null)
      if (dbPromise) return dbPromise
      dbPromise = new Promise(function (resolve) {
        var req = indexedDB.open('rt-offline-' + (rtAppUid() || 'noapp'), 2)
        req.onupgradeneeded = function () {
          var d = req.result
          if (!d.objectStoreNames.contains('files')) d.createObjectStore('files', { keyPath: 'file_id' })
          if (!d.objectStoreNames.contains('mutations')) d.createObjectStore('mutations', { keyPath: 'seq', autoIncrement: true })
          if (!d.objectStoreNames.contains('conflicts')) d.createObjectStore('conflicts', { keyPath: 'mutation_uid' })
          if (!d.objectStoreNames.contains('rejected')) d.createObjectStore('rejected', { keyPath: 'mutation_uid' })
        }
        req.onsuccess = function () {
          var d = req.result
          d.onversionchange = function () { d.close(); dbPromise = null }
          resolve(d)
        }
        req.onerror = function () { hasIdb = false; resolve(null) }
      })
      return dbPromise
    }
    function listAll(name) {
      return idb().then(function (d) {
        if (!d) return memStore[name].slice()
        return new Promise(function (resolve, reject) {
          var tx = d.transaction(name, 'readonly')
          var req = tx.objectStore(name).getAll()
          req.onsuccess = function () { resolve(req.result || []) }
          req.onerror = function () { reject(req.error) }
        })
      })
    }
    function putRow(name, row) {
      return idb().then(function (d) {
        if (!d) {
          if (name === 'mutations' && row.seq === undefined) { row.seq = memStore.seq++; memStore.mutations.push(row) }
          else if (name === 'mutations') {
            var at = -1
            for (var m = 0; m < memStore.mutations.length; m++) { if (memStore.mutations[m].seq === row.seq) { at = m; break } }
            if (at >= 0) memStore.mutations[at] = row; else memStore.mutations.push(row)
          }
          else {
            var arr = memStore[name]
            var kf = name === 'files' ? 'file_id' : 'mutation_uid'
            var i = -1
            for (var j = 0; j < arr.length; j++) { if (arr[j][kf] === row[kf]) { i = j; break } }
            if (i >= 0) arr[i] = row; else arr.push(row)
          }
          return row
        }
        return new Promise(function (resolve, reject) {
          var tx = d.transaction(name, 'readwrite')
          tx.objectStore(name).put(row)
          tx.oncomplete = function () { resolve(row) }
          tx.onerror = function () { reject(tx.error) }
        })
      })
    }
    function deleteRow(name, key) {
      return idb().then(function (d) {
        if (!d) {
          var keyField = name === 'mutations' ? 'seq' : name === 'files' ? 'file_id' : 'mutation_uid'
          memStore[name] = memStore[name].filter(function (r) { return r[keyField] !== key })
          return
        }
        return new Promise(function (resolve, reject) {
          var tx = d.transaction(name, 'readwrite')
          tx.objectStore(name).delete(key)
          tx.oncomplete = function () { resolve() }
          tx.onerror = function () { reject(tx.error) }
        })
      })
    }

    function refreshCounts() {
      return listAll('mutations').then(function (ms) {
        return listAll('conflicts').then(function (cs) {
          return listAll('rejected').then(function (rs) {
            ms.sort(function (a, b) { return (a.seq || 0) - (b.seq || 0) || a.created_at - b.created_at })
            pendingRef.value = ms.length
            queueRef.value = ms
            conflictsRef.value = cs
            rejectedRef.value = rs
          })
        })
      })
    }

    function fire(name, payload) {
      try { busFire('event:' + name, payload) } catch (_) { /* */ }
    }

    function requestBackgroundSync() {
      try {
        if (typeof navigator !== 'undefined' && navigator.serviceWorker && navigator.serviceWorker.ready) {
          navigator.serviceWorker.ready.then(function (reg) {
            if (reg && reg.sync && typeof reg.sync.register === 'function') {
              reg.sync.register('rt-offline-replay').catch(function () { /* */ })
            }
          }).catch(function () { /* */ })
        }
      } catch (_) { /* */ }
    }

    async function enqueueMutation(dsUid, input, base, files) {
      var mutationUid = rtUuid()
      var row = {
        mutation_uid: mutationUid,
        ds_uid: dsUid,
        input: input,
        base: base || null,
        created_at: Date.now(),
      }
      if (files && files.length) row.files = files
      await putRow('mutations', row)
      await refreshCounts()
      fire('offline-queued', { mutation_uid: mutationUid, ds_uid: dsUid })
      requestBackgroundSync()
      return { offline: true, queued: true, mutation_uid: mutationUid, uid: input && input.uid }
    }

    async function replaySend(row) {
      var res = await fetch('/runtime/ds/' + row.ds_uid, {
        method: 'POST',
        credentials: 'include',
        // X-DS-Full keeps the wire response on the { data, meta } envelope (see
        // dsFetchEnvelope). This replay only reads `status` + the 409 error
        // body, but we stay on the envelope for a byte-identical internal wire.
        headers: { 'Content-Type': 'application/json', 'X-Mutation-Id': row.mutation_uid, 'X-DS-Full': '1' },
        body: JSON.stringify({ input: row.input || {}, base: row.base || undefined }),
      })
      var json = null
      try { json = await res.json() } catch (_) { /* */ }
      return { status: res.status, json: json }
    }

    async function replay() {
      if (replaying || authPaused) return { drained: false }
      if (typeof navigator !== 'undefined' && navigator.onLine === false) return { drained: false }
      replaying = true
      try {
        for (;;) {
          var rows = await listAll('mutations')
          rows.sort(function (a, b) { return (a.seq || 0) - (b.seq || 0) || a.created_at - b.created_at })
          if (!rows.length) break
          var row = rows[0]
          var rowKey = row.seq !== undefined ? row.seq : row.mutation_uid
          var out = null
          if (row.files && row.files.length) {
            try { await uploadRowFiles(row) } catch (e) { out = { status: e && e.status >= 400 && e.status < 500 ? e.status : 0, json: { error: (e && e.message) || 'upload failed' } } }
          }
          if (!out) { try { out = await replaySend(row) } catch (_) { out = { status: 0, json: null } } }
          if (out.status >= 200 && out.status < 300) {
            await deleteRow('mutations', rowKey)
            retryDelay = 2000
            continue
          }
          if (out.status === 401) {
            authPaused = true
            fire('offline-auth-required', { mutation_uid: row.mutation_uid })
            break
          }
          if (out.status === 409) {
            await deleteRow('mutations', rowKey)
            var conflictRow = {
              mutation_uid: row.mutation_uid, ds_uid: row.ds_uid, input: row.input, base: row.base,
              conflict: (out.json && out.json.conflict) || null, created_at: row.created_at,
            }
            await putRow('conflicts', conflictRow)
            fire('offline-conflict', conflictRow)
            continue
          }
          if (out.status >= 400 && out.status < 500) {
            await deleteRow('mutations', rowKey)
            var rejRow = {
              mutation_uid: row.mutation_uid, ds_uid: row.ds_uid, input: row.input,
              status: out.status, error: (out.json && out.json.error) || null,
              errors: (out.json && out.json.errors) || null, created_at: row.created_at,
            }
            await putRow('rejected', rejRow)
            await dropRowFiles(row)
            fire('offline-rejected', rejRow)
            continue
          }
          // network error / 5xx → stop, keep order, retry with backoff
          if (retryTimer) clearTimeout(retryTimer)
          retryTimer = setTimeout(function () { replay() }, retryDelay)
          retryDelay = Math.min(retryDelay * 2, 5 * 60 * 1000)
          break
        }
      } finally {
        replaying = false
        await refreshCounts()
        if (pendingRef.value === 0) fire('offline-synced', {})
      }
      return { drained: pendingRef.value === 0 }
    }

    // Offline files: the blob waits in the 'files' store, the mutation carries { field, file_id }; replay uploads
    // each blob first, writes the fileUid into input[field] and persists the row before sending it.
    var FILE_QUEUE_MAX = 20 * 1024 * 1024
    async function uploadRowFiles(row) {
      var rest = row.files.slice()
      while (rest.length) {
        var ref = rest[0]
        var all = await listAll('files')
        var rec = null
        for (var i = 0; i < all.length; i++) { if (all[i].file_id === ref.file_id) { rec = all[i]; break } }
        if (!rec) { var gone = new Error('El archivo en cola ya no existe.'); gone.status = 410; throw gone }
        var up = await Runtime.upload(rec.blob, { name: rec.name, mime: rec.type, size: rec.size })
        row.input = Object.assign({}, row.input || {})
        row.input[ref.field] = up.fileUid
        rest.shift()
        row.files = rest.slice()
        await putRow('mutations', row)
        await deleteRow('files', ref.file_id)
      }
      delete row.files
    }
    async function dropRowFiles(row) {
      var refs = row.files || []
      for (var i = 0; i < refs.length; i++) await deleteRow('files', refs[i].file_id)
    }
    async function queuedBytes() {
      var all = await listAll('files')
      var n = 0
      for (var i = 0; i < all.length; i++) n += all[i].size || 0
      return n
    }
    async function queueFile(file, opts) {
      var o = opts || {}
      if (!o.dsUid || !o.field) throw new Error('Runtime.files.queue: dsUid and field are required')
      var inp = Object.assign({}, o.input || {})
      if (typeof inp.uid !== 'string' || !inp.uid) inp.uid = rtUuid()
      if (!(typeof navigator !== 'undefined' && navigator.onLine === false)) {
        try {
          var up = await Runtime.upload(file)
          inp[o.field] = up.fileUid
          return runOrQueue(o.dsUid, inp)
        } catch (err) {
          if (!(err && err.status === 0)) throw err
        }
      }
      var size = (file && file.size) || 0
      if ((await queuedBytes()) + size > FILE_QUEUE_MAX) {
        try { toast('Sin espacio para más archivos sin conexión. Conéctate para enviar los pendientes.', { tone: 'error' }) } catch (_) { /* */ }
        var full = new Error('offline file queue full'); full.code = 'FILE_QUEUE_FULL'
        throw full
      }
      var fileId = rtUuid()
      await putRow('files', { file_id: fileId, blob: file, name: (file && file.name) || 'file', type: (file && file.type) || 'application/octet-stream', size: size, created_at: Date.now() })
      inp[o.field] = null
      return enqueueMutation(o.dsUid, inp, o.base || null, [{ field: o.field, file_id: fileId }])
    }

    async function runOrQueue(uid, input) {
      var inp = Object.assign({}, input || {})
      // `__base` is the operator-supplied conflict snapshot for 'check'-mode
      // DSs. It travels OUTSIDE the input (the executor reads body.base).
      var base = inp.__base || null
      delete inp.__base
      if (typeof inp.uid !== 'string' || !inp.uid) inp.uid = rtUuid() // client row uid (ignored by non-insert DSs)
      if (typeof navigator !== 'undefined' && navigator.onLine === false) {
        return enqueueMutation(uid, inp, base)
      }
      try {
        var envelope = await dsFetchEnvelope(uid, inp)
        dsAfterWrite(envelope)
        return envelope && Object.prototype.hasOwnProperty.call(envelope, 'data') ? envelope.data : envelope
      } catch (err) {
        if (err && err.status === 0) {
          return enqueueMutation(uid, inp, base)
        }
        throw err
      }
    }

    if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
      window.addEventListener('online', function () { replay() })
    }
    setTimeout(function () { refreshCounts().then(function () { if (pendingRef.value > 0) replay() }).catch(function () { /* */ }) }, 0)

    return {
      get enabled() { var s = offlineDsSet(); for (var k in s) return true; return false },
      get pending() { return pendingRef.value },
      // Pending mutation rows (FIFO): [{ mutation_uid, ds_uid, input, base, created_at }].
      // Read-your-own-writes: pages merge these over cached server reads so the
      // day's offline creations/edits are VISIBLE before tonight's sync.
      get queue() { return queueRef.value },
      get conflicts() { return conflictsRef.value },
      get rejected() { return rejectedRef.value },
      // Warmup progress (reactive): { state: 'idle'|'running'|'done', done, total }.
      // The refs are declared in the warmup section below (assigned before any
      // access — getters only run post-boot).
      get warmup() {
        return { state: warmupStateRef.value, done: warmupDoneRef.value, total: warmupTotalRef.value }
      },
      isOfflineDs: function (uid) { return !!offlineDsSet()[uid] },
      runOrQueue: runOrQueue,
      queueFile: queueFile,
      queuedBytes: queuedBytes,
      replay: replay,
      resumeAfterAuth: function () { authPaused = false; return replay() },
      resolveConflict: async function (mutationUid, action) {
        var cs = await listAll('conflicts')
        var row = null
        for (var i = 0; i < cs.length; i++) { if (cs[i].mutation_uid === mutationUid) { row = cs[i]; break } }
        if (!row) return { ok: false, reason: 'not_found' }
        await deleteRow('conflicts', mutationUid)
        if (action === 'force') {
          // Re-queue with base stripped (LWW override). SAME mutation_uid is
          // safe: the 409 happened BEFORE the server recorded the mutation.
          await putRow('mutations', { mutation_uid: row.mutation_uid, ds_uid: row.ds_uid, input: row.input, base: null, created_at: Date.now() })
          await refreshCounts()
          return replay().then(function () { return { ok: true } })
        }
        await refreshCounts()
        return { ok: true } // 'drop'
      },
      clearRejected: async function () {
        var rs = await listAll('rejected')
        for (var i = 0; i < rs.length; i++) await deleteRow('rejected', rs[i].mutation_uid)
        await refreshCounts()
      },
    }
  })()
  Runtime.offline = Offline
  Runtime.files = { queue: Offline.queueFile, queuedBytes: Offline.queuedBytes }

  var ReadCache = (function () {
    var CAP = 150
    var EVICT = 30
    var memEntries = Object.create(null)
    var hasIdb = (typeof indexedDB !== 'undefined')
    var dbPromise = null

    // Gated on BOTH the app opt-in (rt-offline-reads) AND the device having
    // the app installed — browser tabs don't accumulate offline read caches.
    function enabled() { return rtReadMeta('rt-offline-reads') === '1' && isInstalledDevice() }
    function cachedReadSet() { return rtMetaSet('rt-cached-reads') }
    // Dataset DSs (incremental delta sync) → map uid → pk column. Meta entries
    // are `uid` (default pk 'uid') or `uid:pk` (non-default).
    function datasetSet() {
      var raw = rtReadMeta('rt-dataset-ds') || ''
      var out = {}
      raw.split(',').forEach(function (s) {
        s = (s || '').trim()
        if (!s) return
        var c = s.indexOf(':')
        if (c > 0) out[s.slice(0, c)] = s.slice(c + 1) || 'uid'
        else out[s] = 'uid'
      })
      return out
    }
    var DATASET_FULL_REFRESH_MS = 24 * 60 * 60 * 1000
    // Stable stringify — object key order must not change the cache key.
    function stableStr(v) {
      if (v === null || typeof v !== 'object') return JSON.stringify(v) || 'undefined'
      if (Array.isArray(v)) { return '[' + v.map(stableStr).join(',') + ']' }
      var ks = Object.keys(v).sort()
      return '{' + ks.map(function (k) { return JSON.stringify(k) + ':' + stableStr(v[k]) }).join(',') + '}'
    }

    function idb() {
      if (!hasIdb) return Promise.resolve(null)
      if (dbPromise) return dbPromise
      dbPromise = new Promise(function (resolve) {
        var req = indexedDB.open('rt-readcache-' + (rtReadMeta('rt-app-uid') || 'noapp'), 1)
        req.onupgradeneeded = function () {
          var d = req.result
          if (!d.objectStoreNames.contains('entries')) d.createObjectStore('entries', { keyPath: 'key' })
        }
        req.onsuccess = function () { resolve(req.result) }
        req.onerror = function () { hasIdb = false; resolve(null) }
      })
      return dbPromise
    }
    function get(key) {
      return idb().then(function (d) {
        if (!d) return memEntries[key] || null
        return new Promise(function (resolve) {
          var req = d.transaction('entries', 'readonly').objectStore('entries').get(key)
          req.onsuccess = function () { resolve(req.result || null) }
          req.onerror = function () { resolve(null) }
        })
      })
    }
    function put(key, value) {
      var row = { key: key, value: value, ts: Date.now() }
      return idb().then(function (d) {
        if (!d) { memEntries[key] = row; return }
        return new Promise(function (resolve) {
          var tx = d.transaction('entries', 'readwrite')
          tx.objectStore('entries').put(row)
          tx.oncomplete = function () { resolve(); evictIfNeeded(d) }
          tx.onerror = function () { resolve() }
        })
      }).catch(function () { /* */ })
    }
    var evicting = false
    function evictIfNeeded(d) {
      if (evicting) return
      evicting = true
      try {
        var store = d.transaction('entries', 'readonly').objectStore('entries')
        var countReq = store.count()
        countReq.onsuccess = function () {
          if (countReq.result <= CAP) { evicting = false; return }
          var all = store.getAll ? d.transaction('entries', 'readonly').objectStore('entries').getAll() : null
          if (!all) { evicting = false; return }
          all.onsuccess = function () {
            var rows = (all.result || []).sort(function (a, b) { return a.ts - b.ts }).slice(0, EVICT)
            var tx = d.transaction('entries', 'readwrite')
            rows.forEach(function (r) { tx.objectStore('entries').delete(r.key) })
            tx.oncomplete = function () { evicting = false }
            tx.onerror = function () { evicting = false }
          }
          all.onerror = function () { evicting = false }
        }
        countReq.onerror = function () { evicting = false }
      } catch (_) { evicting = false }
    }

    // Max(updated_at) over a row set → ISO checkpoint, or null if none parse.
    function maxUpdatedAt(rows) {
      var best = null
      for (var i = 0; i < rows.length; i++) {
        var u = rows[i] && rows[i].updated_at
        if (u == null) continue
        var t = Date.parse(u)
        if (Number.isNaN(t)) continue
        if (best === null || t > best) best = t
      }
      return best === null ? null : new Date(best).toISOString()
    }

    // Deletions are not delta-propagated: an entry older than 24h resyncs in full.
    async function datasetFetch(uid, pk) {
      var key = 'ds:' + uid + ':' + stableStr({})
      var hit = await get(key)
      var entry = hit && hit.value && hit.value.__dataset ? hit.value : null
      var since = null
      // Full refresh path: no entry, OR the checkpoint is stale (>24h old).
      if (entry && entry.checkpoint && (Date.now() - Date.parse(entry.checkpoint)) < DATASET_FULL_REFRESH_MS) {
        since = entry.checkpoint
      } else {
        entry = null // force a full fetch (rebuild the map from scratch)
      }
      try {
        var env = await dsFetchEnvelope(uid, {}, since ? { datasetSince: since } : undefined)
        var rows = (env && Array.isArray(env.data)) ? env.data : []
        var map = entry ? Object.assign(Object.create(null), entry.rows) : Object.create(null)
        for (var i = 0; i < rows.length; i++) {
          var r = rows[i]
          if (r && r[pk] != null) map[String(r[pk])] = r
        }
        var deltaCheckpoint = maxUpdatedAt(rows)
        var checkpoint = deltaCheckpoint || (entry && entry.checkpoint) || new Date().toISOString()
        var meta = (env && env.meta) || {}
        var nextEntry = { __dataset: true, rows: map, checkpoint: checkpoint, meta: meta }
        put(key, nextEntry) // fire-and-forget
        var all = []
        for (var k in map) all.push(map[k])
        return { data: all, meta: Object.assign({}, meta, { dataset: true, count: all.length }) }
      } catch (err) {
        if (err && err.status === 0 && entry) {
          // Offline — serve the last merged row set.
          var off = []
          for (var k2 in entry.rows) off.push(entry.rows[k2])
          return { data: off, meta: Object.assign({}, entry.meta, { dataset: true, offline_cached: true, count: off.length }) }
        }
        throw err
      }
    }

    // Read-through wrapper for SELECT-operation DS calls.
    async function dsFetch(uid, input, opts) {
      // Dataset DSs route through the incremental delta path, but ONLY for the
      // no-input call (the prewarm/whole-catalog read). A non-empty input means
      // a filtered/parameterized query — fall through to the normal read-through.
      var inp = input || {}
      var dsSet = datasetSet()
      if (enabled() && dsSet[uid] && Object.keys(inp).length === 0) {
        return datasetFetch(uid, dsSet[uid])
      }
      if (!enabled() || !cachedReadSet()[uid]) return dsReadEnvelope(uid, input, opts)
      var key = 'ds:' + uid + ':' + stableStr(input || {})
      try {
        var env = await dsReadEnvelope(uid, input, opts)
        put(key, env) // fire-and-forget
        return env
      } catch (err) {
        if (err && err.status === 0) {
          var hit = await get(key)
          if (hit) {
            var stale = hit.value
            try { stale = Object.assign({}, hit.value, { meta: Object.assign({}, hit.value && hit.value.meta, { offline_cached: true, cached_at: hit.ts }) }) } catch (_) { /* */ }
            return stale
          }
        }
        throw err
      }
    }

    // Every stored envelope of one DS (any input, dataset included): an invalidated read never replays.
    function drop(uid) {
      var prefix = 'ds:' + uid + ':'
      for (var k in memEntries) if (k.indexOf(prefix) === 0) delete memEntries[k]
      if (!hasIdb || !dbPromise || typeof IDBKeyRange === 'undefined') return Promise.resolve()
      return idb().then(function (d) {
        if (!d) return
        try { d.transaction('entries', 'readwrite').objectStore('entries').delete(IDBKeyRange.bound(prefix, prefix + '\uffff')) } catch (_) { /* */ }
      })
    }

    return { enabled: enabled, get: get, put: put, drop: drop, dsFetch: dsFetch, keyOf: stableStr, cachedReadSet: cachedReadSet }
  })()

  // ── Query registry: tag invalidation, freshness, optimistic writes ───────────
  // An entry is { key, uids:Set, tags, scope, staleTime, focus, reconnect, fetchedAt, refetch, get, set }.
  var RT_ORIGIN = rtUuid()
  var DS_STALE_MS = 30000
  var DS_RETRY_DELAYS = [300, 1200]
  var queryEntries = new Set()
  var queryCollecting = null // Set<uid> while a useAsyncData fetcher is being started
  var dsTagsRaw = null
  var dsTagsMap = Object.create(null)

  function dsTagMap() {
    var raw = rtReadMeta('rt-ds-tags') || ''
    if (raw === dsTagsRaw) return dsTagsMap
    dsTagsRaw = raw
    dsTagsMap = Object.create(null)
    raw.split(',').forEach(function (s) {
      var c = s.indexOf(':')
      if (c > 0) dsTagsMap[s.slice(0, c).trim()] = s.slice(c + 1).split('|').filter(Boolean)
    })
    return dsTagsMap
  }
  function tagList(t) { return (Array.isArray(t) ? t : t == null ? [] : [t]).map(String).filter(Boolean) }
  function tagsMeet(a, b) { for (var i = 0; i < a.length; i++) if (b.indexOf(a[i]) >= 0) return true; return false }
  function queryTags(e) {
    var out = e.tags.slice()
    e.uids.forEach(function (u) { (dsTagMap()[u] || []).forEach(function (t) { if (out.indexOf(t) < 0) out.push(t) }) })
    return out
  }
  function queryTouched(e) {
    if (queryTags(e).length && Runtime.live && Runtime.live.ensureTopic) Runtime.live.ensureTopic('ds:invalidate')
  }
  function queryRegister(scope, e) {
    queryEntries.add(e)
    if (scope) addDisposer(scope, function () { queryEntries.delete(e) })
    queryEnsureListeners()
    queryTouched(e)
  }
  function queryFind(key) {
    var hit = null
    queryEntries.forEach(function (e) { if (e.key === key) hit = e })
    return hit
  }
  // One refetch per entry at a time: a second trigger while one runs joins it.
  function queryRun(e) {
    if (e.inflight) return e.inflight
    var p = Promise.resolve().then(e.refetch)
    var done = function () { if (e.inflight === p) e.inflight = null }
    e.inflight = p
    p.then(done, done)
    return p.catch(function () { /* the entry carries its own error state */ })
  }
  function dsDropReads(uids) {
    uids.forEach(function (u) {
      ReadCache.drop(u)
      for (var k in dsInflight) if (k.indexOf(u + '|') === 0) delete dsInflight[k]
    })
  }
  function queryInvalidate(tags) {
    tags = tagList(tags)
    var map = dsTagMap(), uids = []
    for (var u in map) if (tagsMeet(map[u], tags)) uids.push(u)
    dsDropReads(uids)
    var runs = []
    queryEntries.forEach(function (e) { if (tagsMeet(queryTags(e), tags)) runs.push(queryRun(e)) })
    return Promise.all(runs).then(function () { return runs.length })
  }
  function queryRefetchUid(uid) {
    dsDropReads([uid])
    var runs = []
    queryEntries.forEach(function (e) { if (e.uids.has(uid)) runs.push(queryRun(e)) })
    return Promise.all(runs).then(function () { return runs.length })
  }
  var queryListening = false
  function queryEnsureListeners() {
    if (queryListening || typeof document === 'undefined' || !document.addEventListener) return
    queryListening = true
    document.addEventListener('visibilitychange', function () { if (document.visibilityState !== 'hidden') queryRefreshStale('focus') })
    if (typeof window !== 'undefined' && window.addEventListener) window.addEventListener('online', function () { queryRefreshStale('reconnect') })
  }
  function queryRefreshStale(reason) {
    var now = Date.now()
    queryEntries.forEach(function (e) {
      if (reason === 'focus' ? !e.focus : !e.reconnect) return
      if (!(e.staleTime < Infinity) || now - e.fetchedAt < e.staleTime) return
      queryRun(e)
    })
  }
  // A read through a scoped `ds` (setup, handlers): refetched data reaches the page as `event:ds:data`.
  function queryTrackRead(scope, uid, input, opts, p) {
    var key = uid + '|' + ReadCache.keyOf(input || {})
    var e = null
    queryEntries.forEach(function (x) { if (x.key === key && x.scope === scope) e = x })
    if (!e) {
      e = { key: key, uids: new Set([uid]), tags: [], scope: scope, data: undefined, fetchedAt: Date.now(), focus: true, reconnect: true }
      e.get = function () { return e.data }
      e.set = function (v) { e.data = v; busFire('event:ds:data', { key: key, uid: uid, input: input || {}, data: v }) }
      e.refetch = function () {
        return Runtime.ds(uid, input, { retry: opts && opts.retry }).then(function (d) { e.fetchedAt = Date.now(); e.set(d); return d })
      }
      queryRegister(scope, e)
    }
    e.staleTime = opts && opts.staleTime != null ? opts.staleTime : DS_STALE_MS
    p.then(function (d) { e.data = d; e.fetchedAt = Date.now() }, function () { /* */ })
  }
  function makeScopedDs(scope, base) {
    var fn = function (uid, input, opts) {
      var p = base(uid, input, opts)
      if (!queryCollecting && !(opts && opts.optimistic) && dsIsDeclaredRead(uid) && p && p.then) queryTrackRead(scope, uid, input, opts, p)
      return p
    }
    fn.full = base.full
    fn.mutate = base.mutate
    return fn
  }

  // ── Read retry: network errors and 5xx back off 300 ms then 1200 ms (±20 %) ─
  function dsRetryable(e) { var s = e && e.status; return s === 0 || s >= 500 }
  function dsOffline() { try { return typeof navigator !== 'undefined' && navigator.onLine === false } catch (_) { return false } }
  async function dsWithRetry(send, retries) {
    for (var attempt = 0; ; attempt++) {
      try { return await send() } catch (e) {
        if (attempt >= retries || !dsRetryable(e) || dsOffline()) throw e
        var base = DS_RETRY_DELAYS[Math.min(attempt, DS_RETRY_DELAYS.length - 1)]
        await new Promise(function (r) { setTimeout(r, base * (0.8 + Math.random() * 0.4)) })
      }
    }
  }

  function dsUnwrap(env) { return env && Object.prototype.hasOwnProperty.call(env, 'data') ? env.data : env }
  function dsAfterWrite(env) {
    var inv = env && env.meta && env.meta.invalidates
    if (Array.isArray(inv) && inv.length) queryInvalidate(inv)
  }
  async function dsCall(uid, input, opts, full) {
    opts = opts || {}
    var fromFetcher = !!queryCollecting
    if (queryCollecting) queryCollecting.add(uid)
    if (opts.optimistic) return dsOptimistic(uid, input, opts, full)
    if (Offline.isOfflineDs(uid)) return Offline.runOrQueue(uid, input)
    var env
    // A write the caller retries carries ONE Idempotency-Key for the whole action, so a retry never runs it twice.
    var retriedWrite = !fromFetcher && !dsIsDeclaredRead(uid) && opts.retry > 0
    if (retriedWrite || opts.idempotencyKey || (opts.expect !== undefined && opts.expect !== null)) {
      var single = { expect: opts.expect, idempotencyKey: opts.idempotencyKey || (retriedWrite ? rtUuid() : null) }
      env = await dsWithRetry(function () { return dsFetchEnvelope(uid, input, single) }, opts.retry > 0 ? opts.retry : 0)
    } else {
      env = await ReadCache.dsFetch(uid, input, { retry: opts.retry, read: fromFetcher })
    }
    dsAfterWrite(env)
    return full ? env : dsUnwrap(env)
  }
  // The entry under `optimistic.key` shows apply(current) at once; success refetches it (or takes the
  // write's data with `useResult`), failure restores the snapshot. A queued offline write keeps it.
  async function dsOptimistic(uid, input, opts, full) {
    var o = opts.optimistic
    var e = o && o.key != null ? queryFind(o.key) : null
    var snapshot = e ? e.get() : undefined
    if (e && typeof o.apply === 'function') e.set(o.apply(snapshot))
    try {
      if (Offline.isOfflineDs(uid)) return await Offline.runOrQueue(uid, input)
      var env = await ReadCache.dsFetch(uid, input, { retry: opts.retry != null ? opts.retry : 0 })
      if (e && o.useResult && env && Object.prototype.hasOwnProperty.call(env, 'data')) { e.set(env.data); e.fetchedAt = Date.now() }
      var inv = env && env.meta && env.meta.invalidates
      var covered = e && Array.isArray(inv) && tagsMeet(queryTags(e), inv)
      dsAfterWrite(env)
      if (e && !o.useResult && !covered) queryRun(e)
      return full ? env : dsUnwrap(env)
    } catch (err) {
      if (e) e.set(snapshot)
      throw err
    }
  }

  Runtime.ds = function ds(uid, input, opts) { return dsCall(uid, input, opts, false) }
  // static/validate.js (prepended at serve time): the checks behind the executor's 422, for a pre-check before the request.
  Runtime.validate = typeof rtCreateValidate === 'function' ? rtCreateValidate() : null
  // .full keeps the raw envelope contract.
  Runtime.ds.full = function dsFull(uid, input, opts) { return dsCall(uid, input, opts, true) }
  Runtime.ds.mutate = function dsMutate(uid, input, opts) {
    if (!opts || !opts.optimistic) return Promise.reject(new TypeError('ds.mutate needs { optimistic: { key, apply } }'))
    return dsCall(uid, input, opts, false)
  }
  Runtime.invalidate = function invalidate(tags) { return queryInvalidate(tags) }

  Runtime.auth = (function () {
    const userRef = ref(null) // reactive — templates/scripts reading user re-eval
    let fetched = false
    let grants = null
    let callableDs = null // uids + names of the DataSources this user may call (definition.access)

    function normalizeRef(rest) {
      if (rest.length === 1 && typeof rest[0] === 'object' && rest[0] !== null) {
        const r = rest[0]
        return { type: r.type || 'datasource', uid: r.uid || null, field: r.field || null }
      }
      if (rest.length === 1 && typeof rest[0] === 'string') return { type: 'datasource', uid: rest[0] }
      if (rest.length >= 2 && typeof rest[0] === 'string' && typeof rest[1] === 'string') {
        return { type: rest[0], uid: rest[1], field: typeof rest[2] === 'string' ? rest[2] : null }
      }
      return { type: 'datasource', uid: null }
    }
    function canCheck(action) {
      const rest = Array.prototype.slice.call(arguments, 1)
      if (!grants || !Array.isArray(grants)) return false
      const refr = normalizeRef(rest)
      if (refr.type === 'datasource') {
        return action === 'call' && refr.uid != null && Array.isArray(callableDs) && callableDs.indexOf(refr.uid) >= 0
      }
      const cur = userRef.value
      const roles = (cur && cur.roles) || []
      const hasAdmin = roles.indexOf('admin') >= 0
      const adminHasGrants = grants.some(function (g) { return g.role_name === 'admin' })
      if (hasAdmin && !adminHasGrants) return true
      for (const g of grants) {
        if (g.resource_type !== refr.type) continue
        if (g.actions.indexOf(action) < 0) continue
        if (refr.type === 'field' && refr.field && g.field_name && g.field_name !== refr.field) continue
        if (g.resource_uid != null && refr.uid != null && g.resource_uid !== refr.uid) continue
        return true
      }
      return false
    }
    function authBase() {
      const uid = rtReadMeta('rt-app-uid')
      if (!uid) throw new Error('Runtime.auth: missing <meta name="rt-app-uid"> — auth is not enabled on this app')
      return '/app/' + uid + '/auth'
    }
    async function call(path, init) {
      init = init || {}
      const headers = Object.assign({}, init.headers || {})
      // Only declare a JSON content-type when we actually send a body. Fastify's
      // application/json parser rejects an EMPTY body (FST_ERR_CTP_EMPTY_JSON_BODY),
      // which broke body-less POSTs like /signout (Runtime.auth.signOut()).
      const hasCt = Object.keys(headers).some(function (k) { return k.toLowerCase() === 'content-type' })
      if (init.body != null && !hasCt) headers['content-type'] = 'application/json'
      const res = await fetch(authBase() + path, Object.assign({
        credentials: 'same-origin',
      }, init, { headers }))
      const json = await res.json().catch(function () { return {} })
      if (!res.ok) {
        const err = new Error((json && json.error) || ('HTTP ' + res.status))
        err.status = res.status; err.body = json
        throw err
      }
      return json
    }
    function setUser(u) {
      if (u) u.can = canCheck
      userRef.value = u || null
    }
    async function signedIn(r) {
      setUser((r && r.user) || null)
      await api.refresh() // pull fresh grants — the sign-in response doesn't carry them
      // Resume any offline replay paused on a 401 (session expired mid-queue).
      try { if (Runtime.offline) Runtime.offline.resumeAfterAuth() } catch (_) { /* */ }
      return r
    }
    // Opens the <auth-two-factor> overlay and settles on its
    // `event:auth-two-factor-done` ({ ok }). The overlay emits on every way it can
    // close (verify, cancel, Escape, backdrop, teardown), so the wait always ends.
    function twoFactorStep(labels) {
      return new Promise(function (resolve, reject) {
        let settled = false
        function cancelled(message, code) {
          const e = new Error(message); e.code = code
          return e
        }
        const off = busSubscribe('event:auth-two-factor-done', function (p) {
          if (settled) return
          settled = true; off()
          if (p && p.ok) resolve()
          else reject(cancelled('Two-factor cancelled', 'two_factor_cancelled'))
        })
        Promise.resolve(open('auth-two-factor', labels ? { labels: labels } : {})).then(function (handle) {
          if (handle || settled) return
          settled = true; off()
          reject(cancelled('The authentication-code step could not be opened', 'two_factor_unavailable'))
        }, function (err) {
          if (settled) return
          settled = true; off()
          reject(err)
        })
      })
    }
    function applyMe(json) {
      grants = (json && json.grants) || []
      callableDs = (json && json.datasources) || []
      setUser((json && json.user) || null)
    }
    // The document's `rt-me` is `/auth/me` for the identity it was rendered for. Offline the document may be a
    // service-worker copy of an earlier session, so the boot asks instead (and fails to no user, as before).
    function inlineMe() {
      if (typeof navigator !== 'undefined' && navigator.onLine === false) return null
      const el = typeof document !== 'undefined' && document.getElementById ? document.getElementById('rt-me') : null
      if (!el) return null
      try { return JSON.parse(el.textContent || '') } catch (_) { return null }
    }
    const api = {
      get user() { return userRef.value },
      async refresh() {
        try { applyMe(await call('/me', { method: 'GET' })) } catch (_) { grants = null; callableDs = null; setUser(null) }
        fetched = true
        return userRef.value
      },
      async signIn(input, opts) {
        const r = await call('/signin', { method: 'POST', body: JSON.stringify(input || {}) })
        if (!(r && r.twoFactorRequired)) return signedIn(r)
        if (opts && opts.twoFactor === 'manual') return r
        await twoFactorStep(opts && opts.labels)
        if (!userRef.value) await api.refresh()
        return { user: userRef.value }
      },
      async verifyTwoFactor(input) {
        const body = { code: String((input && input.code) || '').trim(), trustDevice: !!(input && input.trustDevice) }
        return signedIn(await call('/two-factor', { method: 'POST', body: JSON.stringify(body) }))
      },
      async signUp(input) {
        const r = await call('/signup', { method: 'POST', body: JSON.stringify(input || {}) })
        setUser((r && r.user) || null)
        await api.refresh()
        return r
      },
      async signOut() {
        try { await call('/signout', { method: 'POST' }) } catch (_) { /* swallow */ }
        setUser(null)
        // The cached documents belong to the person who just left: the SW drops them before the next visitor.
        try { if (navigator.serviceWorker && navigator.serviceWorker.controller) navigator.serviceWorker.controller.postMessage({ type: 'rt-clear-pages' }) } catch (_) { /* */ }
        const after = rtReadMeta('rt-after-signout') || '/'
        if (typeof Runtime.navigate === 'function') Runtime.navigate(after)
        else { try { window.location.href = after } catch (_) { /* */ } }
      },
      async impersonate(userUid) {
        await call('/impersonate', { method: 'POST', body: JSON.stringify({ user_uid: String(userUid || '') }) })
        window.location.assign('/')
      },
      async stopImpersonating() {
        try { await call('/impersonate/stop', { method: 'POST' }) } finally { window.location.assign('/') }
      },
      async impersonateCandidates(params) {
        const qs = new URLSearchParams()
        const p = params || {}
        for (const k of ['role', 'q', 'page']) {
          if (p[k] != null && p[k] !== '') qs.set(k, String(p[k]))
        }
        const s = qs.toString()
        return call('/impersonate/candidates' + (s ? '?' + s : ''), { method: 'GET' })
      },
      // The signed-in user's own sessions (devices); `current` marks this one.
      async sessions() {
        const r = await call('/sessions', { method: 'GET' })
        return (r && r.sessions) || []
      },
      async revokeSession(id) {
        const r = await call('/sessions/' + encodeURIComponent(String(id || '')) + '/revoke', { method: 'POST' })
        if (r && r.current) setUser(null)
        return r
      },
      async revokeOtherSessions() {
        return call('/sessions/revoke-others', { method: 'POST' })
      },
      async forgotPassword(email, extra) {
        return call('/forgot-password', { method: 'POST', body: JSON.stringify(Object.assign({}, extra || {}, { email: email })) })
      },
      async resetPassword(input) {
        return call('/reset-password', { method: 'POST', body: JSON.stringify(input || {}) })
      },
      async verifyEmail(token) {
        return call('/verify-email', { method: 'POST', body: JSON.stringify({ token: token }) })
      },
      __init: async function () {
        if (fetched) return
        const me = inlineMe()
        if (me) { applyMe(me); fetched = true; return }
        await api.refresh()
      },
    }
    return api
  })()

  // ── Runtime.upload / Runtime.file (Feature 3) ─────────────────────────────
  function uploadBase() {
    const uid = rtReadMeta('rt-app-uid')
    if (!uid) throw new Error('Runtime.upload: missing <meta name="rt-app-uid">')
    return { appUid: uid, base: '/app/' + uid }
  }
  function readImageDimensions(file) {
    return new Promise(function (resolve, reject) {
      try {
        if (typeof URL === 'undefined' || typeof Image === 'undefined') { resolve({}); return }
        const url = URL.createObjectURL(file)
        const img = new Image()
        img.onload = function () {
          const out = { width: img.naturalWidth, height: img.naturalHeight }
          URL.revokeObjectURL(url); resolve(out)
        }
        img.onerror = function (e) { URL.revokeObjectURL(url); reject(e) }
        img.src = url
      } catch (e) { reject(e) }
    })
  }
  function uploadErr(msg, status) { const e = new Error(msg); e.status = status; return e }
  async function uploadFetch(url, init) {
    try { return await fetch(url, init) } catch (e) { throw uploadErr((e && e.message) || 'network error', 0) }
  }
  Runtime.upload = async function upload(file, opts) {
    const based = uploadBase().base
    const filename = (file && (file.name || (opts && opts.name))) || 'file'
    const mime = (file && (file.type || (opts && opts.mime))) || 'application/octet-stream'
    const size = (file && (file.size || (opts && opts.size))) || 0

    // 1) sign
    const signRes = await uploadFetch(based + '/upload/sign', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ filename: filename, mime: mime, size: size, is_public: !!(opts && opts.is_public) }),
    })
    const signed = await signRes.json().catch(function () { return {} })
    if (!signRes.ok) throw uploadErr((signed && signed.error) || ('sign failed: HTTP ' + signRes.status), signRes.status)

    // 2) PUT to pre-signed URL
    const putRes = await uploadFetch(signed.uploadUrl, {
      method: 'PUT',
      headers: Object.assign({}, signed.headers || {}),
      body: file,
    })
    if (!putRes.ok) throw uploadErr('upload failed: HTTP ' + putRes.status, putRes.status)

    // 3) complete
    let dims = {}
    if (mime.indexOf('image/') === 0) {
      try { dims = await readImageDimensions(file) } catch (_) { /* ignore */ }
    }
    const compRes = await uploadFetch(based + '/upload/complete', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify(Object.assign({ fileUid: signed.fileUid }, dims)),
    })
    const compJson = await compRes.json().catch(function () { return {} })
    if (!compRes.ok) throw uploadErr((compJson && compJson.error) || ('complete failed: HTTP ' + compRes.status), compRes.status)

    return Object.assign({
      fileUid: signed.fileUid,
      url: Runtime.file.url(signed.fileUid),
      filename: filename, mime: mime, size: size,
    }, dims)
  }
  Runtime.file = {
    url: function (uid, opts) {
      if (!uid) return ''
      const based = uploadBase().base
      const q = opts && opts.variant ? ('?variant=' + encodeURIComponent(opts.variant)) : ''
      return based + '/file/' + uid + q
    },
    remove: async function (uid) {
      const based = uploadBase().base
      const r = await fetch(based + '/file/' + uid, { method: 'DELETE', credentials: 'same-origin' })
      if (!r.ok) throw new Error('delete failed: HTTP ' + r.status)
    },
  }

  // ── Runtime.export (Feature 12) ───────────────────────────────────────────
  Runtime.export = {
    async csv(opts) {
      opts = opts || {}
      if (!opts.ds_uid) throw new Error('Runtime.export.csv: ds_uid is required')
      const appUid = rtReadMeta('rt-app-uid') || opts.app_uid || null
      const body = {
        ds_uid: opts.ds_uid,
        input: opts.input || undefined,
        columns: opts.columns || undefined,
        filename: opts.filename || undefined,
      }
      if (appUid) body.app_uid = appUid

      const enqRes = await fetch('/runtime/export/csv', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify(body),
      })
      const enq = await enqRes.json().catch(function () { return {} })
      if (!enqRes.ok) throw new Error((enq && enq.error) || ('export enqueue failed: HTTP ' + enqRes.status))
      const jobUid = enq.jobUid
      const resolvedAppUid = enq.appUid

      const pollDelay = 1000
      const maxWaitMs = (opts.timeoutMs || 120000)
      const startTs = Date.now()
      for (;;) {
        if (Date.now() - startTs > maxWaitMs) throw new Error('export timed out')
        const stRes = await fetch('/runtime/job-status/' + resolvedAppUid + '/' + jobUid, {
          method: 'GET', credentials: 'same-origin',
        })
        const st = await stRes.json().catch(function () { return {} })
        if (!stRes.ok) throw new Error((st && st.error) || ('status check failed: HTTP ' + stRes.status))
        if (typeof opts.onStatus === 'function') {
          try { opts.onStatus(st.status, st.attempts, st.max_attempts) } catch (_) { /* */ }
        }
        if (st.status === 'succeeded') {
          const result = st.result || {}
          const url = result.url
          if (url) {
            try {
              const a = document.createElement('a')
              a.href = url
              a.download = result.filename || 'export.csv'
              a.rel = 'noopener'
              document.body.appendChild(a)
              a.click()
              setTimeout(function () { try { a.remove() } catch (_) { /* */ } }, 100)
            } catch (_) {
              try { window.open(url, '_blank') } catch (__) { /* */ }
            }
          }
          return result
        }
        if (st.status === 'failed' || st.status === 'dead' || st.status === 'cancelled') {
          throw new Error('export ' + st.status + (st.last_error ? (': ' + st.last_error) : ''))
        }
        await new Promise(function (r) { setTimeout(r, pollDelay) })
      }
    },
  }

  // ── Runtime.jobs: one job's { status, progress, message } ─────────────────
  // watch() takes `live:job-progress` SSE events when a stream is open and polls /runtime/job-status with backoff
  // (1 s ×1.5 up to 5 s; with SSE a 5 s backstop that also sees the end); it stops at a final status.
  Runtime.jobs = (function () {
    var FINAL = { succeeded: 1, failed: 1, dead: 1, cancelled: 1 }
    async function status(uid, opts) {
      var appUid = (opts && opts.appUid) || rtReadMeta('rt-app-uid')
      var res = await fetch('/runtime/job-status/' + appUid + '/' + uid, { method: 'GET', credentials: 'include' })
      var st = await rtSafeJson(res)
      if (!res.ok) { var e = new Error((st && st.error) || ('job status ' + res.status)); e.status = res.status; throw e }
      return { status: st.status, progress: st.progress == null ? null : st.progress, message: st.message || null, result: st.result, last_error: st.last_error }
    }
    function watch(uid, cb, opts) {
      opts = opts || {}
      var stopped = false, timer = null, delay = 1000, last = null, off = null
      var maxDelay = opts.maxDelayMs || 5000
      var live = !!(Runtime.live && Runtime.live.connected)
      function emit(st) {
        var key = st.status + '|' + st.progress + '|' + st.message
        if (key === last) return
        last = key
        try { cb(st) } catch (_) { /* a throwing callback never stops the watch */ }
      }
      function stop() {
        stopped = true
        if (timer) { clearTimeout(timer); timer = null }
        if (off) { off(); off = null }
      }
      function schedule(ms) { if (!stopped) { if (timer) clearTimeout(timer); timer = setTimeout(tick, ms) } }
      async function tick() {
        timer = null
        if (stopped) return
        try {
          var st = await status(uid, opts)
          if (stopped) return
          emit(st)
          if (FINAL[st.status]) return stop()
          delay = Math.min(maxDelay, Math.round(delay * 1.5))
        } catch (e) {
          if (e && (e.status === 401 || e.status === 403 || e.status === 404)) { emit({ status: 'error', progress: null, message: e.message }); return stop() }
          delay = Math.min(maxDelay * 2, delay * 2)
        }
        schedule(live ? Math.max(delay, maxDelay) : delay)
      }
      if (live) {
        off = busSubscribe('event:live:job-progress', function (p) {
          if (stopped || !p || p.uid !== uid) return
          emit({ status: p.status, progress: p.progress, message: p.message || null })
          if (p.progress >= 100) schedule(300)
        })
      }
      tick()
      return stop
    }
    return { status: status, watch: watch }
  })()

  // ── Runtime.notifications (Feature 13 — Web Push) ─────────────────────────
  function urlBase64ToUint8Array(b64) {
    const padding = '='.repeat((4 - b64.length % 4) % 4)
    const base64 = (b64 + padding).replace(/-/g, '+').replace(/_/g, '/')
    const raw = atob(base64)
    const out = new Uint8Array(raw.length)
    for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i)
    return out
  }
  Runtime.notifications = {
    get permission() {
      return (typeof Notification !== 'undefined') ? Notification.permission : 'denied'
    },
    async requestPermission() {
      if (typeof Notification === 'undefined') return 'denied'
      return await Notification.requestPermission()
    },
    async subscribe() {
      const uid = rtReadMeta('rt-app-uid')
      const vapid = rtReadMeta('rt-vapid-public')
      if (!uid) throw new Error('Runtime.notifications: missing rt-app-uid meta')
      if (!vapid) throw new Error('Runtime.notifications: missing rt-vapid-public meta (push not configured on this app)')
      if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) throw new Error('Runtime.notifications: no service worker support')
      if (typeof window === 'undefined' || !('PushManager' in window)) throw new Error('Runtime.notifications: no Push API support')

      if (Notification.permission !== 'granted') {
        const perm = await Notification.requestPermission()
        if (perm !== 'granted') throw new Error('Runtime.notifications: permission ' + perm)
      }
      const reg = await navigator.serviceWorker.ready
      const existing = await reg.pushManager.getSubscription()
      const subscription = existing || await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(vapid),
      })
      const subBody = subscription.toJSON()
      const res = await fetch('/app/' + uid + '/push/subscribe', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({
          endpoint: subBody.endpoint,
          keys: subBody.keys,
          user_agent: (typeof navigator !== 'undefined' && navigator.userAgent) || null,
        }),
      })
      const json = await res.json().catch(function () { return {} })
      if (!res.ok) throw new Error((json && json.error) || ('subscribe failed: HTTP ' + res.status))
      try {
        if (reg.active) reg.active.postMessage({ type: 'rt-set-subscription', uid: json.subscription_uid })
        try { localStorage.setItem('rt-push-sub-' + uid, json.subscription_uid) } catch (_) { /* */ }
      } catch (_) { /* */ }
      return { subscription_uid: json.subscription_uid, endpoint: subBody.endpoint }
    },
    async unsubscribe() {
      const uid = rtReadMeta('rt-app-uid')
      if (!uid) return { ok: false }
      if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return { ok: false }
      const reg = await navigator.serviceWorker.ready
      const subscription = await reg.pushManager.getSubscription()
      if (!subscription) return { ok: true, was_subscribed: false }
      const endpoint = subscription.endpoint
      try { await subscription.unsubscribe() } catch (_) { /* */ }
      try {
        await fetch('/app/' + uid + '/push/unsubscribe', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'content-type': 'application/json' },
          body: JSON.stringify({ endpoint: endpoint }),
        })
      } catch (_) { /* swallow — local unsub already happened */ }
      try { localStorage.removeItem('rt-push-sub-' + uid) } catch (_) { /* */ }
      return { ok: true, was_subscribed: true }
    },
  }

  // The installed flag is sticky per device: caching and warmup are an installed-app promise.
  function rtInstalledKey() { return 'rt-installed-' + (rtReadMeta('rt-app-uid') || 'app') }
  function isInstalledDevice() {
    try {
      if (typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) return true
      if (typeof navigator !== 'undefined' && navigator.standalone === true) return true // iOS home-screen launch
      return typeof localStorage !== 'undefined' && localStorage.getItem(rtInstalledKey()) === '1'
    } catch (_) { return false }
  }
  function markInstalledDevice() {
    try { localStorage.setItem(rtInstalledKey(), '1') } catch (_) { /* */ }
    try {
      if (typeof navigator !== 'undefined' && navigator.serviceWorker && navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage({ type: 'rt-set-installed', installed: true })
      }
    } catch (_) { /* */ }
  }

  // ── Runtime.pwa (Feature 13 — install prompt + app-update detection) ────────
  // __markUpdateReady is set by the Runtime.pwa IIFE so the boot block's
  // controllerchange listener can flip the reactive ref without a circular ref.
  var __markUpdateReady = null
  Runtime.pwa = (function () {
    let savedEvent = null
    const installableRef = ref(false) // reactive
    const installedRef = ref(false)   // reactive
    const updateReadyRef = ref(false) // reactive — true when a new SW took control
    // Expose setter to the outer scope so the boot block can reach it.
    __markUpdateReady = function () { updateReadyRef.value = true }
    // The platform's install sheet (<ui-install-prompt>): <meta name="rt-install-prompt"> carries { name, icon } when the
    // server allows it on this render; it rings once per page load wherever the browser offers installation (the
    // beforeinstallprompt event, or any iOS browser), never on an installed device, over another modal or within the
    // snooze a dismissal writes per device.
    var INSTALL_SNOOZE_MS = 7 * 24 * 3600 * 1000
    var installSheet = null
    var installAsked = false
    function installMeta() { try { var raw = rtReadMeta('rt-install-prompt'); return raw ? JSON.parse(raw) : null } catch (_) { return null } }
    function installSnoozeKey() { return 'rt-install-ask-' + (rtReadMeta('rt-app-uid') || 'app') }
    function installSnoozed() {
      try { var at = Number(localStorage.getItem(installSnoozeKey()) || 0); return at > 0 && Date.now() - at < INSTALL_SNOOZE_MS } catch (_) { return false }
    }
    function isIosBrowser() {
      try { return /iPhone|iPad|iPod/.test(navigator.userAgent || '') || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) } catch (_) { return false }
    }
    function isHandheld() { try { return window.matchMedia('(pointer: coarse)').matches } catch (_) { return false } }
    function showInstallSheet(mode) {
      if (installSheet) return Promise.resolve(installSheet)
      var meta = installMeta() || {}
      var props = { name: meta.name || null, icon: meta.icon || null, mode: mode || (isIosBrowser() ? 'ios' : 'native'), device: isHandheld() ? 'handheld' : 'desktop' }
      return open('ui-install-prompt', props).then(function (h) {
        installSheet = h
        return h
      })
    }
    function maybeAutoInstall(mode) {
      if (installAsked || !installMeta()) return
      if (installedRef.value || isInstalledDevice() || installSnoozed()) return
      if (mode === 'native' && !savedEvent) return
      if (document.querySelector('[data-rt-modal]')) return
      installAsked = true
      showInstallSheet(mode)
    }
    function scheduleAutoInstall(mode) {
      var run = function () { setTimeout(function () { try { maybeAutoInstall(mode) } catch (_) { /* */ } }, 2500) }
      if (typeof document !== 'undefined' && document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run()
    }
    busSubscribe('event:ui-install-prompt-close', function () { installSheet = null })
    try {
      if (isInstalledDevice()) {
        installedRef.value = true
        markInstalledDevice() // persist + tell the SW (standalone/iOS launches)
      }
    } catch (_) { /* */ }
    if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
      window.addEventListener('beforeinstallprompt', function (e) {
        if (e && typeof e.preventDefault === 'function') e.preventDefault()
        savedEvent = e
        installableRef.value = true
        scheduleAutoInstall('native')
      })
      window.addEventListener('appinstalled', function () {
        installedRef.value = true
        installableRef.value = false
        savedEvent = null
        markInstalledDevice()
        if (installSheet) { try { close(installSheet) } catch (_) { /* */ } installSheet = null }
        // The device just gained the offline promise — start warming now.
        try { setTimeout(function () { if (Runtime.warmOfflineCache) Runtime.warmOfflineCache() }, 1500) } catch (_) { /* */ }
      })
      if (isIosBrowser() && !isInstalledDevice()) scheduleAutoInstall('ios')
    }
    return {
      get installable() { return installableRef.value },
      // true when this render may show the platform's install sheet (app setting + an identified person on a regular page).
      get installPromptEnabled() { return !!installMeta() },
      // Opens the install sheet on demand (a menu entry); ignores the snooze. Resolves the open() handle.
      showInstallPrompt() { return showInstallSheet(null) },
      // Writes the per-device snooze the automatic sheet honours (7 days).
      snoozeInstallPrompt() { try { localStorage.setItem(installSnoozeKey(), String(Date.now())) } catch (_) { /* */ } },
      get installed() { return installedRef.value },
      // Sticky per-device flag — true once the app was EVER installed on this
      // device (standalone launch, iOS home-screen, or appinstalled). Gates
      // the offline cache layers.
      get installedDevice() { return isInstalledDevice() },
      get updateReady() { return updateReadyRef.value },
      // A new platform version activated (SW controllerchange). Reload to pick
      // up the new runtime + flushed caches. Operators: show a toast on
      // event:app-update-ready and call this from it.
      applyUpdate() {
        try { window.location.reload() } catch (_) { /* */ }
      },
      async installPrompt() {
        if (!savedEvent) return { outcome: 'unavailable' }
        savedEvent.prompt()
        const choice = await savedEvent.userChoice
        savedEvent = null
        installableRef.value = false
        return choice
      },
      // App-icon badge (Badging API). No-ops where unsupported (iOS Safari
      // tab, Firefox) — returns false so callers can fall back to in-app UI.
      async setBadge(n) {
        try {
          if (typeof navigator === 'undefined' || typeof navigator.setAppBadge !== 'function') return false
          // Badging API: setAppBadge(0) CLEARS; setAppBadge(undefined) shows a
          // generic dot (no number). A non-positive / non-number count means
          // "nothing to show", so clear rather than flag a bare dot.
          var count = typeof n === 'number' && n > 0 ? Math.floor(n) : 0
          if (count > 0) await navigator.setAppBadge(count)
          else if (typeof navigator.clearAppBadge === 'function') await navigator.clearAppBadge()
          else await navigator.setAppBadge(0)
          return true
        } catch (_) { return false }
      },
      async clearBadge() {
        try {
          if (typeof navigator === 'undefined' || typeof navigator.clearAppBadge !== 'function') return false
          await navigator.clearAppBadge()
          return true
        } catch (_) { return false }
      },
      // `{ caches: [{ name, entries, bytes, max_entries, max_bytes }], usage, quota }` from the SW; null without one.
      cacheStats() {
        return new Promise(function (resolve) {
          try {
            const sw = typeof navigator !== 'undefined' && navigator.serviceWorker && navigator.serviceWorker.controller
            if (!sw || typeof MessageChannel === 'undefined') { resolve(null); return }
            const ch = new MessageChannel()
            const timer = setTimeout(function () { resolve(null) }, 3000)
            ch.port1.onmessage = function (e) { clearTimeout(timer); resolve(e.data || null) }
            sw.postMessage({ type: 'rt-cache-stats' }, [ch.port2])
          } catch (_) { resolve(null) }
        })
      },
    }
  })()

  // ── Runtime.theme: the rt-theme cookie is the one store; SSR stamps <html data-theme> from it, this keeps it live ──
  Runtime.theme = (function () {
    var de = typeof document !== 'undefined' ? document.documentElement : null
    var mq = null
    try { mq = window.matchMedia('(prefers-color-scheme: dark)') } catch (_) { /* */ }
    function stamped() { var t = de && de.getAttribute('data-theme'); return t === 'light' || t === 'dark' ? t : 'auto' }
    var modeRef = ref(stamped())
    var darkRef = ref(!!(mq && mq.matches))
    var supportedRef = ref(false)
    // Supported = the document's own CSS declares `color-scheme: light dark`; the preference attribute is lifted for the
    // read so the forced scheme does not count (synchronous: nothing paints in between).
    function readSupport() {
      if (!de) return
      var t = de.getAttribute('data-theme')
      try {
        if (t) de.removeAttribute('data-theme')
        var cs = getComputedStyle(de).colorScheme || ''
        supportedRef.value = /\blight\b/.test(cs) && /\bdark\b/.test(cs)
      } catch (_) { supportedRef.value = false }
      if (t) de.setAttribute('data-theme', t)
    }
    function effective() { var m = modeRef.value; return m === 'auto' ? (darkRef.value ? 'dark' : 'light') : m }
    function set(mode) {
      mode = mode === 'light' || mode === 'dark' ? mode : 'auto'
      if (!de) return
      document.cookie = 'rt-theme=' + (mode === 'auto' ? '; max-age=0' : mode + '; max-age=31536000') + '; path=/; samesite=lax'
      if (mode === 'auto') de.removeAttribute('data-theme'); else de.setAttribute('data-theme', mode)
      modeRef.value = mode
      busFire('event:theme-changed', { mode: mode, effective: effective() })
    }
    if (mq && mq.addEventListener) mq.addEventListener('change', function (e) { darkRef.value = !!e.matches })
    readSupport()
    if (typeof window !== 'undefined') window.addEventListener('load', readSupport)
    busSubscribe('event:navigated', readSupport)
    return { get mode() { return modeRef.value }, get effective() { return effective() }, get supported() { return supportedRef.value }, set: set }
  })()

  // ── Runtime.share (Web Share API) ─────────────────────────────────────────
  //   await Runtime.share({ title, text, url, files? })
  //   → { ok: true } | { ok: false, reason: 'unsupported' | 'cancelled' | 'error' }
  Runtime.share = async function share(opts) {
    opts = opts || {}
    var payload = {}
    if (typeof opts.title === 'string') payload.title = opts.title
    if (typeof opts.text === 'string') payload.text = opts.text
    if (typeof opts.url === 'string') payload.url = opts.url
    if (Array.isArray(opts.files) && opts.files.length) payload.files = opts.files
    if (typeof navigator === 'undefined' || typeof navigator.share !== 'function') {
      return { ok: false, reason: 'unsupported' }
    }
    if (payload.files && typeof navigator.canShare === 'function' && !navigator.canShare(payload)) {
      return { ok: false, reason: 'unsupported' }
    }
    try {
      await navigator.share(payload)
      return { ok: true }
    } catch (err) {
      var name = err && err.name
      return { ok: false, reason: name === 'AbortError' ? 'cancelled' : 'error' }
    }
  }

  Runtime.print = (function () {
    // ESC/POS control bytes.
    var ESC = 0x1b, GS = 0x1d, LF = 0x0a

    // Latin-1 (ISO-8859-1) encode: code points 0..255 map straight to bytes;
    // anything above becomes '?' (0x3f). Matches CP1252/Latin-1 receipt fonts
    // closely enough for accents (e.g. 'Ñ' → 0xD1).
    function latin1(str) {
      var s = String(str == null ? '' : str)
      var out = []
      for (var i = 0; i < s.length; i++) {
        var c = s.charCodeAt(i)
        out.push(c <= 0xff ? c : 0x3f)
      }
      return out
    }

    // QR via GS ( k (model 2). Returns the byte sequence for one QR symbol, or
    // [] if the data is empty / too large for the 2-byte store length.
    function qrBytes(data) {
      var bytes = latin1(data)
      if (!bytes.length) return []
      // store payload length = data + 3 (the "31 50 30" function prefix counts).
      var storeLen = bytes.length + 3
      if (storeLen > 0xffff) return [] // beyond GS ( k's 16-bit length
      var pL = storeLen & 0xff
      var pH = (storeLen >> 8) & 0xff
      var seq = []
      // select model: GS ( k 04 00 31 41 32 00  (model 2)
      seq.push(GS, 0x28, 0x6b, 0x04, 0x00, 0x31, 0x41, 0x32, 0x00)
      // module size: GS ( k 03 00 31 43 06  (size 6)
      seq.push(GS, 0x28, 0x6b, 0x03, 0x00, 0x31, 0x43, 0x06)
      // error correction: GS ( k 03 00 31 45 30  (0x30 = level L, per plan)
      seq.push(GS, 0x28, 0x6b, 0x03, 0x00, 0x31, 0x45, 0x30)
      // store data: GS ( k pL pH 31 50 30 <data>
      seq.push(GS, 0x28, 0x6b, pL, pH, 0x31, 0x50, 0x30)
      for (var i = 0; i < bytes.length; i++) seq.push(bytes[i])
      // print: GS ( k 03 00 31 51 30
      seq.push(GS, 0x28, 0x6b, 0x03, 0x00, 0x31, 0x51, 0x30)
      return seq
    }

    // Pure encoder — receipt spec → Uint8Array. Exported for tests.
    function encode(lines) {
      var b = []
      // init: ESC @  (reset to a known state)
      b.push(ESC, 0x40)
      var arr = Array.isArray(lines) ? lines : []
      for (var i = 0; i < arr.length; i++) {
        var ln = arr[i]
        if (!ln || typeof ln !== 'object') continue

        // Horizontal rule → 32 dashes + LF (no alignment/size wrapping).
        if (ln.hr === true) {
          for (var d = 0; d < 32; d++) b.push(0x2d)
          b.push(LF)
          continue
        }

        // Cash-drawer kick: ESC p 0 25 250 (pin 0, on=25ms, off=250ms units).
        if (ln.drawer === true) {
          b.push(ESC, 0x70, 0x00, 0x19, 0xfa)
          continue
        }

        // QR code line.
        if (typeof ln.qr === 'string' && ln.qr) {
          // honor center/right alignment for the symbol, then reset.
          var qa = ln.align === 'center' ? 0x01 : ln.align === 'right' ? 0x02 : 0x00
          if (qa) b.push(ESC, 0x61, qa)
          var q = qrBytes(ln.qr)
          for (var qi = 0; qi < q.length; qi++) b.push(q[qi])
          b.push(LF)
          if (qa) b.push(ESC, 0x61, 0x00)
          continue
        }

        // Pure feed line (no text): ESC d n.
        if (typeof ln.feed === 'number' && ln.text == null) {
          var fn = Math.max(0, Math.min(255, Math.floor(ln.feed)))
          b.push(ESC, 0x64, fn)
          continue
        }

        // Text line — apply align/bold/size, emit text + LF, then RESET each
        // attribute so the next line starts clean.
        var hasText = typeof ln.text === 'string'
        var align = ln.align === 'center' ? 0x01 : ln.align === 'right' ? 0x02 : 0x00
        var bold = ln.bold === true
        var dbl = ln.size === 'double'

        if (align) b.push(ESC, 0x61, align)        // ESC a n
        if (dbl) b.push(GS, 0x21, 0x11)            // GS ! 11 (double w+h)
        if (bold) b.push(ESC, 0x45, 0x01)          // ESC E 1

        if (hasText) {
          var t = latin1(ln.text)
          for (var ti = 0; ti < t.length; ti++) b.push(t[ti])
        }
        b.push(LF)

        if (bold) b.push(ESC, 0x45, 0x00)          // ESC E 0
        if (dbl) b.push(GS, 0x21, 0x00)            // GS ! 00
        if (align) b.push(ESC, 0x61, 0x00)         // ESC a 0 (reset to left)

        // optional trailing feed on a text line
        if (typeof ln.feed === 'number' && ln.feed > 0) {
          var tf = Math.max(0, Math.min(255, Math.floor(ln.feed)))
          b.push(ESC, 0x64, tf)
        }
      }
      // partial cut trailer: GS V 66 0
      b.push(GS, 0x56, 0x42, 0x00)
      return new Uint8Array(b)
    }

    // ── Web Bluetooth transport ────────────────────────────────────────────
    var STD_SVC = 0x18f0
    var VENDOR_SVC = 'e7810a71-73ae-499d-8c15-faa9aef0c3f2'
    var device = null
    var server = null
    var characteristic = null
    var connectedRef = ref(false)
    var onDisconnect = null

    function btSupported() {
      return typeof navigator !== 'undefined' && navigator && navigator.bluetooth &&
        typeof navigator.bluetooth.requestDevice === 'function'
    }

    function sleep(ms) { return new Promise(function (r) { setTimeout(r, ms) }) }

    // Walk every service's characteristics and return the first that can be
    // written (writeWithoutResponse preferred, then write).
    async function findWritable(srv) {
      var services
      try { services = await srv.getPrimaryServices() } catch (_) { return null }
      var preferred = null, fallback = null
      for (var i = 0; i < services.length; i++) {
        var chars
        try { chars = await services[i].getCharacteristics() } catch (_) { continue }
        for (var j = 0; j < chars.length; j++) {
          var c = chars[j], p = c.properties || {}
          if (p.writeWithoutResponse && !preferred) preferred = c
          else if (p.write && !fallback) fallback = c
        }
      }
      return preferred || fallback
    }

    async function requestDevice() {
      try {
        return await navigator.bluetooth.requestDevice({
          filters: [{ services: [STD_SVC] }],
          optionalServices: [VENDOR_SVC, STD_SVC],
        })
      } catch (err) {
        // No device matched the service filter → broaden to accept-all so the
        // operator can still pick a printer that doesn't advertise 0x18F0.
        if (err && err.name === 'NotFoundError') {
          return await navigator.bluetooth.requestDevice({
            acceptAllDevices: true,
            optionalServices: [VENDOR_SVC, STD_SVC],
          })
        }
        throw err
      }
    }

    async function connect() {
      if (!btSupported()) return { ok: false, reason: 'unsupported' }
      try {
        device = await requestDevice()
        if (!device) return { ok: false, reason: 'cancelled' }
        onDisconnect = function () {
          connectedRef.value = false
          characteristic = null
          server = null
        }
        try { device.addEventListener('gattserverdisconnected', onDisconnect) } catch (_) { /* */ }
        server = await device.gatt.connect()
        characteristic = await findWritable(server)
        if (!characteristic) {
          try { device.gatt.disconnect() } catch (_) { /* */ }
          return { ok: false, reason: 'no-writable-characteristic' }
        }
        connectedRef.value = true
        return { ok: true }
      } catch (err) {
        var name = err && err.name
        if (name === 'NotFoundError') return { ok: false, reason: 'cancelled' }
        return { ok: false, reason: 'error', message: err && err.message }
      }
    }

    function disconnect() {
      try { if (device && device.gatt && device.gatt.connected) device.gatt.disconnect() } catch (_) { /* */ }
      connectedRef.value = false
      characteristic = null
      server = null
      return { ok: true }
    }

    // Chunked raw write — split into ≤180-byte chunks with ~30ms gaps so the
    // printer's small RX buffer doesn't overflow. writeWithoutResponse is
    // preferred; fall back to write.
    async function raw(bytes) {
      if (!characteristic) return { ok: false, reason: 'not-connected' }
      var u8 = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes || [])
      var CHUNK = 180
      try {
        for (var off = 0; off < u8.length; off += CHUNK) {
          var slice = u8.subarray(off, Math.min(off + CHUNK, u8.length))
          if (typeof characteristic.writeValueWithoutResponse === 'function') {
            await characteristic.writeValueWithoutResponse(slice)
          } else if (typeof characteristic.writeValue === 'function') {
            await characteristic.writeValue(slice)
          } else {
            return { ok: false, reason: 'no-write-method' }
          }
          if (off + CHUNK < u8.length) await sleep(30)
        }
        return { ok: true, bytes: u8.length }
      } catch (err) {
        return { ok: false, reason: 'error', message: err && err.message }
      }
    }

    async function printReceipt(lines) {
      if (!characteristic) return { ok: false, reason: 'not-connected' }
      return raw(encode(lines))
    }

    return {
      encode: encode,
      connect: connect,
      disconnect: disconnect,
      printReceipt: printReceipt,
      raw: raw,
      get connected() { return connectedRef.value },
    }
  })()

  Runtime.live = (function () {
    var connectedRef = ref(false)
    var es = null
    var esTopics = null // the open stream's explicit topics; null = the server default (entity:*, live:*, ds:invalidate)

    // A second connect() while a stream is live is a no-op unless it asks for a topic an explicit stream lacks:
    // then the stream reopens with the union (a default request reopens on the default).
    function connect(opts) {
      if (typeof EventSource === 'undefined') return { ok: false, reason: 'unsupported' }
      var want = opts && opts.topics && opts.topics.length ? opts.topics.slice() : null
      if (es) {
        if (esTopics === null || (want && want.every(function (t) { return esTopics.indexOf(t) >= 0 }))) return { ok: true }
        var merged = want ? esTopics.concat(want.filter(function (t) { return esTopics.indexOf(t) < 0 })) : null
        disconnect()
        want = merged
      }
      var uid = rtReadMeta('rt-app-uid')
      if (!uid) return { ok: false, reason: 'no-app' }
      var url = '/runtime/live/' + uid
      if (want) url += '?topics=' + encodeURIComponent(want.join(','))
      esTopics = want
      try {
        es = new EventSource(url, { withCredentials: true })
      } catch (_) {
        es = null
        return { ok: false, reason: 'error' }
      }
      es.onopen = function () { connectedRef.value = true }
      es.onerror = function () { connectedRef.value = false }
      es.onmessage = function (ev) {
        try {
          var payload = JSON.parse(ev.data)
          if (liveQueryEvent(payload)) return
          if (payload && payload.__resync) {
            // Desync sentinel: the stream could not resume from Last-Event-ID,
            // so intermediate events were lost. Tell listeners to re-fetch all.
            busFire('event:live-resync', {})
            return
          }
          if (payload && typeof payload.__live === 'string') {
            var p = payload.payload !== undefined ? payload.payload : {}
            if (payload.from && p && typeof p === 'object' && !Array.isArray(p)) p._from = payload.from
            busFire('event:live:' + payload.__live, p)
          } else {
            busFire('event:row-changed', payload)
          }
        } catch (_) { /* ignore non-JSON / heartbeat noise */ }
      }
      return { ok: true }
    }

    function disconnect() {
      if (es) { try { es.close() } catch (_) { /* */ } }
      es = null
      esTopics = null
      connectedRef.value = false
    }

    function ensureTopic(topic) {
      if (es && (esTopics === null || esTopics.indexOf(topic) >= 0)) return { ok: true }
      return connect({ topics: es ? esTopics.concat([topic]) : [topic] })
    }

    // `ds:invalidate` from another tab refetches the tagged reads; `{ type: 'refetch', uid }` targets one DS.
    function liveQueryEvent(payload) {
      var p = payload && typeof payload.__live === 'string' ? payload.payload : payload
      if (!p || typeof p !== 'object') return false
      if (p.type === 'invalidate' && Array.isArray(p.tags)) {
        if (p.origin !== RT_ORIGIN) queryInvalidate(p.tags)
        return !payload.__live
      }
      if (p.type === 'refetch' && typeof p.uid === 'string') {
        queryRefetchUid(p.uid)
        return !payload.__live
      }
      return false
    }

    async function publish(event, payload, audience) {
      var uid = rtReadMeta('rt-app-uid')
      if (!uid) return { ok: false, reason: 'no-app' }
      var res
      try {
        res = await fetch('/runtime/live-publish/' + uid, {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ event: event, payload: payload, audience: audience }),
        })
      } catch (_) {
        return { ok: false, reason: 'network' }
      }
      if (res.status === 401) { Runtime.onUnauthorized(); return { ok: false, reason: 'unauthorized' } }
      var json = await rtSafeJson(res)
      return json || { ok: res.ok }
    }

    return {
      connect: connect,
      disconnect: disconnect,
      ensureTopic: ensureTopic,
      publish: publish,
      get connected() { return connectedRef.value },
    }
  })()

  // UI gate only, not data security: the offline caches are not encrypted by the PIN.
  Runtime.lock = (function () {
    var lockedRef = ref(false)
    var cfgCache = undefined // undefined = unread; null = none; object = present
    var attempts = 0         // consecutive wrong unlock attempts
    var nextAllowedAt = 0    // epoch ms; enforced from the 3rd failure
    var autoLockTimer = null
    var booted = false


    // ── IDB storage (single-row cfg store) with in-memory fallback ───────────
    var memCfg = null
    var hasIdb = (typeof indexedDB !== 'undefined')
    var dbPromise = null
    function idb() {
      if (!hasIdb) return Promise.resolve(null)
      if (dbPromise) return dbPromise
      dbPromise = new Promise(function (resolve) {
        var req
        // The page meta is the FULL app uid (only the SW carries the short one), as for ReadCache / Offline.
        try { req = indexedDB.open('rt-lock-' + (rtAppUid() || 'noapp'), 1) }
        catch (_) { hasIdb = false; resolve(null); return }
        req.onupgradeneeded = function () {
          var d = req.result
          if (!d.objectStoreNames.contains('cfg')) d.createObjectStore('cfg', { keyPath: 'k' })
        }
        req.onsuccess = function () { resolve(req.result) }
        req.onerror = function () { hasIdb = false; resolve(null) }
      })
      return dbPromise
    }
    function readCfg() {
      return idb().then(function (d) {
        if (!d) return memCfg
        return new Promise(function (resolve) {
          var req = d.transaction('cfg', 'readonly').objectStore('cfg').get('pin')
          req.onsuccess = function () { resolve(req.result || null) }
          req.onerror = function () { resolve(null) }
        })
      })
    }
    function writeCfg(row) {
      return idb().then(function (d) {
        if (!d) { memCfg = row; return }
        return new Promise(function (resolve) {
          var tx = d.transaction('cfg', 'readwrite')
          tx.objectStore('cfg').put(row)
          tx.oncomplete = function () { resolve() }
          tx.onerror = function () { resolve() }
        })
      })
    }
    function clearCfg() {
      return idb().then(function (d) {
        if (!d) { memCfg = null; return }
        return new Promise(function (resolve) {
          var tx = d.transaction('cfg', 'readwrite')
          tx.objectStore('cfg').delete('pin')
          tx.oncomplete = function () { resolve() }
          tx.onerror = function () { resolve() }
        })
      })
    }

    // ── base64 <-> bytes (Uint8Array) ───────────────────────────────────────
    function bytesToB64(bytes) {
      var s = ''
      for (var i = 0; i < bytes.length; i++) s += String.fromCharCode(bytes[i])
      return btoa(s)
    }
    function b64ToBytes(b64) {
      var bin = atob(b64)
      var out = new Uint8Array(bin.length)
      for (var i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i)
      return out
    }
    function subtle() {
      try { return (typeof crypto !== 'undefined' && crypto.subtle) ? crypto.subtle : null } catch (_) { return null }
    }
    // SHA-256(salt || pin) → base64.
    function hashPin(saltBytes, pin) {
      var s = subtle()
      if (!s) return Promise.resolve(null)
      var pinBytes = new TextEncoder().encode(pin)
      var buf = new Uint8Array(saltBytes.length + pinBytes.length)
      buf.set(saltBytes, 0); buf.set(pinBytes, saltBytes.length)
      return Promise.resolve(s.digest('SHA-256', buf)).then(function (digest) {
        return bytesToB64(new Uint8Array(digest))
      })
    }

    function getCfg() {
      if (cfgCache !== undefined) return Promise.resolve(cfgCache)
      return readCfg().then(function (row) { cfgCache = row || null; return cfgCache })
    }

    function backoffMs(n) {
      // Grows from the 3rd consecutive failure: 5s, 10s, 20s, … (capped 5 min).
      if (n < 3) return 0
      var ms = 5000 * Math.pow(2, n - 3)
      return Math.min(ms, 5 * 60 * 1000)
    }

    function lockNow() {
      lockedRef.value = true
      try { busFire('event:locked', {}) } catch (_) { /* */ }
    }

    function scheduleAutoLock() {
      if (autoLockTimer) { clearTimeout(autoLockTimer); autoLockTimer = null }
      getCfg().then(function (cfg) {
        if (!cfg || !cfg.autoLockMin) return
        if (lockedRef.value) return
        autoLockTimer = setTimeout(function () { lockNow() }, cfg.autoLockMin * 60 * 1000)
      })
    }
    function cancelAutoLock() {
      if (autoLockTimer) { clearTimeout(autoLockTimer); autoLockTimer = null }
    }

    // Auto-lock when the document is hidden for autoLockMin minutes. Timer
    // starts at hidden, cancels at visible. Simple + good enough.
    if (typeof document !== 'undefined' && typeof document.addEventListener === 'function') {
      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'hidden') scheduleAutoLock()
        else cancelAutoLock()
      })
    }

    function setup(pin, opts) {
      var s = subtle()
      if (!s) return Promise.resolve({ ok: false, reason: 'unsupported' })
      if (typeof pin !== 'string' || pin.length < 1) return Promise.resolve({ ok: false, reason: 'invalid' })
      var salt = new Uint8Array(16)
      if (typeof crypto !== 'undefined' && crypto.getRandomValues) crypto.getRandomValues(salt)
      else for (var i = 0; i < 16; i++) salt[i] = Math.floor(Math.random() * 256)
      return hashPin(salt, pin).then(function (hashB64) {
        if (!hashB64) return { ok: false, reason: 'unsupported' }
        var row = { k: 'pin', saltB64: bytesToB64(salt), hashB64: hashB64 }
        if (opts && typeof opts.autoLockMin === 'number' && opts.autoLockMin > 0) row.autoLockMin = opts.autoLockMin
        return writeCfg(row).then(function () {
          cfgCache = row
          attempts = 0; nextAllowedAt = 0
          // setup does NOT lock — operator just enrolled and is present.
          lockedRef.value = false
          return { ok: true }
        })
      })
    }

    function unlock(pin) {
      return getCfg().then(function (cfg) {
        if (!cfg) return { ok: false, reason: 'not-enabled' }
        // Enforce backoff WITHOUT hashing the pin during the wait window.
        var now = Date.now()
        if (nextAllowedAt && now < nextAllowedAt) {
          return { ok: false, waitMs: nextAllowedAt - now }
        }
        var salt = b64ToBytes(cfg.saltB64)
        return hashPin(salt, pin).then(function (hashB64) {
          if (hashB64 && hashB64 === cfg.hashB64) {
            attempts = 0; nextAllowedAt = 0
            lockedRef.value = false
            try { busFire('event:unlocked', {}) } catch (_) { /* */ }
            return { ok: true }
          }
          attempts++
          var wait = backoffMs(attempts)
          if (wait > 0) nextAllowedAt = Date.now() + wait
          return wait > 0 ? { ok: false, waitMs: wait } : { ok: false }
        })
      })
    }

    function disable(pin) {
      return getCfg().then(function (cfg) {
        if (!cfg) return { ok: true } // already disabled
        var salt = b64ToBytes(cfg.saltB64)
        return hashPin(salt, pin).then(function (hashB64) {
          if (!hashB64 || hashB64 !== cfg.hashB64) {
            attempts++
            var wait = backoffMs(attempts)
            if (wait > 0) nextAllowedAt = Date.now() + wait
            return wait > 0 ? { ok: false, waitMs: wait } : { ok: false }
          }
          return clearCfg().then(function () {
            cfgCache = null
            attempts = 0; nextAllowedAt = 0
            lockedRef.value = false
            cancelAutoLock()
            return { ok: true }
          })
        })
      })
    }

    // Boot: if a pin record exists, start locked + fire event:locked. Warmup
    // still runs underneath — this is a UI gate, not data security.
    function __init() {
      if (booted) return
      booted = true
      getCfg().then(function (cfg) {
        if (cfg) lockNow()
      }).catch(function () { /* */ })
    }

    return {
      get enabled() { return !!cfgCache },
      get locked() { return lockedRef.value },
      setup: setup,
      unlock: unlock,
      lock: lockNow,
      disable: disable,
      __init: __init,
    }
  })()


  // Find the current island root whose id starts with `prefix` ("page:" /
  // "shell:"): the first non-script [data-island] container matching it.
  function findIslandRoot(doc, prefix) {
    var d = doc || (typeof document !== 'undefined' ? document : null)
    if (!d || !d.querySelectorAll) return null
    var nodes = d.querySelectorAll('[data-island]')
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i]
      var tag = el.tagName && el.tagName.toLowerCase()
      if (tag === 'script' || tag === 'style' || tag === 'template') continue
      var id = el.getAttribute('data-island') || ''
      if (id.indexOf(prefix) === 0) return el
    }
    return null
  }

  // Find the current page island root: the [data-island] container whose id
  // starts with "page:". (If a shell wraps it, it's the inner one.)
  function findPageIslandRoot(doc) {
    return findIslandRoot(doc, 'page:')
  }

  // Tear down a single island scope: run disposers, stop node effects, drop it
  // from the registry, and remove its companion island/* scripts from the doc.
  function teardownIslandScope(id, rootEl, doc) {
    var d = doc || (typeof document !== 'undefined' ? document : null)
    if (id && Island.scopes[id]) {
      try { disposeScope(Island.scopes[id]) } catch (_) { /* */ }
      delete Island.scopes[id]
    }
    if (rootEl) { try { stopNode(rootEl) } catch (_) { /* */ } }
    if (id && d && d.querySelectorAll) {
      var scripts = d.querySelectorAll('script[data-island="' + id + '"]')
      for (var i = 0; i < scripts.length; i++) {
        if (scripts[i].parentNode) scripts[i].parentNode.removeChild(scripts[i])
      }
    }
  }

  var prefetchCache = Object.create(null) // path → { promise, ts }
  var navInFlight = Object.create(null) // path → navigates in flight (payload, swap, transition, history): a prefetch of it is a duplicate
  var PREFETCH_TTL_MS = 30000
  var PREFETCH_MAX = 8
  // Nav token: a superseded navigate makes its deferred swap a no-op (checks myNav === navSeq).
  var navSeq = 0

  // Tagged page-payload fetch — the single wire path for navigate + prefetch.
  // A followed same-origin redirect answered with the X-Runtime JSON is a soft redirect (`finalPath`).
  function fetchPagePayload(path, signal) {
    var init = { credentials: 'include', headers: { 'X-Runtime': 'true', Accept: 'application/json' } }
    if (signal) init.signal = signal
    var aborted = function () { return !!(signal && signal.aborted) }
    return fetch(path, init).then(function (res) {
      if (aborted()) return { kind: 'aborted' }
      if (res && res.status === 401) return { kind: 'unauthorized' }
      var finalPath = null
      if (res && res.redirected) {
        var ct = ''
        try { ct = (res.headers && typeof res.headers.get === 'function' && res.headers.get('content-type')) || '' } catch (_) { /* */ }
        try {
          var u = new URL(res.url, window.location.href)
          if (u.origin === window.location.origin) finalPath = u.pathname + u.search + u.hash
        } catch (_) { /* */ }
        if (finalPath === null || res.ok === false || String(ct).indexOf('application/json') < 0) {
          return { kind: 'redirect', url: res.url }
        }
      }
      if (!res || res.ok === false) return { kind: 'error' }
      return res.json().then(
        function (data) { return finalPath ? { kind: 'ok', data: data, finalPath: finalPath } : { kind: 'ok', data: data } },
        function () { return { kind: aborted() ? 'aborted' : 'error' } }
      )
    }, function (err) { return aborted() ? { kind: 'aborted' } : { kind: 'neterr', err: err } })
  }

  function prefetchPrune() {
    var keys = Object.keys(prefetchCache)
    if (keys.length <= PREFETCH_MAX) return
    keys.sort(function (a, b) { return prefetchCache[a].ts - prefetchCache[b].ts })
    for (var i = 0; i < keys.length - PREFETCH_MAX; i++) delete prefetchCache[keys[i]]
  }

  Runtime.prefetch = function prefetch(path) {
    try {
      var conn = typeof navigator !== 'undefined' ? navigator.connection : null
      if (conn && (conn.saveData || conn.effectiveType === 'slow-2g' || conn.effectiveType === '2g')) return null
    } catch (_) { /* */ }
    try {
      // Offline hovers must not spam failed requests — navigation falls back
      // to the SW page cache anyway.
      if (typeof navigator !== 'undefined' && navigator.onLine === false) return null
    } catch (_) { /* */ }
    try {
      if (typeof location !== 'undefined' && path === location.pathname + location.search + location.hash) return null
    } catch (_) { /* */ }
    if (navInFlight[path]) return null
    var now = Date.now()
    var hit = prefetchCache[path]
    if (hit && now - hit.ts < PREFETCH_TTL_MS) return hit.promise
    var p = fetchPagePayload(path)
    prefetchCache[path] = { promise: p, ts: now }
    prefetchPrune()
    return p
  }

  // Shared anchor-eligibility (used by click interception AND prefetch).
  // Returns the in-origin path or null.
  function eligibleAnchorPath(e, forPrefetch) {
    if (e.defaultPrevented) return null
    return anchorPath(e.target instanceof Element ? e.target.closest('a[href]') : null, forPrefetch)
  }
  function anchorPath(a, forPrefetch) {
    if (!a) return null
    if (a.target === '_blank') return null
    if (a.hasAttribute('download')) return null
    if (a.hasAttribute('data-rt-hard') || a.hasAttribute('data-rt-no-spa')) return null
    if (forPrefetch && a.hasAttribute('data-rt-no-prefetch')) return null
    var rel = (a.getAttribute('rel') || '').toLowerCase()
    if (rel.split(/\s+/).indexOf('external') >= 0) return null
    var href = a.getAttribute('href')
    if (!href || href.charAt(0) === '#' || /^[a-z]+:/i.test(href)) return null
    try {
      var u = new URL(href, window.location.href)
      if (u.origin !== window.location.origin) return null
      return u.pathname + u.search + u.hash
    } catch (_) { return null }
  }

  // The path + search of the page the runtime last settled on (null until the first navigate).
  var navCurrentPath = null
  var bootLocationPath = typeof window !== 'undefined' ? currentLocationPath(window) : '/'
  function currentLocationPath(win) {
    try { return win && win.location ? (win.location.pathname || '/') + (win.location.search || '') : '/' } catch (_) { return '/' }
  }
  function splitPath(path, win) {
    try {
      var u = new URL(path, (win && win.location && win.location.href) || 'http://localhost/')
      return { path: u.pathname, search: u.search }
    } catch (_) {
      var q = String(path).indexOf('?')
      return q >= 0 ? { path: String(path).slice(0, q), search: String(path).slice(q) } : { path: String(path), search: '' }
    }
  }

  // `Runtime.nav` — reactive navigation state a shell may render instead of the built-in bar.
  var navPendingRef = ref(false)
  var navPathRef = ref(null)
  Runtime.nav = {
    get pending() { return navPendingRef.value },
    get path() { return navPathRef.value },
  }
  var navAbort = null

  // Back/forward payload cache: the last BACK_CACHE_MAX payloads by path + search; a popstate within
  // BACK_CACHE_TTL_MS paints from it and revalidates in the background.
  var backCache = Object.create(null)
  var BACK_CACHE_MAX = 10
  var BACK_CACHE_TTL_MS = 60000
  function backCacheKey(path, win) { var t = splitPath(path, win); return t.path + t.search }
  function backCachePut(key, data) {
    delete backCache[key]
    backCache[key] = { data: data, ts: Date.now() }
    var keys = Object.keys(backCache)
    if (keys.length <= BACK_CACHE_MAX) return
    keys.sort(function (a, b) { return backCache[a].ts - backCache[b].ts })
    for (var i = 0; i < keys.length - BACK_CACHE_MAX; i++) delete backCache[keys[i]]
  }
  function backCacheGet(key) {
    var hit = backCache[key]
    return hit && Date.now() - hit.ts <= BACK_CACHE_TTL_MS ? hit : null
  }

  // `Runtime.route` — reactive { path, search, query } of the URL; the bare `route` of a setup block is its SSR snapshot.
  var routePathRef = ref('/')
  var routeSearchRef = ref('')
  function routeSync(win) {
    try { routePathRef.value = win.location.pathname || '/'; routeSearchRef.value = win.location.search || '' } catch (_) { /* */ }
  }
  function parseQuery(search) {
    var out = {}
    new URLSearchParams(search || '').forEach(function (v, k) {
      out[k] = Object.prototype.hasOwnProperty.call(out, k) ? [].concat(out[k], v) : v
    })
    return out
  }
  Runtime.route = {
    get path() { return routePathRef.value },
    get search() { return routeSearchRef.value },
    get query() { return parseQuery(routeSearchRef.value) },
  }
  // The bare `route`, `params` and `query` of every mounted island follow the CURRENT page: a navigate copies the
  // new page's seeded globals into each persisting scope (the shell, its components), setQuery rewrites `query`.
  var LIVE_GLOBALS = ['route', 'params', 'query']
  var liveScopes = new Set()
  function liveGlobalsTrack(scope) { liveScopes.add(scope); addDisposer(scope, function () { liveScopes.delete(scope) }) }
  function syncInto(target, src) {
    var keys = Object.keys(toRaw(target)), k, i
    for (i = 0; i < keys.length; i++) if (!Object.prototype.hasOwnProperty.call(src, keys[i])) delete target[keys[i]]
    for (k in src) if (Object.prototype.hasOwnProperty.call(src, k)) target[k] = (src[k] !== null && typeof src[k] === 'object') ? JSON.parse(JSON.stringify(src[k])) : src[k]
  }
  function liveGlobalsAdopt(globals, ownerId) {
    liveScopes.forEach(function (s) {
      if (s.__islandId === ownerId) return
      for (var i = 0; i < LIVE_GLOBALS.length; i++) {
        var k = LIVE_GLOBALS[i], src = globals[k], dst = s[k]
        if (dst && typeof dst === 'object' && src && typeof src === 'object') syncInto(dst, src)
      }
    })
  }
  function liveQuerySync(search) {
    var q = parseQuery(search)
    liveScopes.forEach(function (s) {
      if (s.query && typeof s.query === 'object') syncInto(s.query, q)
      if (s.route && typeof s.route === 'object' && s.route.query && typeof s.route.query === 'object') syncInto(s.route.query, q)
    })
  }
  if (typeof window !== 'undefined' && window.location) routeSync(window)
  // Merge `patch` into the query (null/undefined deletes, an array repeats the key) and write the URL without a navigation.
  Runtime.setQuery = function setQuery(patch, opts) {
    var win = window
    var params = new URLSearchParams(win.location.search || '')
    for (var k in patch || {}) {
      var vals = (Array.isArray(patch[k]) ? patch[k] : [patch[k]]).filter(function (v) { return v !== null && v !== undefined })
      if (vals.length === 1) { params.set(k, String(vals[0])); continue }
      params.delete(k)
      for (var i = 0; i < vals.length; i++) params.append(k, String(vals[i]))
    }
    var qs = params.toString()
    rtHistoryWrite(win, opts && opts.replace === false ? 'push' : 'replace', win.location.pathname + (qs ? '?' + qs : '') + (win.location.hash || ''))
    navCurrentPath = currentLocationPath(win)
    navPathRef.value = navCurrentPath
    routeSync(win)
    liveQuerySync(win.location.search || '')
  }

  // Viewport prefetch: visible eligible links warm the prefetch cache, VIEWPORT_PREFETCH_MAX paths per page view,
  // only on a fast connection without save-data.
  var VIEWPORT_PREFETCH_MAX = 10
  var viewportObserver = null
  function viewportPrefetchDisarm() {
    if (viewportObserver) { try { viewportObserver.disconnect() } catch (_) { /* */ } }
    viewportObserver = null
  }
  function viewportPrefetchArm(root) {
    viewportPrefetchDisarm()
    if (typeof IntersectionObserver !== 'function' || !root || typeof root.querySelectorAll !== 'function') return
    try {
      var conn = typeof navigator !== 'undefined' ? navigator.connection : null
      if (conn && (conn.saveData || conn.effectiveType !== '4g')) return
    } catch (_) { /* */ }
    var seen = Object.create(null)
    var count = 0
    var obs = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (!entries[i].isIntersecting) continue
        obs.unobserve(entries[i].target)
        var path = anchorPath(entries[i].target, true)
        if (!path || seen[path]) continue
        if (count >= VIEWPORT_PREFETCH_MAX) { if (viewportObserver === obs) viewportPrefetchDisarm(); return }
        seen[path] = true
        count++
        Runtime.prefetch(path)
      }
    }, { rootMargin: '0px', threshold: 0 })
    viewportObserver = obs
    viewportPrefetchObserve(root)
  }
  // Opt-in per link: a visible link is not intent, so only `data-rt-prefetch="viewport"` is observed.
  function viewportPrefetchObserve(root) {
    if (!viewportObserver || !root || typeof root.querySelectorAll !== 'function') return
    var links = root.querySelectorAll('a[href][data-rt-prefetch="viewport"]')
    for (var j = 0; j < links.length; j++) if (anchorPath(links[j], true)) viewportObserver.observe(links[j])
  }

  // Every same-origin link to the current pathname carries aria-current="page"; without one, the longest ancestor
  // link(s) (`/clientes` on `/clientes/123`, never `/`) carry aria-current="true"; others lose theirs.
  function markCurrentLinks(doc, win, pathname) {
    if (!doc || !win || typeof doc.querySelectorAll !== 'function') return
    var links = doc.querySelectorAll('a[href]'), paths = [], i, p, exact = false, longest = 0
    var ancestor = function (q) { return q !== '/' && pathname.indexOf(q.replace(/\/$/, '') + '/') === 0 }
    for (i = 0; i < links.length; i++) {
      p = null
      try { var u = new URL(links[i].getAttribute('href'), win.location.href); if (u.origin === win.location.origin) p = u.pathname } catch (_) { /* */ }
      paths.push(p)
      if (p === pathname) exact = true
      else if (p && ancestor(p) && p.length > longest) longest = p.length
    }
    for (i = 0; i < links.length; i++) {
      p = paths[i]
      var mark = p === pathname ? 'page' : (!exact && longest && p && p.length === longest && ancestor(p)) ? 'true' : null
      if (mark) links[i].setAttribute('aria-current', mark)
      else { var cur = links[i].getAttribute('aria-current'); if (cur === 'page' || cur === 'true') links[i].removeAttribute('aria-current') }
    }
  }

  // A hard load (reload, return from another site) keeps history.state: land where the reader was.
  var bootScrollDone = false
  function restoreBootScroll(win) {
    if (bootScrollDone) return
    bootScrollDone = true
    try {
      var st = win.history && win.history.state
      if (!st || !Array.isArray(st.rtScroll)) return
      var xy = st.rtScroll
      var go = function () { try { win.scrollTo(xy[0] || 0, xy[1] || 0) } catch (_) { /* */ } }
      if (typeof win.requestAnimationFrame === 'function') win.requestAnimationFrame(go); else go()
    } catch (_) { /* */ }
  }
  function readScroll(win) {
    try { return [win.scrollX || win.pageXOffset || 0, win.scrollY || win.pageYOffset || 0] } catch (_) { return [0, 0] }
  }
  function saveScrollInEntry(win, xy) {
    try {
      var st = win.history.state
      var next = {}
      if (st && typeof st === 'object') for (var k in st) next[k] = st[k]
      next.rtScroll = xy
      win.history.replaceState(next, '')
    } catch (_) { /* */ }
  }
  function scrollToTarget(doc, win, path) {
    var h = String(path).indexOf('#')
    var id = h >= 0 ? String(path).slice(h + 1) : ''
    try { id = decodeURIComponent(id) } catch (_) { /* */ }
    var el = null
    if (id && doc) el = doc.getElementById(id) || (doc.getElementsByName(id) || [])[0] || null
    try {
      if (el && typeof el.scrollIntoView === 'function') el.scrollIntoView()
      else if (typeof win.scrollTo === 'function') win.scrollTo(0, 0)
    } catch (_) { /* */ }
  }

  // Progress bar: shown when a navigate is still pending after PROGRESS_DELAY_MS.
  var PROGRESS_DELAY_MS = 150
  var PROGRESS_CSS = '[data-rt-progress]{position:fixed;top:0;left:0;width:100%;height:2px;'
    + 'background:var(--app-primary,var(--primary,#2563eb));z-index:2147483000;pointer-events:none;'
    + 'transform-origin:0 0;transform:scaleX(0);opacity:0}'
    + '[data-rt-progress][data-state=start]{opacity:1}'
    + '[data-rt-progress][data-state=run]{opacity:1;transform:scaleX(.8);transition:transform 8s cubic-bezier(.1,.6,.3,1)}'
    + '[data-rt-progress][data-state=done]{transform:scaleX(1);transition:transform .2s ease,opacity .2s ease .2s}'
    + '@media (pointer:coarse){[data-rt-progress]{height:3px}}'
    + '@media (prefers-reduced-motion:reduce){[data-rt-progress]{transition:none!important;transform:scaleX(1)!important}}'
  var progressEl = null
  var progressShowTimer = null
  var progressHideTimer = null
  function progressNode(doc) {
    if (progressEl && progressEl.isConnected !== false && doc.contains(progressEl)) return progressEl
    if (!doc.body) return null
    if (doc.head && !doc.head.querySelector('style[data-rt-progress]')) {
      var st = doc.createElement('style')
      st.setAttribute('data-rt-progress', '')
      st.textContent = PROGRESS_CSS
      doc.head.appendChild(st)
    }
    progressEl = doc.createElement('div')
    progressEl.setAttribute('data-rt-progress', '')
    progressEl.setAttribute('aria-hidden', 'true')
    doc.body.appendChild(progressEl)
    return progressEl
  }
  function progressStart(doc) {
    if (!doc || progressShowTimer || doc.querySelector('meta[name="rt-no-progress"]')) return
    if (progressEl && progressEl.getAttribute('data-state') === 'run') return
    progressShowTimer = setTimeout(function () {
      progressShowTimer = null
      if (!navPendingRef.value) return
      var el = progressNode(doc)
      if (!el) return
      if (progressHideTimer) { clearTimeout(progressHideTimer); progressHideTimer = null }
      el.setAttribute('data-state', 'start')
      void el.offsetWidth // commit scaleX(0) so the run state animates from it
      el.setAttribute('data-state', 'run')
    }, PROGRESS_DELAY_MS)
  }
  function progressEnd() {
    if (progressShowTimer) { clearTimeout(progressShowTimer); progressShowTimer = null }
    var el = progressEl
    if (!el || el.getAttribute('data-state') !== 'run') return
    el.setAttribute('data-state', 'done')
    progressHideTimer = setTimeout(function () {
      progressHideTimer = null
      if (el.getAttribute('data-state') === 'done') el.removeAttribute('data-state')
    }, 450)
  }

  // ── Leave guards: Runtime.beforeLeave(fn) and the scope-bound beforeLeave(fn) ──
  // history.state.rtIndex numbers the runtime's entries so a cancelled popstate can go() back.
  var leaveGuards = []
  var historyIndex = 0
  var suppressPopstate = false

  function onBeforeUnloadGuard(e) { e.preventDefault(); e.returnValue = '' }

  function registerLeaveGuard(fn) {
    if (typeof fn !== 'function') return function () {}
    leaveGuards.push(fn)
    if (leaveGuards.length === 1 && typeof window !== 'undefined') window.addEventListener('beforeunload', onBeforeUnloadGuard)
    return function off() {
      var i = leaveGuards.indexOf(fn)
      if (i < 0) return
      leaveGuards.splice(i, 1)
      if (!leaveGuards.length && typeof window !== 'undefined') window.removeEventListener('beforeunload', onBeforeUnloadGuard)
    }
  }
  Runtime.beforeLeave = registerLeaveGuard
  Runtime.store = rtStore
  Runtime.use = makeUseHelpers(null)
  Runtime.t = function (key, params) { return rtT()(key, params) }

  function historyStateOf(win) { try { return win.history.state } catch (_) { return null } }

  function rtHistoryWrite(win, kind, path) {
    var idx = kind === 'push' ? historyIndex + 1 : historyIndex
    var st = Object.assign({}, kind === 'replace' ? historyStateOf(win) : null, { rtIndex: idx })
    win.history[kind === 'push' ? 'pushState' : 'replaceState'](st, '', path)
    historyIndex = idx
  }

  // true = proceed now; otherwise a Promise<boolean> the navigate awaits (false = cancelled).
  function leaveGate(path, opts) {
    var popstate = !!(opts && opts.fromPopstate)
    var win = (typeof window !== 'undefined') ? window : null
    if (popstate && suppressPopstate) { suppressPopstate = false; return Promise.resolve(false) }
    var st = popstate && win ? historyStateOf(win) : null
    var target = st && typeof st.rtIndex === 'number' ? st.rtIndex : null
    if (!leaveGuards.length) { if (target !== null) historyIndex = target; return true }
    var info = { to: path, from: navCurrentPath !== null ? navCurrentPath : currentLocationPath(win), type: popstate ? 'popstate' : 'navigate' }
    return (async function () {
      var guards = leaveGuards.slice()
      for (var i = 0; i < guards.length; i++) {
        var ok
        try { ok = await guards[i](info) } catch (e) { console.error('[runtime] beforeLeave guard error', e) }
        if (ok !== false) continue
        if (popstate && win) {
          if (target === null) rtHistoryWrite(win, 'push', info.from)
          else if (historyIndex !== target) { suppressPopstate = true; win.history.go(historyIndex - target) }
        }
        return false
      }
      if (target !== null) historyIndex = target
      return true
    })()
  }

  if (typeof window !== 'undefined' && window.history && typeof window.history.replaceState === 'function') {
    var bootState = historyStateOf(window)
    if (bootState && typeof bootState.rtIndex === 'number') historyIndex = bootState.rtIndex
    else { try { rtHistoryWrite(window, 'replace') } catch (_) { /* */ } }
  }

  // A navigate to the destination (path + search) already pending joins it: same promise, no second fetch.
  var navJoin = null
  Runtime.navigate = function navigate(path, opts) {
    navInFlight[path] = (navInFlight[path] || 0) + 1
    var done = function () { if (--navInFlight[path] <= 0) delete navInFlight[path] }
    var r
    try { r = navigateImpl(path, opts) } catch (e) { done(); throw e }
    var j = navJoin && navJoin.promise === r ? navJoin : null
    if (j && j.wrapped) { j.wrapped.then(done, done); return j.wrapped }
    var w = Promise.resolve(r).then(function (v) { done(); return v }, function (e) { done(); throw e })
    if (j) j.wrapped = w
    return w
  }
  function navigateImpl(path, opts) {
    var key = opts && (opts.fromPopstate || opts.payload) ? null : splitPath(path, typeof window !== 'undefined' ? window : null)
    key = key && key.path + key.search
    if (key && navJoin && navJoin.key === key && (navJoin.seq === 0 || navJoin.seq === navSeq)) return navJoin.promise
    var j = navJoin = key ? { key: key, seq: 0, promise: null } : null
    var p = navigateStart(path, opts, j)
    if (j) { j.promise = p; var clear = function () { if (navJoin === j) navJoin = null }; p.then(clear, clear) }
    return p
  }

  async function navigateStart(path, opts, join) {
    var leave = leaveGate(path, opts); if (leave !== true && !(await leave)) return
    var myNav = ++navSeq
    if (join) join.seq = myNav
    var doc = (typeof document !== 'undefined') ? document : null
    viewportPrefetchDisarm()
    if (navAbort) { try { navAbort.abort() } catch (_) { /* */ } }
    var ctrl = typeof AbortController === 'function' ? new AbortController() : null
    navAbort = ctrl
    navPendingRef.value = true
    navPathRef.value = path
    progressStart(doc)
    try {
      await navigateRun(path, opts || {}, myNav, doc, ctrl)
    } finally {
      if (navAbort === ctrl) navAbort = null
      if (myNav === navSeq) {
        navPendingRef.value = false
        progressEnd()
      }
    }
  }

  async function navigateRun(path, opts, myNav, doc, ctrl) {
    var fromPopstate = !!opts.fromPopstate
    var win = (typeof window !== 'undefined') ? window : (doc && doc.defaultView) || null
    // A popstate navigate runs after the browser already changed the URL, so the
    // page we leave is the one the runtime last settled on, not location.
    if (navCurrentPath === null) navCurrentPath = currentLocationPath(win)
    var fromPath = navCurrentPath
    var popScroll = null
    if (fromPopstate) {
      try { var hs = win.history.state; if (hs && Array.isArray(hs.rtScroll)) popScroll = hs.rtScroll } catch (_) { /* */ }
    }
    try { busFire('event:navigating', { path: path }) } catch (_) { /* */ }

    function hardNav(url) {
      var to = url || path
      try {
        if (win && win.location) {
          if (typeof win.location.assign === 'function') win.location.assign(to)
          else win.location.href = to
        }
      } catch (_) { /* */ }
    }

    var data
    var backHit = opts.payload ? null : (fromPopstate && opts.cache !== false ? backCacheGet(backCacheKey(path, win)) : null)
    var tagged
    if (opts.payload) tagged = opts.payload
    else if (backHit) tagged = { kind: 'ok', data: backHit.data }
    else {
      var pf = prefetchCache[path]
      // A prefetch promise is shared and cached, so only this navigate's own fetch carries the abort signal.
      var payloadPromise = (pf && Date.now() - pf.ts < PREFETCH_TTL_MS) ? pf.promise : fetchPagePayload(path, ctrl && ctrl.signal)
      delete prefetchCache[path]
      tagged = await payloadPromise
    }
    if (tagged.kind === 'aborted' || myNav !== navSeq) return
    if (tagged.kind === 'unauthorized') { navPathRef.value = navCurrentPath; Runtime.onUnauthorized(); return }
    if (tagged.kind === 'neterr') {
      console.error('[runtime] navigate failed — falling back to hard nav', tagged.err)
      hardNav(); return
    }
    if (tagged.kind === 'redirect') { hardNav(tagged.url); return }
    if (tagged.kind !== 'ok') { hardNav(); return }
    var finalPath = tagged.finalPath || path
    if (finalPath !== path) { delete prefetchCache[finalPath]; navPathRef.value = finalPath }
    data = tagged.data
    if (!data || typeof data.html !== 'string') { hardNav(finalPath); return }
    if (!backHit) backCachePut(backCacheKey(finalPath, win), data)

    // A region swap is valid only when the target's shell is the current shell; else a full load.
    if (data.shell !== undefined) {
      var curShellEl = findIslandRoot(doc, 'shell:')
      var curShellId = curShellEl ? curShellEl.getAttribute('data-island') : null
      if ((data.shell || null) !== curShellId) { hardNav(finalPath); return }
    }

    // ── Locate the CURRENT page island region ────────────────────────────────
    var oldPageRoot = findPageIslandRoot(doc)
    var anchor = null   // where to insert the new region
    var parent = null
    if (oldPageRoot) {
      anchor = oldPageRoot
      parent = oldPageRoot.parentNode
    }

    // ── Parse the new island block ───────────────────────────────────────────
    // It contains the new page <div data-island> + companion island/* scripts.
    var tpl = doc.createElement('template')
    tpl.innerHTML = data.html
    var frag = tpl.content
    // The new page island container (the first non-script [data-island]).
    var newPageRoot = null
    var nis = frag.querySelectorAll('[data-island]')
    for (var i = 0; i < nis.length; i++) {
      var t = nis[i].tagName && nis[i].tagName.toLowerCase()
      if (t === 'script' || t === 'style' || t === 'template') continue
      newPageRoot = nis[i]
      break
    }
    if (!newPageRoot) { hardNav(finalPath); return }
    var newPageId = newPageRoot.getAttribute('data-island')

    // Assets are acquired before the swap and outside the view transition; re-acquire is idempotent.
    if (data.assets && data.assets.length) {
      try { await acquireAssets(data.assets, newPageId) } catch (e) { console.warn('[runtime] navigate asset load error:', e) }
    }

    // ── The MUTATING phase — dispose old scope, swap nodes, mount, sync head.
    // Wrapped in document.startViewTransition (below) when available so the
    // browser captures before/after snapshots and cross-fades the page region.
    var leaveScroll = null
    async function performSwap() {
      if (myNav !== navSeq) return
      if (!fromPopstate) leaveScroll = readScroll(win)
      // ── Dispose the OLD page scope (on/intervals/timeouts/observers stop) ─────
      var oldPageId = null
      if (oldPageRoot) {
        oldPageId = oldPageRoot.getAttribute('data-island')
        teardownIslandScope(oldPageId, oldPageRoot, doc)
      }

      // ── Dispose any open overlays (modals / drawers) — they belong to the
      //    page being navigated away from. Leaving them open would orphan their
      //    island scopes and keep them visually on screen after the page swap. ──
      closeAllOverlays()

      // ── F18 — release the OLD page's libraries (page-scoped + the components
      //    it rendered). Same-page navigation (only params changed) keeps the
      //    same owner id, so there is nothing to release there. ──
      if (oldPageId && oldPageId !== newPageId) releaseAssets(oldPageId)

      var toMove = []
      var children = Array.prototype.slice.call(frag.childNodes)
      for (var c = 0; c < children.length; c++) {
        var node = children[c]
        if (node === newPageRoot) { toMove.push(node); continue }
        if (node.nodeType === 1 && node.tagName && node.tagName.toLowerCase() === 'script') {
          var stype = (node.getAttribute('type') || '')
          // Keep only island/* companion scripts (bind/setup/globals/state).
          if (stype.indexOf('island/') === 0) toMove.push(node)
          continue
        }
        // Drop stray text/whitespace and the runtime/Island.start() tail scripts.
      }
      if (parent) {
        for (var n = 0; n < toMove.length; n++) parent.insertBefore(toMove[n], anchor)
        if (oldPageRoot && oldPageRoot.parentNode) oldPageRoot.parentNode.removeChild(oldPageRoot)
      } else if (doc && doc.body) {
        // First nav before any page mounted (rare — shell-only doc).
        for (var m = 0; m < toMove.length; m++) doc.body.appendChild(toMove[m])
      }

      if (data.islandComps) registerIslandComps(data.islandComps)
      mergeOnce(data.once)
      // ── Inject / replace page CSS (a single <style data-rt-page-css>). ────────
      if (doc) {
        var styleEl = doc.querySelector('style[data-rt-page-css]')
        if (data.css) {
          if (!styleEl) {
            styleEl = doc.createElement('style')
            styleEl.setAttribute('data-rt-page-css', '')
            ;(doc.head || doc.body || doc.documentElement).appendChild(styleEl)
          }
          styleEl.textContent = data.css
        } else if (styleEl) {
          styleEl.textContent = ''
        }
      }

      try {
        await mountIsland(newPageRoot)
      } catch (e) {
        var captured = captureError(Island.scopes[newPageId] || { __rootEl: newPageRoot }, newPageId || '?', e)
        if (captured) { /* an enclosing onErrorCaptured hook handled it */ }
        else if (typeof Island.onError === 'function') Island.onError(newPageId || '?', e)
        else console.error('[runtime] navigate mount error', e)
      }
      focusPageRootSettled(newPageRoot, function () { return myNav === navSeq })

      // ── Title + history ───────────────────────────────────────────────────────
      if (data.title && doc) doc.title = data.title
      // Feature 19 — SEO: sync managed head tags on soft-nav.
      if (doc && typeof data.head === 'string' && data.head) {
        var __old = doc.querySelectorAll('head [data-rt-seo]')
        for (var __i = 0; __i < __old.length; __i++) __old[__i].remove()
        var __tmp = doc.createElement('div')
        __tmp.innerHTML = data.head
        var __nodes = Array.prototype.slice.call(__tmp.children)
        for (var __j = 0; __j < __nodes.length; __j++) {
          var __el = __nodes[__j]
          if (__el.tagName === 'TITLE') { doc.title = __el.textContent; continue }
          __el.setAttribute('data-rt-seo', '')
          doc.head.appendChild(__el)
        }
      }

      // Scroll inside the swap so the view transition's "after" snapshot is already in place.
      if (fromPopstate) {
        var restore = function () {
          if (myNav !== navSeq) return
          if (!popScroll) { scrollToTarget(doc, win, finalPath); return }
          try { win.scrollTo(popScroll[0] || 0, popScroll[1] || 0) } catch (_) { /* */ }
        }
        if (typeof win.requestAnimationFrame === 'function') win.requestAnimationFrame(restore)
        else restore()
      } else if (opts.scroll !== false) {
        scrollToTarget(doc, win, finalPath)
      }
    }

    // ── View Transition wrap (PWA native feel) ────────────────────────────────
    // Cross-fade the page region via the View Transitions API when supported,
    // unless the user prefers reduced motion. Otherwise run the swap directly.
    var reducedMotion = false
    try {
      reducedMotion = !!(win && win.matchMedia && win.matchMedia('(prefers-reduced-motion: reduce)').matches)
    } catch (_) { /* */ }
    if (doc && typeof doc.startViewTransition === 'function' && !reducedMotion) {
      try {
        var vt = doc.startViewTransition(function () { return performSwap() })
        await vt.finished
      } catch (_) {
      }
    } else {
      await performSwap()
    }

    // Only the winning (latest) navigate updates history — a superseded one must
    // not push its URL after the newer one already swapped the DOM (would leave
    // URL=stale, DOM=fresh).
    if (myNav === navSeq && !fromPopstate && win && win.history && typeof win.history.pushState === 'function') {
      if (opts.replace) { try { rtHistoryWrite(win, 'replace', finalPath) } catch (_) { /* */ } } else {
        if (leaveScroll) saveScrollInEntry(win, leaveScroll)
        try { rtHistoryWrite(win, 'push', finalPath) } catch (_) { /* */ }
      }
    }
    // The new page is mounted and the URL is the target: tell the shell (active
    // nav item, progress bar) — `on('event:navigated', ({ path, search, from }) => …)`.
    if (myNav === navSeq) {
      var target = splitPath(finalPath, win)
      navCurrentPath = target.path + target.search
      navPathRef.value = navCurrentPath
      routeSync(win)
      var pageGlobalsEl = doc && doc.querySelector('script[type="island/globals"][data-island="' + newPageId + '"]')
      var pageGlobals = parseState(pageGlobalsEl ? pageGlobalsEl.textContent || '' : '')
      if (pageGlobals && typeof pageGlobals === 'object') liveGlobalsAdopt(pageGlobals, newPageId)
      try { busFire('event:navigated', { path: target.path, search: target.search, from: fromPath }) } catch (_) { /* */ }
      markCurrentLinks(doc, win, target.path)
      // Shell listeners re-render on the next tick; links they add are marked and observed there.
      setTimeout(function () {
        if (myNav !== navSeq) return
        markCurrentLinks(doc, win, target.path)
        viewportPrefetchArm(doc)
      }, 0)
      if (backHit) backRevalidate(path, data.html, myNav, doc)
    }
    // The freshly mounted page may expose new internal links (tab bars, menus)
    // — warm their document cache for offline launches.
    if (myNav === navSeq) scheduleOfflineWarmup()
  }

  // The cached popstate paint is followed by a fresh fetch; a changed html re-runs the swap unless a newer navigate won.
  function backRevalidate(path, html, myNav, doc) {
    fetchPagePayload(path).then(function (t) {
      if (myNav !== navSeq || t.kind !== 'ok' || t.finalPath || !t.data || typeof t.data.html !== 'string') return
      backCachePut(backCacheKey(path, window), t.data)
      if (t.data.html === html) return
      // The person is already typing into the restored page: a swap would drop the input.
      var ae = doc && doc.activeElement
      if (ae && /^(INPUT|TEXTAREA|SELECT)$/.test(ae.tagName) && !ae.closest('[data-island^="shell:"]')) return
      navigateRun(path, { fromPopstate: true, payload: t }, ++navSeq, doc, null)
    })
  }

  Runtime.assets = { acquire: acquireAssets, release: releaseAssets, list: listAssets, timeoutMs: ASSET_LOAD_TIMEOUT_MS }

  var warmedPaths = Object.create(null)
  var prewarmedDs = Object.create(null)
  var WARM_CAP_PER_SWEEP = 12

  var warmupStateRef = ref('idle')
  var warmupDoneRef = ref(0)
  var warmupTotalRef = ref(0)
  function warmEnqueue(n) {
    if (!n || n <= 0) return
    warmupTotalRef.value += n
    warmupStateRef.value = 'running'
  }
  function warmSettle() {
    warmupDoneRef.value += 1
    try { busFire('event:offline-warmup-progress', { done: warmupDoneRef.value, total: warmupTotalRef.value }) } catch (_) { /* */ }
    if (warmupDoneRef.value >= warmupTotalRef.value) {
      warmupStateRef.value = 'done'
      try { busFire('event:offline-warmup-done', { done: warmupDoneRef.value, total: warmupTotalRef.value }) } catch (_) { /* */ }
    }
  }
  Runtime.offlineWarmupProgress = function () {
    return { state: warmupStateRef.value, done: warmupDoneRef.value, total: warmupTotalRef.value }
  }

  function offlineWarmupSweep() {
    try {
      if (typeof document === 'undefined' || typeof navigator === 'undefined') return
      if (!navigator.serviceWorker || !navigator.serviceWorker.controller) return
      if (navigator.onLine === false) return
      if (navigator.connection && navigator.connection.saveData) return
      if (rtReadMeta('rt-auth-enabled') === 'true' && !rtReadMeta('rt-warm-routes') && !rtReadMeta('rt-prewarm-ds') && !rtReadMeta('rt-prewarm-comp')) return
      // Caching is an INSTALLED-app promise — browser tabs get no warmup (the
      // SW refuses cache writes for them anyway).
      if (!isInstalledDevice()) return
      var anchors = document.querySelectorAll('a[href]')
      var targets = []
      var herePath = window.location.pathname + window.location.search
      if (!warmedPaths[herePath]) { warmedPaths[herePath] = true; targets.push(herePath) }
      // Server-declared route paths next (rt-warm-routes) — they cover pages
      // linked only inside menus/overlays, which DOM scraping can't see.
      var metaRoutes = (rtReadMeta('rt-warm-routes') || '').split(',')
      for (var m = 0; m < metaRoutes.length && targets.length < WARM_CAP_PER_SWEEP; m++) {
        var mp = metaRoutes[m].trim()
        if (!mp || mp.charAt(0) !== '/') continue
        if (mp === window.location.pathname + window.location.search) continue
        if (warmedPaths[mp]) continue
        warmedPaths[mp] = true
        targets.push(mp)
      }
      for (var i = 0; i < anchors.length && targets.length < WARM_CAP_PER_SWEEP; i++) {
        var a = anchors[i]
        if (a.target === '_blank' || a.hasAttribute('download')) continue
        if (a.hasAttribute('data-rt-hard') || a.hasAttribute('data-rt-no-spa') || a.hasAttribute('data-rt-no-prefetch')) continue
        var rel = (a.getAttribute('rel') || '').toLowerCase()
        if (rel.split(/\s+/).indexOf('external') >= 0) continue
        var href = a.getAttribute('href')
        if (!href || href.charAt(0) === '#' || /^[a-z]+:/i.test(href)) continue
        var u
        try { u = new URL(href, window.location.href) } catch (_) { continue }
        if (u.origin !== window.location.origin) continue
        var p = u.pathname + u.search
        if (p === window.location.pathname + window.location.search) continue
        if (warmedPaths[p]) continue
        warmedPaths[p] = true
        targets.push(p)
      }
      warmEnqueue(targets.length)
      targets.forEach(function (p) {
        // Plain document GET — flows through the SW (networkFirst → stampAndPut).
        // On network failure, forget the path so a later sweep retries.
        fetch(p, { credentials: 'same-origin' }).then(
          function () { warmSettle() },
          function () { delete warmedPaths[p]; warmSettle() }
        )
      })
      // Prewarm SELECT DSs (empty input) + tenant components (empty props) so
      // reads and overlays replay offline even on pages the user never opened.
      // Sequential + freshness-skipped (10 min) to keep boot bursts cheap.
      prewarmReadsAndComponents()
    } catch (_) { /* */ }
  }

  var PREWARM_FRESH_MS = 10 * 60 * 1000
  var prewarming = false
  async function prewarmReadsAndComponents() {
    if (prewarming) return
    prewarming = true
    try {
      var dsUids = (rtReadMeta('rt-prewarm-ds') || '').split(',')
      for (var i = 0; i < dsUids.length; i++) {
        var entry = dsUids[i].trim()
        if (!entry) continue
        // Strip the '#d' dataset marker before parsing @ttl (the dataset delta
        // logic lives inside ReadCache.dsFetch, keyed off rt-dataset-ds).
        var hash = entry.indexOf('#')
        if (hash > 0) entry = entry.slice(0, hash)
        var at = entry.indexOf('@')
        var uid = at > 0 ? entry.slice(0, at) : entry
        var ttl = at > 0 ? (parseInt(entry.slice(at + 1), 10) || PREWARM_FRESH_MS) : PREWARM_FRESH_MS
        if (!uid || prewarmedDs['ds:' + uid]) continue
        prewarmedDs['ds:' + uid] = true
        try {
          var key = 'ds:' + uid + ':' + ReadCache.keyOf({})
          var hit = await ReadCache.get(key)
          if (hit && Date.now() - hit.ts < ttl) continue
          warmEnqueue(1)
          try { await ReadCache.dsFetch(uid, undefined) } finally { warmSettle() }
        } catch (_) { delete prewarmedDs['ds:' + uid] }
      }
      var comps = (rtReadMeta('rt-prewarm-comp') || '').split(',')
      for (var j = 0; j < comps.length; j++) {
        var name = comps[j].trim()
        if (!name || prewarmedDs['comp:' + name]) continue
        prewarmedDs['comp:' + name] = true
        try {
          var ckey = 'comp:' + name + ':' + ReadCache.keyOf({ props: {} })
          var chit = await ReadCache.get(ckey)
          if (chit && Date.now() - chit.ts < PREWARM_FRESH_MS) continue
          warmEnqueue(1)
          try { await fetchComponentPayload(name, { props: {} }, { silent401: true }) } finally { warmSettle() }
        } catch (_) { delete prewarmedDs['comp:' + name] }
      }
    } finally {
      prewarming = false
    }
  }

  function scheduleOfflineWarmup() {
    var run = function () { offlineWarmupSweep() }
    try {
      if (typeof requestIdleCallback === 'function') { requestIdleCallback(run, { timeout: 5000 }); return }
    } catch (_) { /* */ }
    setTimeout(run, 2500)
  }
  Runtime.warmOfflineCache = offlineWarmupSweep // immediate manual trigger (also used by tests)

  if (typeof document !== 'undefined' && typeof document.addEventListener === 'function') {
    document.addEventListener('click', function (e) {
      // Modifier keys / non-primary button → let the browser handle it.
      if (e.button !== undefined && e.button !== 0) return
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return
      var path = eligibleAnchorPath(e, false)
      if (!path) return
      e.preventDefault()
      Runtime.navigate(path)
    })

    // ── Prefetch warmers — passive, never block scrolling ────────────────────
    // A pointer or focus that merely crosses a link is not intent: the prefetch
    // fires only after it rests PREFETCH_INTENT_MS on the same anchor, and leaving
    // the anchor before that cancels it. A touch is intent already. A prefetch is a
    // full server render of the target, so the dwell is long enough to mean a decision.
    var PREFETCH_INTENT_MS = 200
    var intentTimer = null
    var intentAnchor = null
    var cancelIntent = function () {
      if (intentTimer) clearTimeout(intentTimer)
      intentTimer = null
      intentAnchor = null
    }
    var intentEnter = function (e) {
      var path = eligibleAnchorPath(e, true)
      if (!path) return
      var a = e.target.closest('a[href]')
      if (a === intentAnchor) return
      cancelIntent()
      intentAnchor = a
      intentTimer = setTimeout(function () {
        var live = intentAnchor && document.contains(intentAnchor)
        cancelIntent()
        if (live) Runtime.prefetch(path)
      }, PREFETCH_INTENT_MS)
    }
    var intentLeave = function (e) {
      if (!intentAnchor) return
      var a = e.target instanceof Element ? e.target.closest('a[href]') : null
      if (a !== intentAnchor) return
      var to = e.relatedTarget
      if (to instanceof Node && intentAnchor.contains(to)) return
      cancelIntent()
    }
    document.addEventListener('mouseover', intentEnter, { passive: true })
    document.addEventListener('mouseout', intentLeave, { passive: true })
    document.addEventListener('focusin', intentEnter, { passive: true })
    document.addEventListener('focusout', intentLeave, { passive: true })
    document.addEventListener('touchstart', function (e) {
      var path = eligibleAnchorPath(e, true)
      if (path) Runtime.prefetch(path)
    }, { passive: true })
    // A primary press is a click about to happen: prefetch at once, without the intent dwell.
    document.addEventListener('pointerdown', function (e) {
      if (e.button !== undefined && e.button !== 0) return
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return
      var path = eligibleAnchorPath(e, true)
      if (!path) return
      cancelIntent()
      Runtime.prefetch(path)
    }, { passive: true })

    // The runtime restores scroll itself (rtScroll in history.state); the scroll recorder keeps
    // the current entry's position so a forward/back return lands where the reader left.
    try { if (window.history && 'scrollRestoration' in window.history) window.history.scrollRestoration = 'manual' } catch (_) { /* */ }
    var scrollRecordTimer = null
    window.addEventListener('scroll', function () {
      if (scrollRecordTimer) clearTimeout(scrollRecordTimer)
      scrollRecordTimer = setTimeout(function () {
        scrollRecordTimer = null
        if (!navPendingRef.value) saveScrollInEntry(window, readScroll(window))
      }, 150)
    }, { passive: true })

    // ── popstate → navigate WITHOUT pushState (URL already changed) ──────────
    // A popstate that keeps path + search (a #hash link, back/forward between fragments) is no navigation,
    // unless a navigate is in flight: the new entry then supersedes it.
    window.addEventListener('popstate', function () {
      routeSync(window)
      var here = currentLocationPath(window)
      if (navPendingRef.value || here !== (navCurrentPath !== null ? navCurrentPath : bootLocationPath)) {
        Runtime.navigate(here, { fromPopstate: true })
        return
      }
      if (suppressPopstate) { suppressPopstate = false; return }
      var st = historyStateOf(window)
      if (st && typeof st.rtIndex === 'number') historyIndex = st.rtIndex
      if (st && Array.isArray(st.rtScroll)) { try { window.scrollTo(st.rtScroll[0] || 0, st.rtScroll[1] || 0) } catch (_) { /* */ } }
      else if (window.location.hash) scrollToTarget(document, window, window.location.hash)
      else { try { window.scrollTo(0, 0) } catch (_) { /* */ } }
    })
  }

  ;(function () {
    if (typeof document === 'undefined' || typeof window === 'undefined') return
    if (typeof document.addEventListener !== 'function') return
    var PTR_THRESHOLD = 70
    var startY = null
    var pulling = false
    var indicator = null

    function standalone() {
      try { return !!(window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) } catch (_) { return false }
    }
    function optedOut() {
      try { return !!(document.querySelector && document.querySelector('meta[name="rt-no-pull-refresh"]')) } catch (_) { return false }
    }
    function atTop() {
      var d = document.scrollingElement || document.documentElement
      return (d ? d.scrollTop : 0) <= 0
    }
    function showIndicator() {
      if (indicator) return
      indicator = document.createElement('div')
      indicator.id = 'rt-ptr'
      indicator.textContent = '↻'
      indicator.setAttribute('style',
        'position:fixed;top:10px;left:50%;transform:translateX(-50%);z-index:99999;' +
        'width:34px;height:34px;border-radius:50%;display:flex;align-items:center;justify-content:center;' +
        'background:rgba(255,255,255,.95);box-shadow:0 2px 8px rgba(0,0,0,.18);font-size:18px;color:#334155;')
      document.body.appendChild(indicator)
    }
    function hideIndicator(afterMs) {
      var el = indicator
      indicator = null
      if (!el) return
      setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el) }, afterMs || 0)
    }

    // A swipe inside an open overlay (a sheet with its own scroll) is the sheet's, never a pull to refresh.
    function insideOverlay(target) {
      var el = target && target.nodeType === 1 ? target : (target && target.parentElement)
      return !!(el && el.closest && el.closest('[data-overlay-instance]'))
    }
    document.addEventListener('touchstart', function (e) {
      if (!standalone() || optedOut() || !atTop() || insideOverlay(e.target)) { startY = null; return }
      var t = e.touches && e.touches[0]
      startY = t ? t.clientY : null
      pulling = false
    }, { passive: true })

    document.addEventListener('touchmove', function (e) {
      if (startY === null) return
      var t = e.touches && e.touches[0]
      if (!t) return
      if (t.clientY - startY >= PTR_THRESHOLD && atTop()) {
        pulling = true
        showIndicator()
      }
    }, { passive: true })

    document.addEventListener('touchend', function () {
      if (pulling) {
        pulling = false
        try { busFire('event:pull-refresh', {}) } catch (_) { /* */ }
        try { Runtime.warmOfflineCache() } catch (_) { /* */ }
        hideIndicator(800)
      } else {
        hideIndicator(0)
      }
      startY = null
    }, { passive: true })
  })()

  attachUiPrims(Runtime)
  if (typeof window !== 'undefined') window.Runtime = Runtime
  if (typeof globalThis !== 'undefined') globalThis.Runtime = Runtime

  // Boot: when auth is enabled, prime Runtime.auth.user before scripts run.
  // (jsdom evals after DOM build → readyState 'complete'; we still init auth so
  // tests that set rt-auth-enabled get a populated user. Guarded by meta.)
  if (typeof document !== 'undefined' && typeof document.addEventListener === 'function') {
    const rtBoot = function () {
      if (rtReadMeta('rt-auth-enabled') === 'true') {
        Promise.resolve(Runtime.auth.__init()).catch(function () { /* */ })
      }
      // PIN lock: start locked if a cfg exists. Runs BEFORE warmup so the shell
      // overlay shows immediately (warmup still proceeds underneath — UI gate).
      try { Runtime.lock.__init() } catch (_) { /* */ }
      // Not-installed devices keep no offline READ caches — drop any pre-gate
      // leftovers (DS envelopes / component payloads). The WRITE queue
      // (rt-offline-*) is data safety, not cache, and is never touched.
      if (!isInstalledDevice()) {
        try {
          var __ruid = rtReadMeta('rt-app-uid')
          if (__ruid && typeof indexedDB !== 'undefined' && indexedDB.deleteDatabase) {
            indexedDB.deleteDatabase('rt-readcache-' + __ruid)
          }
        } catch (_) { /* */ }
      }
      // Warm the document cache of this page's internal links (offline launches).
      scheduleOfflineWarmup()
    }
    if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
      window.addEventListener('online', function () { scheduleOfflineWarmup() })
    }
    // SW → bus bridge: stale-while-revalidate refreshes surface as a bus event
    // so operators can on('event:page-revalidated', …) to offer a reload.
    try {
      if (typeof navigator !== 'undefined' && navigator.serviceWorker && typeof navigator.serviceWorker.addEventListener === 'function') {
        navigator.serviceWorker.addEventListener('message', function (ev) {
          var d = ev && ev.data
          if (d && d.type === 'rt-page-revalidated') busFire('event:page-revalidated', { url: d.url })
          if (d && d.type === 'rt-offline-event') busFire('event:' + d.name, d.payload) // SW sends BARE names; bridge adds the prefix
        })
        // Update pill: a new SW took control mid-session; the first controller of a fresh install is not an update.
        var __hadController = !!navigator.serviceWorker.controller
        var __updateFired = false
        navigator.serviceWorker.addEventListener('controllerchange', function () {
          if (!__hadController) { __hadController = true; return }
          if (__updateFired) return
          __updateFired = true
          if (typeof __markUpdateReady === 'function') __markUpdateReady()
          busFire('event:app-update-ready', {})
        })
        // The SW only knows the SHORT app uid ({{APP_UID}}); the offline IDB
        // name uses the FULL uid. Hand it over so SW Background Sync replay can
        // open the right database without scanning indexedDB.databases().
        navigator.serviceWorker.ready.then(function (reg) {
          try {
            var uid = rtReadMeta('rt-app-uid')
            if (uid && reg.active) reg.active.postMessage({ type: 'rt-set-app-uid', uid: uid })
            // Installed-device signal — ALWAYS sent, both values. TRUE persists
            // the SW flag (sticky); FALSE triggers the SW's cache wipe for
            // never-installed tabs (the SW ignores false once true persisted).
            if (reg.active) {
              reg.active.postMessage({ type: 'rt-set-installed', installed: isInstalledDevice() })
            }
            // Periodic Background Sync: hand the SW the offline warm config so it
            // can re-warm caches with the tab closed (rt-rewarm tag). The config
            // mirrors what offlineWarmupSweep / prewarmReadsAndComponents read.
            if (uid && reg.active) {
              var splitMeta = function (name) {
                return (rtReadMeta(name) || '').split(',').map(function (s) { return s.trim() }).filter(Boolean)
              }
              var cfg = {
                fullAppUid: uid,
                warmRoutes: splitMeta('rt-warm-routes'),
                prewarmDs: splitMeta('rt-prewarm-ds'),   // raw entries incl. @ttl / #d markers
                prewarmComp: splitMeta('rt-prewarm-comp'),
                cachedReads: splitMeta('rt-cached-reads'),
              }
              reg.active.postMessage({ type: 'rt-set-offline-config', cfg: cfg })
            }
            // Register the periodic sync tag (Chrome/Android installed PWAs only;
            // the API may be absent or permission denied — silently best-effort).
            try {
              if (isInstalledDevice() && reg.periodicSync && typeof reg.periodicSync.register === 'function') {
                reg.periodicSync.register('rt-rewarm', { minInterval: 12 * 3600 * 1000 }).catch(function () { /* */ })
              }
            } catch (_) { /* */ }
          } catch (_) { /* */ }
        }).catch(function () { /* */ })
      }
    } catch (_) { /* */ }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', rtBoot)
    else rtBoot()
  }

  // ════════════════════════════════════════════════════════════════════
  //  Public surface
  // ════════════════════════════════════════════════════════════════════
  const Island = {
    // reactivity
    reactive, ref, computed, watch, watchEffect, nextTick,
    isRef, unref, isReactive, toRaw, markRaw, proxyRefs,
    // expression eval
    evaluate, runStmt,
    // Layer 2 — marker-based hydration (DOM adoption)
    hydrateRoot, buildFromTpl,
    // Layer 3 — scope discovery + setup + mount
    runSetup,
    mountIsland,
    start,
    scopes: {},
    onError: function (id, err) { console.error('[island]', id, err); rtObs.report('island', err, { source: 'island:' + id }) },
    // configurable stubs (override before calling start)
    ds: null,          // set Island.ds = async (uid, input) => {...} before start()
    useAsyncData: null,
    useFetch: null,
    // Framework-global composable overrides (set before calling start())
    useAppConfig: null, // () => app — defaults to reading the seeded scope.app
    useRoute: null,     // () => route — defaults to reading seeded scope.route or {params,query}
    // Overlay component spawner (open/close/closeSelf — replaces fragment())
    open: open,
    close: close,
    closeAllOverlays: closeAllOverlays,
    // Server-function RPC stub factory (<script server> exports → /runtime/fn/:appUid)
    serverFn: serverFn,
    componentBaseUrl: componentBaseUrl,
    // Cross-scope event bus (real on/emit, ported from the old runtime).
    // Island.emit(event, payload) is the global form (was Runtime.emit) — fans a
    // fire out to every on('event:NAME') subscriber across all scopes.
    emit: function (event, payload) { busFire(event, payload) },
    makeOn,
    makeEmit,
    addDisposer,
    disposeScope,
    // Layer 4 — dehydrated state helpers
    parseState,
    makeUseAsyncData,
    makeScopedDs,
    // low-level (exposed for tests / advanced use)
    ReactiveEffect, track, trigger,
    version: '0.5.0',
  }

  rtObs.wire(Runtime)

  if (typeof globalThis !== 'undefined' && globalThis.__ISLAND_TEST__) {
    Island.__test = { setPath, runStmt, evaluate }
  }

  if (typeof window !== 'undefined') window.Island = Island
  if (typeof globalThis !== 'undefined') globalThis.Island = Island
})()
